{
  "0111301": {
    "description": "Cultivo de arroz",
    "class_description": "Cultivo de cereais"
  },
  "0111302": {
    "description": "Cultivo de milho",
    "class_description": "Cultivo de cereais"
  },
  "0111303": {
    "description": "Cultivo de trigo",
    "class_description": "Cultivo de cereais"
  },
  "0111399": {
    "description": "Cultivo de outros cereais não especificados anteriormente",
    "class_description": "Cultivo de cereais"
  },
  "0112101": {
    "description": "Cultivo de algodão herbáceo",
    "class_description": "Cultivo de algodão herbáceo e de outras fibras de lavoura temporária"
  },
  "0112102": {
    "description": "Cultivo de juta",
    "class_description": "Cultivo de algodão herbáceo e de outras fibras de lavoura temporária"
  },
  "0112199": {
    "description": "Cultivo de outras fibras de lavoura temporária não especificadas anteriormente",
    "class_description": "Cultivo de algodão herbáceo e de outras fibras de lavoura temporária"
  },
  "0113000": {
    "description": "Cultivo de cana-de-açúcar",
    "class_description": "Cultivo de cana-de-açúcar"
  },
  "0114800": {
    "description": "Cultivo de fumo",
    "class_description": "Cultivo de fumo"
  },
  "0115600": {
    "description": "Cultivo de soja",
    "class_description": "Cultivo de soja"
  },
  "0116401": {
    "description": "Cultivo de amendoim",
    "class_description": "Cultivo de oleaginosas de lavoura temporária, exceto soja"
  },
  "0116402": {
    "description": "Cultivo de girassol",
    "class_description": "Cultivo de oleaginosas de lavoura temporária, exceto soja"
  },
  "0116403": {
    "description": "Cultivo de mamona",
    "class_description": "Cultivo de oleaginosas de lavoura temporária, exceto soja"
  },
  "0116499": {
    "description": "Cultivo de outras oleaginosas de lavoura temporária não especificadas anteriormente",
    "class_description": "Cultivo de oleaginosas de lavoura temporária, exceto soja"
  },
  "0119901": {
    "description": "Cultivo de abacaxi",
    "class_description": "Cultivo de plantas de lavoura temporária não especificadas anteriormente"
  },
  "0119902": {
    "description": "Cultivo de alho",
    "class_description": "Cultivo de plantas de lavoura temporária não especificadas anteriormente"
  },
  "0119903": {
    "description": "Cultivo de batata-inglesa",
    "class_description": "Cultivo de plantas de lavoura temporária não especificadas anteriormente"
  },
  "0119904": {
    "description": "Cultivo de cebola",
    "class_description": "Cultivo de plantas de lavoura temporária não especificadas anteriormente"
  },
  "0119905": {
    "description": "Cultivo de feijão",
    "class_description": "Cultivo de plantas de lavoura temporária não especificadas anteriormente"
  },
  "0119906": {
    "description": "Cultivo de mandioca",
    "class_description": "Cultivo de plantas de lavoura temporária não especificadas anteriormente"
  },
  "0119907": {
    "description": "Cultivo de melão",
    "class_description": "Cultivo de plantas de lavoura temporária não especificadas anteriormente"
  },
  "0119908": {
    "description": "Cultivo de melancia",
    "class_description": "Cultivo de plantas de lavoura temporária não especificadas anteriormente"
  },
  "0119909": {
    "description": "Cultivo de tomate rasteiro",
    "class_description": "Cultivo de plantas de lavoura temporária não especificadas anteriormente"
  },
  "0119999": {
    "description": "Cultivo de outras plantas de lavoura temporária não especificadas anteriormente",
    "class_description": "Cultivo de plantas de lavoura temporária não especificadas anteriormente"
  },
  "0121101": {
    "description": "Horticultura, exceto morango",
    "class_description": "Horticultura"
  },
  "0121102": {
    "description": "Cultivo de morango",
    "class_description": "Horticultura"
  },
  "0122900": {
    "description": "Cultivo de flores e plantas ornamentais",
    "class_description": "Cultivo de flores e plantas ornamentais"
  },
  "0131800": {
    "description": "Cultivo de laranja",
    "class_description": "Cultivo de laranja"
  },
  "0132600": {
    "description": "Cultivo de uva",
    "class_description": "Cultivo de uva"
  },
  "0133401": {
    "description": "Cultivo de açaí",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0133402": {
    "description": "Cultivo de banana",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0133403": {
    "description": "Cultivo de caju",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0133404": {
    "description": "Cultivo de cítricos, exceto laranja",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0133405": {
    "description": "Cultivo de coco-da-baía",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0133406": {
    "description": "Cultivo de guaraná",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0133407": {
    "description": "Cultivo de maçã",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0133408": {
    "description": "Cultivo de mamão",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0133409": {
    "description": "Cultivo de maracujá",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0133410": {
    "description": "Cultivo de manga",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0133411": {
    "description": "Cultivo de pêssego",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0133499": {
    "description": "Cultivo de frutas de lavoura permanente não especificadas anteriormente",
    "class_description": "Cultivo de frutas de lavoura permanente, exceto laranja e uva"
  },
  "0134200": {
    "description": "Cultivo de café",
    "class_description": "Cultivo de café"
  },
  "0135100": {
    "description": "Cultivo de cacau",
    "class_description": "Cultivo de cacau"
  },
  "0139301": {
    "description": "Cultivo de chá-da-índia",
    "class_description": "Cultivo de plantas de lavoura permanente não especificadas anteriormente"
  },
  "0139302": {
    "description": "Cultivo de erva-mate",
    "class_description": "Cultivo de plantas de lavoura permanente não especificadas anteriormente"
  },
  "0139303": {
    "description": "Cultivo de pimenta-do-reino",
    "class_description": "Cultivo de plantas de lavoura permanente não especificadas anteriormente"
  },
  "0139304": {
    "description": "Cultivo de plantas para condimento, exceto pimenta-do-reino",
    "class_description": "Cultivo de plantas de lavoura permanente não especificadas anteriormente"
  },
  "0139305": {
    "description": "Cultivo de dendê",
    "class_description": "Cultivo de plantas de lavoura permanente não especificadas anteriormente"
  },
  "0139306": {
    "description": "Cultivo de seringueira",
    "class_description": "Cultivo de plantas de lavoura permanente não especificadas anteriormente"
  },
  "0139399": {
    "description": "Cultivo de outras plantas de lavoura permanente não especificadas anteriormente",
    "class_description": "Cultivo de plantas de lavoura permanente não especificadas anteriormente"
  },
  "0141501": {
    "description": "Produção de sementes certificadas, exceto de forrageiras para pasto",
    "class_description": "Produção de sementes certificadas"
  },
  "0141502": {
    "description": "Produção de sementes certificadas de forrageiras para formação de pasto",
    "class_description": "Produção de sementes certificadas"
  },
  "0142300": {
    "description": "Produção de mudas e outras formas de propagação vegetal, certificadas",
    "class_description": "Produção de mudas e outras formas de propagação vegetal, certificadas"
  },
  "0151201": {
    "description": "Criação de bovinos para corte",
    "class_description": "Criação de bovinos"
  },
  "0151202": {
    "description": "Criação de bovinos para leite",
    "class_description": "Criação de bovinos"
  },
  "0151203": {
    "description": "Criação de bovinos, exceto para corte e leite",
    "class_description": "Criação de bovinos"
  },
  "0152101": {
    "description": "Criação de bufalinos",
    "class_description": "Criação de outros animais de grande porte"
  },
  "0152102": {
    "description": "Criação de equinos",
    "class_description": "Criação de outros animais de grande porte"
  },
  "0152103": {
    "description": "Criação de asininos e muares",
    "class_description": "Criação de outros animais de grande porte"
  },
  "0153901": {
    "description": "Criação de caprinos",
    "class_description": "Criação de caprinos e ovinos"
  },
  "0153902": {
    "description": "Criação de ovinos, inclusive para produção de lã",
    "class_description": "Criação de caprinos e ovinos"
  },
  "0154700": {
    "description": "Criação de suínos",
    "class_description": "Criação de suínos"
  },
  "0155501": {
    "description": "Criação de frangos para corte",
    "class_description": "Criação de aves"
  },
  "0155502": {
    "description": "Produção de pintos de um dia",
    "class_description": "Criação de aves"
  },
  "0155503": {
    "description": "Criação de outros galináceos, exceto para corte",
    "class_description": "Criação de aves"
  },
  "0155504": {
    "description": "Criação de aves, exceto galináceos",
    "class_description": "Criação de aves"
  },
  "0155505": {
    "description": "Produção de ovos",
    "class_description": "Criação de aves"
  },
  "0159801": {
    "description": "Apicultura",
    "class_description": "Criação de animais não especificados anteriormente"
  },
  "0159802": {
    "description": "Criação de animais de estimação",
    "class_description": "Criação de animais não especificados anteriormente"
  },
  "0159803": {
    "description": "Criação de escargô",
    "class_description": "Criação de animais não especificados anteriormente"
  },
  "0159804": {
    "description": "Criação de bicho-da-seda",
    "class_description": "Criação de animais não especificados anteriormente"
  },
  "0159899": {
    "description": "Criação de outros animais não especificados anteriormente",
    "class_description": "Criação de animais não especificados anteriormente"
  },
  "0161001": {
    "description": "Serviço de pulverização e controle de pragas agrícolas",
    "class_description": "Atividades de apoio à agricultura"
  },
  "0161002": {
    "description": "Serviço de poda de árvores para lavouras",
    "class_description": "Atividades de apoio à agricultura"
  },
  "0161003": {
    "description": "Serviço de preparação de terreno, cultivo e colheita",
    "class_description": "Atividades de apoio à agricultura"
  },
  "0161099": {
    "description": "Atividades de apoio à agricultura não especificadas anteriormente",
    "class_description": "Atividades de apoio à agricultura"
  },
  "0162801": {
    "description": "Serviço de inseminação artificial em animais",
    "class_description": "Atividades de apoio à pecuária"
  },
  "0162802": {
    "description": "Serviço de tosquiamento de ovinos",
    "class_description": "Atividades de apoio à pecuária"
  },
  "0162803": {
    "description": "Serviço de manejo de animais",
    "class_description": "Atividades de apoio à pecuária"
  },
  "0162899": {
    "description": "Atividades de apoio à pecuária não especificadas anteriormente",
    "class_description": "Atividades de apoio à pecuária"
  },
  "0163600": {
    "description": "Atividades de pós-colheita",
    "class_description": "Atividades de pós-colheita"
  },
  "0170900": {
    "description": "Caça e serviços relacionados",
    "class_description": "Caça e serviços relacionados"
  },
  "0210101": {
    "description": "Cultivo de eucalipto",
    "class_description": "Produção florestal - florestas plantadas"
  },
  "0210102": {
    "description": "Cultivo de acácia-negra",
    "class_description": "Produção florestal - florestas plantadas"
  },
  "0210103": {
    "description": "Cultivo de pinus",
    "class_description": "Produção florestal - florestas plantadas"
  },
  "0210104": {
    "description": "Cultivo de teca",
    "class_description": "Produção florestal - florestas plantadas"
  },
  "0210105": {
    "description": "Cultivo de espécies madeireiras, exceto eucalipto, acácia-negra, pinus e teca",
    "class_description": "Produção florestal - florestas plantadas"
  },
  "0210106": {
    "description": "Cultivo de mudas em viveiros florestais",
    "class_description": "Produção florestal - florestas plantadas"
  },
  "0210107": {
    "description": "Extração de madeira em florestas plantadas",
    "class_description": "Produção florestal - florestas plantadas"
  },
  "0210108": {
    "description": "Produção de carvão vegetal - florestas plantadas",
    "class_description": "Produção florestal - florestas plantadas"
  },
  "0210109": {
    "description": "Produção de casca de acácia-negra - florestas plantadas",
    "class_description": "Produção florestal - florestas plantadas"
  },
  "0210199": {
    "description": "Produção de produtos não madeireiros não especificados anteriormente em florestas plantadas",
    "class_description": "Produção florestal - florestas plantadas"
  },
  "0220901": {
    "description": "Extração de madeira em florestas nativas",
    "class_description": "Produção florestal - florestas nativas"
  },
  "0220902": {
    "description": "Produção de carvão vegetal - florestas nativas",
    "class_description": "Produção florestal - florestas nativas"
  },
  "0220903": {
    "description": "Coleta de castanha-do-pará em florestas nativas",
    "class_description": "Produção florestal - florestas nativas"
  },
  "0220904": {
    "description": "Coleta de látex em florestas nativas",
    "class_description": "Produção florestal - florestas nativas"
  },
  "0220905": {
    "description": "Coleta de palmito em florestas nativas",
    "class_description": "Produção florestal - florestas nativas"
  },
  "0220906": {
    "description": "Conservação de florestas nativas",
    "class_description": "Produção florestal - florestas nativas"
  },
  "0220999": {
    "description": "Coleta de produtos não madeireiros não especificados anteriormente em florestas nativas",
    "class_description": "Produção florestal - florestas nativas"
  },
  "0230600": {
    "description": "Atividades de apoio à produção florestal",
    "class_description": "Atividades de apoio à produção florestal"
  },
  "0311601": {
    "description": "Pesca de peixes em água salgada",
    "class_description": "Pesca em água salgada"
  },
  "0311602": {
    "description": "Pesca de crustáceos e moluscos em água salgada",
    "class_description": "Pesca em água salgada"
  },
  "0311603": {
    "description": "Coleta de outros produtos marinhos",
    "class_description": "Pesca em água salgada"
  },
  "0311604": {
    "description": "Atividades de apoio à pesca em água salgada",
    "class_description": "Pesca em água salgada"
  },
  "0312401": {
    "description": "Pesca de peixes em água doce",
    "class_description": "Pesca em água doce"
  },
  "0312402": {
    "description": "Pesca de crustáceos e moluscos em água doce",
    "class_description": "Pesca em água doce"
  },
  "0312403": {
    "description": "Coleta de outros produtos aquáticos de água doce",
    "class_description": "Pesca em água doce"
  },
  "0312404": {
    "description": "Atividades de apoio à pesca em água doce",
    "class_description": "Pesca em água doce"
  },
  "0321301": {
    "description": "Criação de peixes em água salgada e salobra",
    "class_description": "Aquicultura em água salgada e salobra"
  },
  "0321302": {
    "description": "Criação de camarões em água salgada e salobra",
    "class_description": "Aquicultura em água salgada e salobra"
  },
  "0321303": {
    "description": "Criação de ostras e mexilhões em água salgada e salobra",
    "class_description": "Aquicultura em água salgada e salobra"
  },
  "0321304": {
    "description": "Criação de peixes ornamentais em água salgada e salobra",
    "class_description": "Aquicultura em água salgada e salobra"
  },
  "0321305": {
    "description": "Atividades de apoio à aquicultura em água salgada e salobra",
    "class_description": "Aquicultura em água salgada e salobra"
  },
  "0321399": {
    "description": "Cultivos e semicultivos da aquicultura em água salgada e salobra não especificados anteriormente",
    "class_description": "Aquicultura em água salgada e salobra"
  },
  "0322101": {
    "description": "Criação de peixes em água doce",
    "class_description": "Aquicultura em água doce"
  },
  "0322102": {
    "description": "Criação de camarões em água doce",
    "class_description": "Aquicultura em água doce"
  },
  "0322103": {
    "description": "Criação de ostras e mexilhões em água doce",
    "class_description": "Aquicultura em água doce"
  },
  "0322104": {
    "description": "Criação de peixes ornamentais em água doce",
    "class_description": "Aquicultura em água doce"
  },
  "0322105": {
    "description": "Ranicultura",
    "class_description": "Aquicultura em água doce"
  },
  "0322106": {
    "description": "Criação de jacaré",
    "class_description": "Aquicultura em água doce"
  },
  "0322107": {
    "description": "Atividades de apoio à aquicultura em água doce",
    "class_description": "Aquicultura em água doce"
  },
  "0322199": {
    "description": "Cultivos e semicultivos da aquicultura em água doce não especificados anteriormente",
    "class_description": "Aquicultura em água doce"
  },
  "0500301": {
    "description": "Extração de carvão mineral",
    "class_description": "Extração de carvão mineral"
  },
  "0500302": {
    "description": "Beneficiamento de carvão mineral",
    "class_description": "Extração de carvão mineral"
  },
  "0600001": {
    "description": "Extração de petróleo e gás natural",
    "class_description": "Extração de petróleo e gás natural"
  },
  "0600002": {
    "description": "Extração e beneficiamento de xisto",
    "class_description": "Extração de petróleo e gás natural"
  },
  "0600003": {
    "description": "Extração e beneficiamento de areias betuminosas",
    "class_description": "Extração de petróleo e gás natural"
  },
  "0710301": {
    "description": "Extração de minério de ferro",
    "class_description": "Extração de minério de ferro"
  },
  "0710302": {
    "description": "Pelotização, sinterização e outros beneficiamentos de minério de ferro",
    "class_description": "Extração de minério de ferro"
  },
  "0721901": {
    "description": "Extração de minério de alumínio",
    "class_description": "Extração de minério de alumínio"
  },
  "0721902": {
    "description": "Beneficiamento de minério de alumínio",
    "class_description": "Extração de minério de alumínio"
  },
  "0722701": {
    "description": "Extração de minério de estanho",
    "class_description": "Extração de minério de estanho"
  },
  "0722702": {
    "description": "Beneficiamento de minério de estanho",
    "class_description": "Extração de minério de estanho"
  },
  "0723501": {
    "description": "Extração de minério de manganês",
    "class_description": "Extração de minério de manganês"
  },
  "0723502": {
    "description": "Beneficiamento de minério de manganês",
    "class_description": "Extração de minério de manganês"
  },
  "0724301": {
    "description": "Extração de minério de metais preciosos",
    "class_description": "Extração de minério de metais preciosos"
  },
  "0724302": {
    "description": "Beneficiamento de minério de metais preciosos",
    "class_description": "Extração de minério de metais preciosos"
  },
  "0725100": {
    "description": "Extração de minerais radioativos",
    "class_description": "Extração de minerais radioativos"
  },
  "0729401": {
    "description": "Extração de minérios de nióbio e titânio",
    "class_description": "Extração de minerais metálicos não ferrosos não especificados anteriormente"
  },
  "0729402": {
    "description": "Extração de minério de tungstênio",
    "class_description": "Extração de minerais metálicos não ferrosos não especificados anteriormente"
  },
  "0729403": {
    "description": "Extração de minério de níquel",
    "class_description": "Extração de minerais metálicos não ferrosos não especificados anteriormente"
  },
  "0729404": {
    "description": "Extração de minérios de cobre, chumbo, zinco e outros minerais metálicos não ferrosos não especificados anteriormente",
    "class_description": "Extração de minerais metálicos não ferrosos não especificados anteriormente"
  },
  "0729405": {
    "description": "Beneficiamento de minérios de cobre, chumbo, zinco e outros minerais metálicos não ferrosos não especificados anteriormente",
    "class_description": "Extração de minerais metálicos não ferrosos não especificados anteriormente"
  },
  "0810001": {
    "description": "Extração de ardósia e beneficiamento associado",
    "class_description": "Extração de pedra, areia e argila"
  },
  "0810002": {
    "description": "Extração de granito e beneficiamento associado",
    "class_description": "Extração de pedra, areia e argila"
  },
  "0810003": {
    "description": "Extração de mármore e beneficiamento associado",
    "class_description": "Extração de pedra, areia e argila"
  },
  "0810004": {
    "description": "Extração de calcário e dolomita e beneficiamento associado",
    "class_description": "Extração de pedra, areia e argila"
  },
  "0810005": {
    "description": "Extração de gesso e caulim",
    "class_description": "Extração de pedra, areia e argila"
  },
  "0810006": {
    "description": "Extração de areia, cascalho ou pedregulho e beneficiamento associado",
    "class_description": "Extração de pedra, areia e argila"
  },
  "0810007": {
    "description": "Extração de argila e beneficiamento associado",
    "class_description": "Extração de pedra, areia e argila"
  },
  "0810008": {
    "description": "Extração de saibro e beneficiamento associado",
    "class_description": "Extração de pedra, areia e argila"
  },
  "0810009": {
    "description": "Extração de basalto e beneficiamento associado",
    "class_description": "Extração de pedra, areia e argila"
  },
  "0810010": {
    "description": "Beneficiamento de gesso e caulim associado à extração",
    "class_description": "Extração de pedra, areia e argila"
  },
  "0810099": {
    "description": "Extração e britamento de pedras e outros materiais para construção e beneficiamento associado",
    "class_description": "Extração de pedra, areia e argila"
  },
  "0891600": {
    "description": "Extração de minerais para fabricação de adubos, fertilizantes e outros produtos químicos",
    "class_description": "Extração de minerais para fabricação de adubos, fertilizantes e outros produtos químicos"
  },
  "0892401": {
    "description": "Extração de sal marinho",
    "class_description": "Extração e refino de sal marinho e sal-gema"
  },
  "0892402": {
    "description": "Extração de sal-gema",
    "class_description": "Extração e refino de sal marinho e sal-gema"
  },
  "0892403": {
    "description": "Refino e outros tratamentos do sal",
    "class_description": "Extração e refino de sal marinho e sal-gema"
  },
  "0893200": {
    "description": "Extração de gemas (pedras preciosas e semipreciosas)",
    "class_description": "Extração de gemas (pedras preciosas e semipreciosas)"
  },
  "0899101": {
    "description": "Extração de grafita",
    "class_description": "Extração de minerais não metálicos não especificados anteriormente"
  },
  "0899102": {
    "description": "Extração de quartzo",
    "class_description": "Extração de minerais não metálicos não especificados anteriormente"
  },
  "0899103": {
    "description": "Extração de amianto",
    "class_description": "Extração de minerais não metálicos não especificados anteriormente"
  },
  "0899199": {
    "description": "Extração de outros minerais não metálicos não especificados anteriormente",
    "class_description": "Extração de minerais não metálicos não especificados anteriormente"
  },
  "0910600": {
    "description": "Atividades de apoio à extração de petróleo e gás natural",
    "class_description": "Atividades de apoio à extração de petróleo e gás natural"
  },
  "0990401": {
    "description": "Atividades de apoio à extração de minério de ferro",
    "class_description": "Atividades de apoio à extração de minerais, exceto petróleo e gás natural"
  },
  "0990402": {
    "description": "Atividades de apoio à extração de minerais metálicos não ferrosos",
    "class_description": "Atividades de apoio à extração de minerais, exceto petróleo e gás natural"
  },
  "0990403": {
    "description": "Atividades de apoio à extração de minerais não metálicos",
    "class_description": "Atividades de apoio à extração de minerais, exceto petróleo e gás natural"
  },
  "1011201": {
    "description": "Frigorífico - abate de bovinos",
    "class_description": "Abate de reses, exceto suínos"
  },
  "1011202": {
    "description": "Frigorífico - abate de equinos",
    "class_description": "Abate de reses, exceto suínos"
  },
  "1011203": {
    "description": "Frigorífico - abate de ovinos e caprinos",
    "class_description": "Abate de reses, exceto suínos"
  },
  "1011204": {
    "description": "Frigorífico - abate de bufalinos",
    "class_description": "Abate de reses, exceto suínos"
  },
  "1011205": {
    "description": "Matadouro - abate de reses sob contrato, exceto abate de suínos",
    "class_description": "Abate de reses, exceto suínos"
  },
  "1012101": {
    "description": "Abate de aves",
    "class_description": "Abate de suínos, aves e outros pequenos animais"
  },
  "1012102": {
    "description": "Abate de pequenos animais",
    "class_description": "Abate de suínos, aves e outros pequenos animais"
  },
  "1012103": {
    "description": "Frigorífico - abate de suínos",
    "class_description": "Abate de suínos, aves e outros pequenos animais"
  },
  "1012104": {
    "description": "Matadouro - abate de suínos sob contrato",
    "class_description": "Abate de suínos, aves e outros pequenos animais"
  },
  "1013901": {
    "description": "Fabricação de produtos de carne",
    "class_description": "Fabricação de produtos de carne"
  },
  "1013902": {
    "description": "Preparação de subprodutos do abate",
    "class_description": "Fabricação de produtos de carne"
  },
  "1020101": {
    "description": "Preservação de peixes, crustáceos e moluscos",
    "class_description": "Preservação do pescado e fabricação de produtos do pescado"
  },
  "1020102": {
    "description": "Fabricação de conservas de peixes, crustáceos e moluscos",
    "class_description": "Preservação do pescado e fabricação de produtos do pescado"
  },
  "1031700": {
    "description": "Fabricação de conservas de frutas",
    "class_description": "Fabricação de conservas de frutas"
  },
  "1032501": {
    "description": "Fabricação de conservas de palmito",
    "class_description": "Fabricação de conservas de legumes e outros vegetais"
  },
  "1032599": {
    "description": "Fabricação de conservas de legumes e outros vegetais, exceto palmito",
    "class_description": "Fabricação de conservas de legumes e outros vegetais"
  },
  "1033301": {
    "description": "Fabricação de sucos concentrados de frutas, hortaliças e legumes",
    "class_description": "Fabricação de sucos de frutas, hortaliças e legumes"
  },
  "1033302": {
    "description": "Fabricação de sucos de frutas, hortaliças e legumes, exceto concentrados",
    "class_description": "Fabricação de sucos de frutas, hortaliças e legumes"
  },
  "1041400": {
    "description": "Fabricação de óleos vegetais em bruto, exceto óleo de milho",
    "class_description": "Fabricação de óleos vegetais em bruto, exceto óleo de milho"
  },
  "1042200": {
    "description": "Fabricação de óleos vegetais refinados, exceto óleo de milho",
    "class_description": "Fabricação de óleos vegetais refinados, exceto óleo de milho"
  },
  "1043100": {
    "description": "Fabricação de margarina e outras gorduras vegetais e de óleos não comestíveis de animais",
    "class_description": "Fabricação de margarina e outras gorduras vegetais e de óleos não comestíveis de animais"
  },
  "1051100": {
    "description": "Preparação do leite",
    "class_description": "Preparação do leite"
  },
  "1052000": {
    "description": "Fabricação de laticínios",
    "class_description": "Fabricação de laticínios"
  },
  "1053800": {
    "description": "Fabricação de sorvetes e outros gelados comestíveis",
    "class_description": "Fabricação de sorvetes e outros gelados comestíveis"
  },
  "1061901": {
    "description": "Beneficiamento de arroz",
    "class_description": "Beneficiamento de arroz e fabricação de produtos do arroz"
  },
  "1061902": {
    "description": "Fabricação de produtos do arroz",
    "class_description": "Beneficiamento de arroz e fabricação de produtos do arroz"
  },
  "1062700": {
    "description": "Moagem de trigo e fabricação de derivados",
    "class_description": "Moagem de trigo e fabricação de derivados"
  },
  "1063500": {
    "description": "Fabricação de farinha de mandioca e derivados",
    "class_description": "Fabricação de farinha de mandioca e derivados"
  },
  "1064300": {
    "description": "Fabricação de farinha de milho e derivados, exceto óleos de milho",
    "class_description": "Fabricação de farinha de milho e derivados, exceto óleos de milho"
  },
  "1065101": {
    "description": "Fabricação de amidos e féculas de vegetais",
    "class_description": "Fabricação de amidos e féculas de vegetais e de óleos de milho"
  },
  "1065102": {
    "description": "Fabricação de óleo de milho em bruto",
    "class_description": "Fabricação de amidos e féculas de vegetais e de óleos de milho"
  },
  "1065103": {
    "description": "Fabricação de óleo de milho refinado",
    "class_description": "Fabricação de amidos e féculas de vegetais e de óleos de milho"
  },
  "1066000": {
    "description": "Fabricação de alimentos para animais",
    "class_description": "Fabricação de alimentos para animais"
  },
  "1069400": {
    "description": "Moagem e fabricação de produtos de origem vegetal não especificados anteriormente",
    "class_description": "Moagem e fabricação de produtos de origem vegetal não especificados anteriormente"
  },
  "1071600": {
    "description": "Fabricação de açúcar em bruto",
    "class_description": "Fabricação de açúcar em bruto"
  },
  "1072401": {
    "description": "Fabricação de açúcar de cana refinado",
    "class_description": "Fabricação de açúcar refinado"
  },
  "1072402": {
    "description": "Fabricação de açúcar de cereais (dextrose) e de beterraba",
    "class_description": "Fabricação de açúcar refinado"
  },
  "1081301": {
    "description": "Beneficiamento de café",
    "class_description": "Torrefação e moagem de café"
  },
  "1081302": {
    "description": "Torrefação e moagem de café",
    "class_description": "Torrefação e moagem de café"
  },
  "1082100": {
    "description": "Fabricação de produtos à base de café",
    "class_description": "Fabricação de produtos à base de café"
  },
  "1091101": {
    "description": "Fabricação de produtos de panificação industrial",
    "class_description": "Fabricação de produtos de panificação"
  },
  "1091102": {
    "description": "Fabricação de produtos de padaria e confeitaria com predominância de produção própria",
    "class_description": "Fabricação de produtos de panificação"
  },
  "1092900": {
    "description": "Fabricação de biscoitos e bolachas",
    "class_description": "Fabricação de biscoitos e bolachas"
  },
  "1093701": {
    "description": "Fabricação de produtos derivados do cacau e de chocolates",
    "class_description": "Fabricação de produtos derivados do cacau, de chocolates e confeitos"
  },
  "1093702": {
    "description": "Fabricação de frutas cristalizadas, balas e semelhantes",
    "class_description": "Fabricação de produtos derivados do cacau, de chocolates e confeitos"
  },
  "1094500": {
    "description": "Fabricação de massas alimentícias",
    "class_description": "Fabricação de massas alimentícias"
  },
  "1095300": {
    "description": "Fabricação de especiarias, molhos, temperos e condimentos",
    "class_description": "Fabricação de especiarias, molhos, temperos e condimentos"
  },
  "1096100": {
    "description": "Fabricação de alimentos e pratos prontos",
    "class_description": "Fabricação de alimentos e pratos prontos"
  },
  "1099601": {
    "description": "Fabricação de vinagres",
    "class_description": "Fabricação de produtos alimentícios não especificados anteriormente"
  },
  "1099602": {
    "description": "Fabricação de pós-alimentícios",
    "class_description": "Fabricação de produtos alimentícios não especificados anteriormente"
  },
  "1099603": {
    "description": "Fabricação de fermentos e leveduras",
    "class_description": "Fabricação de produtos alimentícios não especificados anteriormente"
  },
  "1099604": {
    "description": "Fabricação de gelo comum",
    "class_description": "Fabricação de produtos alimentícios não especificados anteriormente"
  },
  "1099605": {
    "description": "Fabricação de produtos para infusão (chá, mate, etc.)",
    "class_description": "Fabricação de produtos alimentícios não especificados anteriormente"
  },
  "1099606": {
    "description": "Fabricação de adoçantes naturais e artificiais",
    "class_description": "Fabricação de produtos alimentícios não especificados anteriormente"
  },
  "1099607": {
    "description": "Fabricação de alimentos dietéticos e complementos alimentares",
    "class_description": "Fabricação de produtos alimentícios não especificados anteriormente"
  },
  "1099699": {
    "description": "Fabricação de outros produtos alimentícios não especificados anteriormente",
    "class_description": "Fabricação de produtos alimentícios não especificados anteriormente"
  },
  "1111901": {
    "description": "Fabricação de aguardente de cana-de-açúcar",
    "class_description": "Fabricação de aguardentes e outras bebidas destiladas"
  },
  "1111902": {
    "description": "Fabricação de outras aguardentes e bebidas destiladas",
    "class_description": "Fabricação de aguardentes e outras bebidas destiladas"
  },
  "1112700": {
    "description": "Fabricação de vinho",
    "class_description": "Fabricação de vinho"
  },
  "1113501": {
    "description": "Fabricação de malte, inclusive malte uísque",
    "class_description": "Fabricação de malte, cervejas e chopes"
  },
  "1113502": {
    "description": "Fabricação de cervejas e chopes",
    "class_description": "Fabricação de malte, cervejas e chopes"
  },
  "1121600": {
    "description": "Fabricação de águas envasadas",
    "class_description": "Fabricação de águas envasadas"
  },
  "1122401": {
    "description": "Fabricação de refrigerantes",
    "class_description": "Fabricação de refrigerantes e de outras bebidas não alcoólicas"
  },
  "1122402": {
    "description": "Fabricação de chá mate e outros chás prontos para consumo",
    "class_description": "Fabricação de refrigerantes e de outras bebidas não alcoólicas"
  },
  "1122403": {
    "description": "Fabricação de refrescos, xaropes e pós para refrescos, exceto refrescos de frutas",
    "class_description": "Fabricação de refrigerantes e de outras bebidas não alcoólicas"
  },
  "1122404": {
    "description": "Fabricação de bebidas isotônicas",
    "class_description": "Fabricação de refrigerantes e de outras bebidas não alcoólicas"
  },
  "1122499": {
    "description": "Fabricação de outras bebidas não alcoólicas não especificadas anteriormente",
    "class_description": "Fabricação de refrigerantes e de outras bebidas não alcoólicas"
  },
  "1210700": {
    "description": "Processamento industrial do fumo",
    "class_description": "Processamento industrial do fumo"
  },
  "1220401": {
    "description": "Fabricação de cigarros",
    "class_description": "Fabricação de produtos do fumo"
  },
  "1220402": {
    "description": "Fabricação de cigarrilhas e charutos",
    "class_description": "Fabricação de produtos do fumo"
  },
  "1220403": {
    "description": "Fabricação de filtros para cigarros",
    "class_description": "Fabricação de produtos do fumo"
  },
  "1220499": {
    "description": "Fabricação de outros produtos do fumo, exceto cigarros, cigarrilhas e charutos",
    "class_description": "Fabricação de produtos do fumo"
  },
  "1311100": {
    "description": "Preparação e fiação de fibras de algodão",
    "class_description": "Preparação e fiação de fibras de algodão"
  },
  "1312000": {
    "description": "Preparação e fiação de fibras têxteis naturais, exceto algodão",
    "class_description": "Preparação e fiação de fibras têxteis naturais, exceto algodão"
  },
  "1313800": {
    "description": "Fiação de fibras artificiais e sintéticas",
    "class_description": "Fiação de fibras artificiais e sintéticas"
  },
  "1314600": {
    "description": "Fabricação de linhas para costurar e bordar",
    "class_description": "Fabricação de linhas para costurar e bordar"
  },
  "1321900": {
    "description": "Tecelagem de fios de algodão",
    "class_description": "Tecelagem de fios de algodão"
  },
  "1322700": {
    "description": "Tecelagem de fios de fibras têxteis naturais, exceto algodão",
    "class_description": "Tecelagem de fios de fibras têxteis naturais, exceto algodão"
  },
  "1323500": {
    "description": "Tecelagem de fios de fibras artificiais e sintéticas",
    "class_description": "Tecelagem de fios de fibras artificiais e sintéticas"
  },
  "1330800": {
    "description": "Fabricação de tecidos de malha",
    "class_description": "Fabricação de tecidos de malha"
  },
  "1340501": {
    "description": "Estamparia e texturização em fios, tecidos, artefatos têxteis e peças do vestuário",
    "class_description": "Acabamentos em fios, tecidos e artefatos têxteis"
  },
  "1340502": {
    "description": "Alvejamento, tingimento e torção em fios, tecidos, artefatos têxteis e peças do vestuário",
    "class_description": "Acabamentos em fios, tecidos e artefatos têxteis"
  },
  "1340599": {
    "description": "Outros serviços de acabamento em fios, tecidos, artefatos têxteis e peças do vestuário",
    "class_description": "Acabamentos em fios, tecidos e artefatos têxteis"
  },
  "1351100": {
    "description": "Fabricação de artefatos têxteis para uso doméstico",
    "class_description": "Fabricação de artefatos têxteis para uso doméstico"
  },
  "1352900": {
    "description": "Fabricação de artefatos de tapeçaria",
    "class_description": "Fabricação de artefatos de tapeçaria"
  },
  "1353700": {
    "description": "Fabricação de artefatos de cordoaria",
    "class_description": "Fabricação de artefatos de cordoaria"
  },
  "1354500": {
    "description": "Fabricação de tecidos especiais, inclusive artefatos",
    "class_description": "Fabricação de tecidos especiais, inclusive artefatos"
  },
  "1359600": {
    "description": "Fabricação de outros produtos têxteis não especificados anteriormente",
    "class_description": "Fabricação de outros produtos têxteis não especificados anteriormente"
  },
  "1411801": {
    "description": "Confecção de roupas íntimas",
    "class_description": "Confecção de roupas íntimas"
  },
  "1411802": {
    "description": "Facção de roupas íntimas",
    "class_description": "Confecção de roupas íntimas"
  },
  "1412601": {
    "description": "Confecção de peças do vestuário, exceto roupas íntimas e as confeccionadas sob medida",
    "class_description": "Confecção de peças do vestuário, exceto roupas íntimas"
  },
  "1412602": {
    "description": "Confecção, sob medida, de peças do vestuário, exceto roupas íntimas",
    "class_description": "Confecção de peças do vestuário, exceto roupas íntimas"
  },
  "1412603": {
    "description": "Facção de peças do vestuário, exceto roupas íntimas",
    "class_description": "Confecção de peças do vestuário, exceto roupas íntimas"
  },
  "1413401": {
    "description": "Confecção de roupas profissionais, exceto sob medida",
    "class_description": "Confecção de roupas profissionais"
  },
  "1413402": {
    "description": "Confecção, sob medida, de roupas profissionais",
    "class_description": "Confecção de roupas profissionais"
  },
  "1413403": {
    "description": "Facção de roupas profissionais",
    "class_description": "Confecção de roupas profissionais"
  },
  "1414200": {
    "description": "Fabricação de acessórios do vestuário, exceto para segurança e proteção",
    "class_description": "Fabricação de acessórios do vestuário, exceto para segurança e proteção"
  },
  "1421500": {
    "description": "Fabricação de meias",
    "class_description": "Fabricação de meias"
  },
  "1422300": {
    "description": "Fabricação de artigos do vestuário, produzidos em malharias e tricotagens, exceto meias",
    "class_description": "Fabricação de artigos do vestuário, produzidos em malharias e tricotagens, exceto meias"
  },
  "1510600": {
    "description": "Curtimento e outras preparações de couro",
    "class_description": "Curtimento e outras preparações de couro"
  },
  "1521100": {
    "description": "Fabricação de artigos para viagem, bolsas e semelhantes de qualquer material",
    "class_description": "Fabricação de artigos para viagem, bolsas e semelhantes de qualquer material"
  },
  "1529700": {
    "description": "Fabricação de artefatos de couro não especificados anteriormente",
    "class_description": "Fabricação de artefatos de couro não especificados anteriormente"
  },
  "1531901": {
    "description": "Fabricação de calçados de couro",
    "class_description": "Fabricação de calçados de couro"
  },
  "1531902": {
    "description": "Acabamento de calçados de couro sob contrato",
    "class_description": "Fabricação de calçados de couro"
  },
  "1532700": {
    "description": "Fabricação de tênis de qualquer material",
    "class_description": "Fabricação de tênis de qualquer material"
  },
  "1533500": {
    "description": "Fabricação de calçados de material sintético",
    "class_description": "Fabricação de calçados de material sintético"
  },
  "1539400": {
    "description": "Fabricação de calçados de materiais não especificados\nanteriormente",
    "class_description": "Fabricação de calçados de materiais não especificados anteriormente"
  },
  "1540800": {
    "description": "Fabricação de partes para calçados, de qualquer material",
    "class_description": "Fabricação de partes para calçados, de qualquer material"
  },
  "1610203": {
    "description": "Serrarias com desdobramento de madeira em bruto",
    "class_description": "Desdobramento de madeira"
  },
  "1610204": {
    "description": "Serrarias sem desdobramento de madeira em bruto - Resseragem",
    "class_description": "Desdobramento de madeira"
  },
  "1610205": {
    "description": "Serviço de tratamento de madeira realizado sob contrato",
    "class_description": "Desdobramento de madeira"
  },
  "1621800": {
    "description": "Fabricação de madeira laminada e de chapas de madeira compensada, prensada e aglomerada",
    "class_description": "Fabricação de madeira laminada e de chapas de madeira compensada, prensada e aglomerada"
  },
  "1622601": {
    "description": "Fabricação de casas de madeira pré-fabricadas",
    "class_description": "Fabricação de estruturas de madeira e de artigos de carpintaria para construção"
  },
  "1622602": {
    "description": "Fabricação de esquadrias de madeira e de peças de madeira para instalações industriais e comerciais",
    "class_description": "Fabricação de estruturas de madeira e de artigos de carpintaria para construção"
  },
  "1622699": {
    "description": "Fabricação de outros artigos de carpintaria para construção",
    "class_description": "Fabricação de estruturas de madeira e de artigos de carpintaria para construção"
  },
  "1623400": {
    "description": "Fabricação de artefatos de tanoaria e de embalagens de madeira",
    "class_description": "Fabricação de artefatos de tanoaria e de embalagens de madeira"
  },
  "1629301": {
    "description": "Fabricação de artefatos diversos de madeira, exceto móveis",
    "class_description": "Fabricação de artefatos de madeira, palha, cortiça, vime e material trançado não especificados anteriormente, exceto\nmóveis"
  },
  "1629302": {
    "description": "Fabricação de artefatos diversos de cortiça, bambu, palha, vime e outros materiais trançados, exceto móveis",
    "class_description": "Fabricação de artefatos de madeira, palha, cortiça, vime e material trançado não especificados anteriormente, exceto\nmóveis"
  },
  "1710900": {
    "description": "Fabricação de celulose e outras pastas para a fabricação de papel",
    "class_description": "Fabricação de celulose e outras pastas para a fabricação de papel"
  },
  "1721400": {
    "description": "Fabricação de papel",
    "class_description": "Fabricação de papel"
  },
  "1722200": {
    "description": "Fabricação de cartolina e papel-cartão",
    "class_description": "Fabricação de cartolina e papel-cartão"
  },
  "1731100": {
    "description": "Fabricação de embalagens de papel",
    "class_description": "Fabricação de embalagens de papel"
  },
  "1732000": {
    "description": "Fabricação de embalagens de cartolina e papel-cartão",
    "class_description": "Fabricação de embalagens de cartolina e papel-cartão"
  },
  "1733800": {
    "description": "Fabricação de chapas e de embalagens de papelão ondulado",
    "class_description": "Fabricação de chapas e de embalagens de papelão ondulado"
  },
  "1741901": {
    "description": "Fabricação de formulários contínuos",
    "class_description": "Fabricação de produtos de papel, cartolina, papel-cartão e papelão ondulado para uso comercial e de escritório"
  },
  "1741902": {
    "description": "Fabricação de produtos de papel, cartolina, papel-cartão e papelão ondulado para uso comercial e de escritório",
    "class_description": "Fabricação de produtos de papel, cartolina, papel-cartão e papelão ondulado para uso comercial e de escritório"
  },
  "1742701": {
    "description": "Fabricação de fraldas descartáveis",
    "class_description": "Fabricação de produtos de papel para usos doméstico e higiênico-sanitário"
  },
  "1742702": {
    "description": "Fabricação de absorventes higiênicos",
    "class_description": "Fabricação de produtos de papel para usos doméstico e higiênico-sanitário"
  },
  "1742799": {
    "description": "Fabricação de produtos de papel para uso doméstico e higiênico-sanitário não especificados anteriormente",
    "class_description": "Fabricação de produtos de papel para usos doméstico e higiênico-sanitário"
  },
  "1749400": {
    "description": "Fabricação de produtos de pastas celulósicas, papel, cartolina, papel-cartão e papelão ondulado não especificados anteriormente",
    "class_description": "Fabricação de produtos de pastas celulósicas, papel, cartolina, papel-cartão e papelão ondulado não especificados anteriormente"
  },
  "1811301": {
    "description": "Impressão de jornais",
    "class_description": "Impressão de jornais, livros, revistas e outras publicações periódicas"
  },
  "1811302": {
    "description": "Impressão de livros, revistas e outras publicações periódicas",
    "class_description": "Impressão de jornais, livros, revistas e outras publicações periódicas"
  },
  "1812100": {
    "description": "Impressão de material de segurança",
    "class_description": "Impressão de material de segurança"
  },
  "1813001": {
    "description": "Impressão de material para uso publicitário",
    "class_description": "Impressão de materiais para outros usos"
  },
  "1813099": {
    "description": "Impressão de material para outros usos",
    "class_description": "Impressão de materiais para outros usos"
  },
  "1821100": {
    "description": "Serviços de pré-impressão",
    "class_description": "Serviços de pré-impressão"
  },
  "1822901": {
    "description": "Serviços de encadernação e plastificação",
    "class_description": "Serviços de acabamentos gráficos"
  },
  "1822999": {
    "description": "Serviços de acabamentos gráficos, exceto encadernação e plastificação",
    "class_description": "Serviços de acabamentos gráficos"
  },
  "1830001": {
    "description": "Reprodução de som em qualquer suporte",
    "class_description": "Reprodução de materiais gravados em qualquer suporte"
  },
  "1830002": {
    "description": "Reprodução de vídeo em qualquer suporte",
    "class_description": "Reprodução de materiais gravados em qualquer suporte"
  },
  "1830003": {
    "description": "Reprodução de software em qualquer suporte",
    "class_description": "Reprodução de materiais gravados em qualquer suporte"
  },
  "1910100": {
    "description": "Coquerias",
    "class_description": "Coquerias"
  },
  "1921700": {
    "description": "Fabricação de produtos do refino de petróleo",
    "class_description": "Fabricação de produtos do refino de petróleo"
  },
  "1922501": {
    "description": "Formulação de combustíveis",
    "class_description": "Fabricação de produtos derivados do petróleo, exceto produtos do refino"
  },
  "1922502": {
    "description": "Rerrefino de óleos lubrificantes",
    "class_description": "Fabricação de produtos derivados do petróleo, exceto produtos do refino"
  },
  "1922599": {
    "description": "Fabricação de outros produtos derivados do petróleo, exceto produtos do refino",
    "class_description": "Fabricação de produtos derivados do petróleo, exceto produtos do refino"
  },
  "1931400": {
    "description": "Fabricação de álcool",
    "class_description": "Fabricação de álcool"
  },
  "1932200": {
    "description": "Fabricação de biocombustíveis, exceto álcool",
    "class_description": "Fabricação de biocombustíveis, exceto álcool"
  },
  "2011800": {
    "description": "Fabricação de cloro e álcalis",
    "class_description": "Fabricação de cloro e álcalis"
  },
  "2012600": {
    "description": "Fabricação de intermediários para fertilizantes",
    "class_description": "Fabricação de intermediários para fertilizantes"
  },
  "2013401": {
    "description": "Fabricação de adubos e fertilizantes organo-minerais",
    "class_description": "Fabricação de adubos e fertilizantes"
  },
  "2013402": {
    "description": "Fabricação de adubos e fertilizantes, exceto organo-minerais",
    "class_description": "Fabricação de adubos e fertilizantes"
  },
  "2014200": {
    "description": "Fabricação de gases industriais",
    "class_description": "Fabricação de gases industriais"
  },
  "2019301": {
    "description": "Elaboração de combustíveis nucleares",
    "class_description": "Fabricação de produtos químicos inorgânicos não especificados anteriormente"
  },
  "2019399": {
    "description": "Fabricação de outros produtos químicos inorgânicos não especificados anteriormente",
    "class_description": "Fabricação de produtos químicos inorgânicos não especificados anteriormente"
  },
  "2021500": {
    "description": "Fabricação de produtos petroquímicos básicos",
    "class_description": "Fabricação de produtos petroquímicos básicos"
  },
  "2022300": {
    "description": "Fabricação de intermediários para plastificantes, resinas e fibras",
    "class_description": "Fabricação de intermediários para plastificantes, resinas e fibras"
  },
  "2029100": {
    "description": "Fabricação de produtos químicos orgânicos não especificados anteriormente",
    "class_description": "Fabricação de produtos químicos orgânicos não especificados anteriormente"
  },
  "2031200": {
    "description": "Fabricação de resinas termoplásticas",
    "class_description": "Fabricação de resinas termoplásticas"
  },
  "2032100": {
    "description": "Fabricação de resinas termofixas",
    "class_description": "Fabricação de resinas termofixas"
  },
  "2033900": {
    "description": "Fabricação de elastômeros",
    "class_description": "Fabricação de elastômeros"
  },
  "2040100": {
    "description": "Fabricação de fibras artificiais e sintéticas",
    "class_description": "Fabricação de fibras artificiais e sintéticas"
  },
  "2051700": {
    "description": "Fabricação de defensivos agrícolas",
    "class_description": "Fabricação de defensivos agrícolas"
  },
  "2052500": {
    "description": "Fabricação de desinfestantes domissanitários",
    "class_description": "Fabricação de desinfestantes domissanitários"
  },
  "2061400": {
    "description": "Fabricação de sabões e detergentes sintéticos",
    "class_description": "Fabricação de sabões e detergentes sintéticos"
  },
  "2062200": {
    "description": "Fabricação de produtos de limpeza e polimento",
    "class_description": "Fabricação de produtos de limpeza e polimento"
  },
  "2063100": {
    "description": "Fabricação de cosméticos, produtos de perfumaria e de higiene pessoal",
    "class_description": "Fabricação de cosméticos, produtos de perfumaria e de higiene pessoal"
  },
  "2071100": {
    "description": "Fabricação de tintas, vernizes, esmaltes e lacas",
    "class_description": "Fabricação de tintas, vernizes, esmaltes e lacas"
  },
  "2072000": {
    "description": "Fabricação de tintas de impressão",
    "class_description": "Fabricação de tintas de impressão"
  },
  "2073800": {
    "description": "Fabricação de impermeabilizantes, solventes e produtos afins",
    "class_description": "Fabricação de impermeabilizantes, solventes e produtos afins"
  },
  "2091600": {
    "description": "Fabricação de adesivos e selantes",
    "class_description": "Fabricação de adesivos e selantes"
  },
  "2092401": {
    "description": "Fabricação de pólvoras, explosivos e detonantes",
    "class_description": "Fabricação de explosivos"
  },
  "2092402": {
    "description": "Fabricação de artigos pirotécnicos",
    "class_description": "Fabricação de explosivos"
  },
  "2092403": {
    "description": "Fabricação de fósforos de segurança",
    "class_description": "Fabricação de explosivos"
  },
  "2093200": {
    "description": "Fabricação de aditivos de uso industrial",
    "class_description": "Fabricação de aditivos de uso industrial"
  },
  "2094100": {
    "description": "Fabricação de catalisadores",
    "class_description": "Fabricação de catalisadores"
  },
  "2099101": {
    "description": "Fabricação de chapas, filmes, papéis e outros materiais e produtos químicos para fotografia",
    "class_description": "Fabricação de produtos químicos não especificados anteriormente"
  },
  "2099199": {
    "description": "Fabricação de outros produtos químicos não especificados anteriormente",
    "class_description": "Fabricação de produtos químicos não especificados anteriormente"
  },
  "2110600": {
    "description": "Fabricação de produtos farmoquímicos",
    "class_description": "Fabricação de produtos farmoquímicos"
  },
  "2121101": {
    "description": "Fabricação de medicamentos alopáticos para uso humano",
    "class_description": "Fabricação de medicamentos para uso humano"
  },
  "2121102": {
    "description": "Fabricação de medicamentos homeopáticos para uso humano",
    "class_description": "Fabricação de medicamentos para uso humano"
  },
  "2121103": {
    "description": "Fabricação de medicamentos fitoterápicos para uso humano",
    "class_description": "Fabricação de medicamentos para uso humano"
  },
  "2122000": {
    "description": "Fabricação de medicamentos para uso veterinário",
    "class_description": "Fabricação de medicamentos para uso veterinário"
  },
  "2123800": {
    "description": "Fabricação de preparações farmacêuticas",
    "class_description": "Fabricação de preparações farmacêuticas"
  },
  "2211100": {
    "description": "Fabricação de pneumáticos e de câmaras-de-ar",
    "class_description": "Fabricação de pneumáticos e de câmaras-de-ar"
  },
  "2212900": {
    "description": "Reforma de pneumáticos usados",
    "class_description": "Reforma de pneumáticos usados"
  },
  "2219600": {
    "description": "Fabricação de artefatos de borracha não especificados \nanteriormente",
    "class_description": "Fabricação de artefatos de borracha não especificados anteriormente"
  },
  "2221800": {
    "description": "Fabricação de laminados planos e tubulares de material plástico",
    "class_description": "Fabricação de laminados planos e tubulares de material plástico"
  },
  "2222600": {
    "description": "Fabricação de embalagens de material plástico",
    "class_description": "Fabricação de embalagens de material plástico"
  },
  "2223400": {
    "description": "Fabricação de tubos e acessórios de material plástico para uso na construção",
    "class_description": "Fabricação de tubos e acessórios de material plástico para uso na construção"
  },
  "2229301": {
    "description": "Fabricação de artefatos de material plástico para uso pessoal e doméstico",
    "class_description": "Fabricação de artefatos de material plástico não especificados anteriormente"
  },
  "2229302": {
    "description": "Fabricação de artefatos de material plástico para usos industriais",
    "class_description": "Fabricação de artefatos de material plástico não especificados anteriormente"
  },
  "2229303": {
    "description": "Fabricação de artefatos de material plástico para uso na construção, exceto tubos e acessórios",
    "class_description": "Fabricação de artefatos de material plástico não especificados anteriormente"
  },
  "2229399": {
    "description": "Fabricação de artefatos de material plástico para outros usos não especificados anteriormente",
    "class_description": "Fabricação de artefatos de material plástico não especificados anteriormente"
  },
  "2311700": {
    "description": "Fabricação de vidro plano e de segurança",
    "class_description": "Fabricação de vidro plano e de segurança"
  },
  "2312500": {
    "description": "Fabricação de embalagens de vidro",
    "class_description": "Fabricação de embalagens de vidro"
  },
  "2319200": {
    "description": "Fabricação de artigos de vidro",
    "class_description": "Fabricação de artigos de vidro"
  },
  "2320600": {
    "description": "Fabricação de cimento",
    "class_description": "Fabricação de cimento"
  },
  "2330301": {
    "description": "Fabricação de estruturas pré-moldadas de concreto armado, em série e sob encomenda",
    "class_description": "Fabricação de artefatos de concreto, cimento, fibrocimento, gesso e materiais semelhantes"
  },
  "2330302": {
    "description": "Fabricação de artefatos de cimento para uso na construção",
    "class_description": "Fabricação de artefatos de concreto, cimento, fibrocimento, gesso e materiais semelhantes"
  },
  "2330303": {
    "description": "Fabricação de artefatos de fibrocimento para uso na construção",
    "class_description": "Fabricação de artefatos de concreto, cimento, fibrocimento, gesso e materiais semelhantes"
  },
  "2330304": {
    "description": "Fabricação de casas pré-moldadas de concreto",
    "class_description": "Fabricação de artefatos de concreto, cimento, fibrocimento, gesso e materiais semelhantes"
  },
  "2330305": {
    "description": "Preparação de massa de concreto e argamassa para construção",
    "class_description": "Fabricação de artefatos de concreto, cimento, fibrocimento, gesso e materiais semelhantes"
  },
  "2330399": {
    "description": "Fabricação de outros artefatos e produtos de concreto, cimento, fibrocimento, gesso e materiais semelhantes",
    "class_description": "Fabricação de artefatos de concreto, cimento, fibrocimento, gesso e materiais semelhantes"
  },
  "2341900": {
    "description": "Fabricação de produtos cerâmicos refratários",
    "class_description": "Fabricação de produtos cerâmicos refratários"
  },
  "2342701": {
    "description": "Fabricação de azulejos e pisos",
    "class_description": "Fabricação de produtos cerâmicos não refratários para uso estrutural na construção"
  },
  "2342702": {
    "description": "Fabricação de artefatos de cerâmica e barro cozido para uso na construção, exceto azulejos e pisos",
    "class_description": "Fabricação de produtos cerâmicos não refratários para uso estrutural na construção"
  },
  "2349401": {
    "description": "Fabricação de material sanitário de cerâmica",
    "class_description": "Fabricação de produtos cerâmicos não refratários não especificados anteriormente"
  },
  "2349499": {
    "description": "Fabricação de produtos cerâmicos não refratários não especificados anteriormente",
    "class_description": "Fabricação de produtos cerâmicos não refratários não especificados anteriormente"
  },
  "2391501": {
    "description": "Britamento de pedras, exceto associado à extração",
    "class_description": "Aparelhamento e outros trabalhos em pedras"
  },
  "2391502": {
    "description": "Aparelhamento de pedras para construção, exceto associado à extração",
    "class_description": "Aparelhamento e outros trabalhos em pedras"
  },
  "2391503": {
    "description": "Aparelhamento de placas e execução de trabalhos em mármore, granito, ardósia e outras pedras",
    "class_description": "Aparelhamento e outros trabalhos em pedras"
  },
  "2392300": {
    "description": "Fabricação de cal e gesso",
    "class_description": "Fabricação de cal e gesso"
  },
  "2399101": {
    "description": "Decoração, lapidação, gravação, vitrificação e outros trabalhos em cerâmica, louça, vidro e cristal",
    "class_description": "Fabricação de produtos de minerais não metálicos não especificados anteriormente"
  },
  "2399102": {
    "description": "Fabricação de abrasivos",
    "class_description": "Fabricação de produtos de minerais não metálicos não especificados anteriormente"
  },
  "2399199": {
    "description": "Fabricação de outros produtos de minerais não metálicos não especificados anteriormente",
    "class_description": "Fabricação de produtos de minerais não metálicos não especificados anteriormente"
  },
  "2411300": {
    "description": "Produção de ferro-gusa",
    "class_description": "Produção de ferro-gusa"
  },
  "2412100": {
    "description": "Produção de ferroligas",
    "class_description": "Produção de ferroligas"
  },
  "2421100": {
    "description": "Produção de semiacabados de aço",
    "class_description": "Produção de semiacabados de aço"
  },
  "2422901": {
    "description": "Produção de laminados planos de aço ao carbono, revestidos ou não",
    "class_description": "Produção de laminados planos de aço"
  },
  "2422902": {
    "description": "Produção de laminados planos de aços especiais",
    "class_description": "Produção de laminados planos de aço"
  },
  "2423701": {
    "description": "Produção de tubos de aço sem costura",
    "class_description": "Produção de laminados longos de aço"
  },
  "2423702": {
    "description": "Produção de laminados longos de aço, exceto tubos",
    "class_description": "Produção de laminados longos de aço"
  },
  "2424501": {
    "description": "Produção de arames de aço",
    "class_description": "Produção de relaminados, trefilados e perfilados de aço"
  },
  "2424502": {
    "description": "Produção de relaminados, trefilados e perfilados de aço, exceto arames",
    "class_description": "Produção de relaminados, trefilados e perfilados de aço"
  },
  "2431800": {
    "description": "Produção de tubos de aço com costura",
    "class_description": "Produção de tubos de aço com costura"
  },
  "2439300": {
    "description": "Produção de outros tubos de ferro e aço",
    "class_description": "Produção de outros tubos de ferro e aço"
  },
  "2441501": {
    "description": "Produção de alumínio e suas ligas em formas primárias",
    "class_description": "Metalurgia do alumínio e suas ligas"
  },
  "2441502": {
    "description": "Produção de laminados de alumínio",
    "class_description": "Metalurgia do alumínio e suas ligas"
  },
  "2442300": {
    "description": "Metalurgia dos metais preciosos",
    "class_description": "Metalurgia dos metais preciosos"
  },
  "2443100": {
    "description": "Metalurgia do cobre",
    "class_description": "Metalurgia do cobre"
  },
  "2449101": {
    "description": "Produção de zinco em formas primárias",
    "class_description": "Metalurgia dos metais não ferrosos e suas ligas não especificados anteriormente"
  },
  "2449102": {
    "description": "Produção de laminados de zinco",
    "class_description": "Metalurgia dos metais não ferrosos e suas ligas não especificados anteriormente"
  },
  "2449103": {
    "description": "Fabricação de ânodos para galvanoplastia",
    "class_description": "Metalurgia dos metais não ferrosos e suas ligas não especificados anteriormente"
  },
  "2449199": {
    "description": "Metalurgia de outros metais não ferrosos e suas ligas não especificados anteriormente",
    "class_description": "Metalurgia dos metais não ferrosos e suas ligas não especificados anteriormente"
  },
  "2451200": {
    "description": "Fundição de ferro e aço",
    "class_description": "Fundição de ferro e aço"
  },
  "2452100": {
    "description": "Fundição de metais não ferrosos e suas ligas",
    "class_description": "Fundição de metais não ferrosos e suas ligas"
  },
  "2511000": {
    "description": "Fabricação de estruturas metálicas",
    "class_description": "Fabricação de estruturas metálicas"
  },
  "2512800": {
    "description": "Fabricação de esquadrias de metal",
    "class_description": "Fabricação de esquadrias de metal"
  },
  "2513600": {
    "description": "Fabricação de obras de caldeiraria pesada",
    "class_description": "Fabricação de obras de caldeiraria pesada"
  },
  "2521700": {
    "description": "Fabricação de tanques, reservatórios metálicos e caldeiras para aquecimento central",
    "class_description": "Fabricação de tanques, reservatórios metálicos e caldeiras para aquecimento central"
  },
  "2522500": {
    "description": "Fabricação de caldeiras geradoras de vapor, exceto para aquecimento central e para veículos",
    "class_description": "Fabricação de caldeiras geradoras de vapor, exceto para aquecimento central e para veículos"
  },
  "2531401": {
    "description": "Produção de forjados de aço",
    "class_description": "Produção de forjados de aço e de metais não ferrosos e suas ligas"
  },
  "2531402": {
    "description": "Produção de forjados de metais não ferrosos e suas ligas",
    "class_description": "Produção de forjados de aço e de metais não ferrosos e suas ligas"
  },
  "2532201": {
    "description": "Produção de artefatos estampados de metal",
    "class_description": "Produção de artefatos estampados de metal; metalurgia do pó"
  },
  "2532202": {
    "description": "Metalurgia do pó",
    "class_description": "Produção de artefatos estampados de metal; metalurgia do pó"
  },
  "2539001": {
    "description": "Serviços de usinagem, torneiria e solda",
    "class_description": "Serviços de usinagem, solda, tratamento e revestimento em metais"
  },
  "2539002": {
    "description": "Serviços de tratamento e revestimento em metais",
    "class_description": "Serviços de usinagem, solda, tratamento e revestimento em metais"
  },
  "2541100": {
    "description": "Fabricação de artigos de cutelaria",
    "class_description": "Fabricação de artigos de cutelaria"
  },
  "2542000": {
    "description": "Fabricação de artigos de serralheria, exceto esquadrias",
    "class_description": "Fabricação de artigos de serralheria, exceto esquadrias"
  },
  "2543800": {
    "description": "Fabricação de ferramentas",
    "class_description": "Fabricação de ferramentas"
  },
  "2550101": {
    "description": "Fabricação de equipamento bélico pesado, exceto veículos militares de combate",
    "class_description": "Fabricação de equipamento bélico pesado, armas de fogo e munições"
  },
  "2550102": {
    "description": "Fabricação de armas de fogo, outras armas e munições",
    "class_description": "Fabricação de equipamento bélico pesado, armas de fogo e munições"
  },
  "2591800": {
    "description": "Fabricação de embalagens metálicas",
    "class_description": "Fabricação de embalagens metálicas"
  },
  "2592601": {
    "description": "Fabricação de produtos de trefilados de metal padronizados",
    "class_description": "Fabricação de produtos de trefilados de metal"
  },
  "2592602": {
    "description": "Fabricação de produtos de trefilados de metal, exceto padronizados",
    "class_description": "Fabricação de produtos de trefilados de metal"
  },
  "2593400": {
    "description": "Fabricação de artigos de metal para uso doméstico e pessoal",
    "class_description": "Fabricação de artigos de metal para uso doméstico e pessoal"
  },
  "2599301": {
    "description": "Serviços de confecção de armações metálicas para a construção",
    "class_description": "Fabricação de produtos de metal não especificados anteriormente"
  },
  "2599302": {
    "description": "Serviço de corte e dobra de metais",
    "class_description": "Fabricação de produtos de metal não especificados anteriormente"
  },
  "2599399": {
    "description": "Fabricação de outros produtos de metal não especificados anteriormente",
    "class_description": "Fabricação de produtos de metal não especificados anteriormente"
  },
  "2610800": {
    "description": "Fabricação de componentes eletrônicos",
    "class_description": "Fabricação de componentes eletrônicos"
  },
  "2621300": {
    "description": "Fabricação de equipamentos de informática",
    "class_description": "Fabricação de equipamentos de informática"
  },
  "2622100": {
    "description": "Fabricação de periféricos para equipamentos de informática",
    "class_description": "Fabricação de periféricos para equipamentos de informática"
  },
  "2631100": {
    "description": "Fabricação de equipamentos transmissores de comunicação, peças e acessórios",
    "class_description": "Fabricação de equipamentos transmissores de comunicação"
  },
  "2632900": {
    "description": "Fabricação de aparelhos telefônicos e de outros equipamentos de comunicação, peças e acessórios",
    "class_description": "Fabricação de aparelhos telefônicos e de outros equipamentos de comunicação"
  },
  "2640000": {
    "description": "Fabricação de aparelhos de recepção, reprodução, gravação e amplificação de áudio e vídeo",
    "class_description": "Fabricação de aparelhos de recepção, reprodução, gravação e amplificação de áudio e vídeo"
  },
  "2651500": {
    "description": "Fabricação de aparelhos e equipamentos de medida, teste e controle",
    "class_description": "Fabricação de aparelhos e equipamentos de medida, teste e\ncontrole"
  },
  "2652300": {
    "description": "Fabricação de cronômetros e relógios",
    "class_description": "Fabricação de cronômetros e relógios"
  },
  "2660400": {
    "description": "Fabricação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação",
    "class_description": "Fabricação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação"
  },
  "2670101": {
    "description": "Fabricação de equipamentos e instrumentos ópticos, peças e acessórios",
    "class_description": "Fabricação de equipamentos e instrumentos ópticos, fotográficos e cinematográficos"
  },
  "2670102": {
    "description": "Fabricação de aparelhos fotográficos e cinematográficos, peças e acessórios",
    "class_description": "Fabricação de equipamentos e instrumentos ópticos, fotográficos e cinematográficos"
  },
  "2680900": {
    "description": "Fabricação de mídias virgens, magnéticas e ópticas",
    "class_description": "Fabricação de mídias virgens, magnéticas e ópticas"
  },
  "2710401": {
    "description": "Fabricação de geradores de corrente contínua e alternada, peças e acessórios",
    "class_description": "Fabricação de geradores, transformadores e motores elétricos"
  },
  "2710402": {
    "description": "Fabricação de transformadores, indutores, conversores, sincronizadores e semelhantes, peças e acessórios",
    "class_description": "Fabricação de geradores, transformadores e motores elétricos"
  },
  "2710403": {
    "description": "Fabricação de motores elétricos, peças e acessórios",
    "class_description": "Fabricação de geradores, transformadores e motores elétricos"
  },
  "2721000": {
    "description": "Fabricação de pilhas, baterias e acumuladores elétricos, exceto para veículos automotores",
    "class_description": "Fabricação de pilhas, baterias e acumuladores elétricos, exceto para veículos automotores"
  },
  "2722801": {
    "description": "Fabricação de baterias e acumuladores para veículos automotores",
    "class_description": "Fabricação de baterias e acumuladores para veículos automotores"
  },
  "2722802": {
    "description": "Recondicionamento de baterias e acumuladores para veículos automotores",
    "class_description": "Fabricação de baterias e acumuladores para veículos automotores"
  },
  "2731700": {
    "description": "Fabricação de aparelhos e equipamentos para distribuição e controle de energia elétrica",
    "class_description": "Fabricação de aparelhos e equipamentos para distribuição e controle de energia elétrica"
  },
  "2732500": {
    "description": "Fabricação de material elétrico para instalações em circuito de consumo",
    "class_description": "Fabricação de material elétrico para instalações em circuito de consumo"
  },
  "2733300": {
    "description": "Fabricação de fios, cabos e condutores elétricos isolados",
    "class_description": "Fabricação de fios, cabos e condutores elétricos isolados"
  },
  "2740601": {
    "description": "Fabricação de lâmpadas",
    "class_description": "Fabricação de lâmpadas e outros equipamentos de iluminação"
  },
  "2740602": {
    "description": "Fabricação de luminárias e outros equipamentos de iluminação",
    "class_description": "Fabricação de lâmpadas e outros equipamentos de iluminação"
  },
  "2751100": {
    "description": "Fabricação de fogões, refrigeradores e máquinas de lavar e secar para uso doméstico, peças e acessórios",
    "class_description": "Fabricação de fogões, refrigeradores e máquinas de lavar e secar para uso doméstico"
  },
  "2759701": {
    "description": "Fabricação de aparelhos elétricos de uso pessoal, peças e acessórios",
    "class_description": "Fabricação de aparelhos eletrodomésticos não especificados anteriormente"
  },
  "2759799": {
    "description": "Fabricação de outros aparelhos eletrodomésticos não especificados anteriormente, peças e acessórios",
    "class_description": "Fabricação de aparelhos eletrodomésticos não especificados anteriormente"
  },
  "2790201": {
    "description": "Fabricação de eletrodos, contatos e outros artigos de carvão e grafita para uso elétrico, eletroímãs e isoladores",
    "class_description": "Fabricação de equipamentos e aparelhos elétricos não especificados anteriormente"
  },
  "2790202": {
    "description": "Fabricação de equipamentos para sinalização e alarme",
    "class_description": "Fabricação de equipamentos e aparelhos elétricos não especificados anteriormente"
  },
  "2790299": {
    "description": "Fabricação de outros equipamentos e aparelhos elétricos não especificados anteriormente",
    "class_description": "Fabricação de equipamentos e aparelhos elétricos não especificados anteriormente"
  },
  "2811900": {
    "description": "Fabricação de motores e turbinas, peças e acessórios, exceto para aviões e veículos rodoviários",
    "class_description": "Fabricação de motores e turbinas, exceto para aviões e veículos rodoviários"
  },
  "2812700": {
    "description": "Fabricação de equipamentos hidráulicos e pneumáticos, peças e acessórios, exceto válvulas",
    "class_description": "Fabricação de equipamentos hidráulicos e pneumáticos, exceto válvulas"
  },
  "2813500": {
    "description": "Fabricação de válvulas, registros e dispositivos semelhantes, peças e acessórios",
    "class_description": "Fabricação de válvulas, registros e dispositivos semelhantes"
  },
  "2814301": {
    "description": "Fabricação de compressores para uso industrial, peças e acessórios",
    "class_description": "Fabricação de compressores"
  },
  "2814302": {
    "description": "Fabricação de compressores para uso não industrial, peças e acessórios",
    "class_description": "Fabricação de compressores"
  },
  "2815101": {
    "description": "Fabricação de rolamentos para fins industriais",
    "class_description": "Fabricação de equipamentos de transmissão para fins industriais"
  },
  "2815102": {
    "description": "Fabricação de equipamentos de transmissão para fins industriais, exceto rolamentos",
    "class_description": "Fabricação de equipamentos de transmissão para fins industriais"
  },
  "2821601": {
    "description": "Fabricação de fornos industriais, aparelhos e equipamentos não elétricos para instalações térmicas, peças e acessórios",
    "class_description": "Fabricação de aparelhos e equipamentos para instalações térmicas"
  },
  "2821602": {
    "description": "Fabricação de estufas e fornos elétricos para fins industriais, peças e acessórios",
    "class_description": "Fabricação de aparelhos e equipamentos para instalações térmicas"
  },
  "2822401": {
    "description": "Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de pessoas, peças e acessórios",
    "class_description": "Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas e pessoas"
  },
  "2822402": {
    "description": "Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas, peças e acessórios",
    "class_description": "Fabricação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas e pessoas"
  },
  "2823200": {
    "description": "Fabricação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial, peças e acessórios",
    "class_description": "Fabricação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial"
  },
  "2824101": {
    "description": "Fabricação de aparelhos e equipamentos de ar condicionado para uso industrial",
    "class_description": "Fabricação de aparelhos e equipamentos de ar condicionado"
  },
  "2824102": {
    "description": "Fabricação de aparelhos e equipamentos de ar condicionado para uso não industrial",
    "class_description": "Fabricação de aparelhos e equipamentos de ar condicionado"
  },
  "2825900": {
    "description": "Fabricação de máquinas e equipamentos para saneamento básico e ambiental, peças e acessórios",
    "class_description": "Fabricação de máquinas e equipamentos para saneamento básico e ambiental"
  },
  "2829101": {
    "description": "Fabricação de máquinas de escrever, calcular e outros equipamentos não eletrônicos para escritório, peças e acessórios",
    "class_description": "Fabricação de máquinas e equipamentos de uso geral não especificados anteriormente"
  },
  "2829199": {
    "description": "Fabricação de outras máquinas e equipamentos de uso geral não especificados anteriormente, peças e acessórios",
    "class_description": "Fabricação de máquinas e equipamentos de uso geral não especificados anteriormente"
  },
  "2831300": {
    "description": "Fabricação de tratores agrícolas, peças e acessórios",
    "class_description": "Fabricação de tratores agrícolas"
  },
  "2832100": {
    "description": "Fabricação de equipamentos para irrigação agrícola, peças e acessórios",
    "class_description": "Fabricação de equipamentos para irrigação agrícola"
  },
  "2833000": {
    "description": "Fabricação de máquinas e equipamentos para a agricultura e pecuária, peças e acessórios, exceto para irrigação",
    "class_description": "Fabricação de máquinas e equipamentos para a agricultura e pecuária, exceto para irrigação"
  },
  "2840200": {
    "description": "Fabricação de máquinas-ferramenta, peças e acessórios",
    "class_description": "Fabricação de máquinas-ferramenta"
  },
  "2851800": {
    "description": "Fabricação de máquinas e equipamentos para a prospecção e extração de petróleo, peças e acessórios",
    "class_description": "Fabricação de máquinas e equipamentos para a prospecção e extração de petróleo"
  },
  "2852600": {
    "description": "Fabricação de outras máquinas e equipamentos para uso na extração mineral, peças e acessórios, exceto na extração de petróleo",
    "class_description": "Fabricação de outras máquinas e equipamentos para uso na extração mineral, exceto na extração de petróleo"
  },
  "2853400": {
    "description": "Fabricação de tratores, peças e acessórios, exceto agrícolas",
    "class_description": "Fabricação de tratores, exceto agrícolas"
  },
  "2854200": {
    "description": "Fabricação de máquinas e equipamentos para terraplenagem, pavimentação e construção, peças e acessórios, exceto tratores",
    "class_description": "Fabricação de máquinas e equipamentos para terraplenagem, pavimentação e construção, exceto tratores"
  },
  "2861500": {
    "description": "Fabricação de máquinas para a indústria metalúrgica, peças e acessórios, exceto máquinas-ferramenta",
    "class_description": "Fabricação de máquinas para a indústria metalúrgica, exceto máquinas-ferramenta"
  },
  "2862300": {
    "description": "Fabricação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo, peças e acessórios",
    "class_description": "Fabricação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo"
  },
  "2863100": {
    "description": "Fabricação de máquinas e equipamentos para a indústria têxtil, peças e acessórios",
    "class_description": "Fabricação de máquinas e equipamentos para a indústria têxtil"
  },
  "2864000": {
    "description": "Fabricação de máquinas e equipamentos para as indústrias do vestuário, do couro e de calçados, peças e acessórios",
    "class_description": "Fabricação de máquinas e equipamentos para as indústrias do vestuário, do couro e de calçados"
  },
  "2865800": {
    "description": "Fabricação de máquinas e equipamentos para as indústrias de celulose, papel e papelão e artefatos, peças e acessórios",
    "class_description": "Fabricação de máquinas e equipamentos para as indústrias de celulose, papel e papelão e artefatos"
  },
  "2866600": {
    "description": "Fabricação de máquinas e equipamentos para a indústria do plástico, peças e acessórios",
    "class_description": "Fabricação de máquinas e equipamentos para a indústria do plástico"
  },
  "2869100": {
    "description": "Fabricação de máquinas e equipamentos para uso industrial específico não especificados anteriormente, peças e acessórios",
    "class_description": "Fabricação de máquinas e equipamentos para uso industrial específico não especificados anteriormente"
  },
  "2910701": {
    "description": "Fabricação de automóveis, camionetas e utilitários",
    "class_description": "Fabricação de automóveis, camionetas e utilitários"
  },
  "2910702": {
    "description": "Fabricação de chassis com motor para automóveis, camionetas e utilitários",
    "class_description": "Fabricação de automóveis, camionetas e utilitários"
  },
  "2910703": {
    "description": "Fabricação de motores para automóveis, camionetas e utilitários",
    "class_description": "Fabricação de automóveis, camionetas e utilitários"
  },
  "2920401": {
    "description": "Fabricação de caminhões e ônibus",
    "class_description": "Fabricação de caminhões e ônibus"
  },
  "2920402": {
    "description": "Fabricação de motores para caminhões e ônibus",
    "class_description": "Fabricação de caminhões e ônibus"
  },
  "2930101": {
    "description": "Fabricação de cabines, carrocerias e reboques para caminhões",
    "class_description": "Fabricação de cabines, carrocerias e reboques para veículos automotores"
  },
  "2930102": {
    "description": "Fabricação de carrocerias para ônibus",
    "class_description": "Fabricação de cabines, carrocerias e reboques para veículos automotores"
  },
  "2930103": {
    "description": "Fabricação de cabines, carrocerias e reboques para outros veículos automotores, exceto caminhões e ônibus",
    "class_description": "Fabricação de cabines, carrocerias e reboques para veículos automotores"
  },
  "2941700": {
    "description": "Fabricação de peças e acessórios para o sistema motor de veículos automotores",
    "class_description": "Fabricação de peças e acessórios para o sistema motor de veículos automotores"
  },
  "2942500": {
    "description": "Fabricação de peças e acessórios para os sistemas de marcha e transmissão de veículos automotores",
    "class_description": "Fabricação de peças e acessórios para os sistemas de marcha e transmissão de veículos automotores"
  },
  "2943300": {
    "description": "Fabricação de peças e acessórios para o sistema de freios de veículos automotores",
    "class_description": "Fabricação de peças e acessórios para o sistema de freios de veículos automotores"
  },
  "2944100": {
    "description": "Fabricação de peças e acessórios para o sistema de direção e suspensão de veículos automotores",
    "class_description": "Fabricação de peças e acessórios para o sistema de direção e suspensão de veículos automotores"
  },
  "2945000": {
    "description": "Fabricação de material elétrico e eletrônico para veículos automotores, exceto baterias",
    "class_description": "Fabricação de material elétrico e eletrônico para veículos automotores, exceto baterias"
  },
  "2949201": {
    "description": "Fabricação de bancos e estofados para veículos automotores",
    "class_description": "Fabricação de peças e acessórios para veículos automotores não especificados anteriormente"
  },
  "2949299": {
    "description": "Fabricação de outras peças e acessórios para veículos automotores não especificadas anteriormente",
    "class_description": "Fabricação de peças e acessórios para veículos automotores não especificados anteriormente"
  },
  "2950600": {
    "description": "Recondicionamento e recuperação de motores para veículos automotores",
    "class_description": "Recondicionamento e recuperação de motores para veículos automotores"
  },
  "3011301": {
    "description": "Construção de embarcações de grande porte",
    "class_description": "Construção de embarcações e estruturas flutuantes"
  },
  "3011302": {
    "description": "Construção de embarcações para uso comercial e para usos especiais, exceto de grande porte",
    "class_description": "Construção de embarcações e estruturas flutuantes"
  },
  "3012100": {
    "description": "Construção de embarcações para esporte e lazer",
    "class_description": "Construção de embarcações para esporte e lazer"
  },
  "3031800": {
    "description": "Fabricação de locomotivas, vagões e outros materiais rodantes",
    "class_description": "Fabricação de locomotivas, vagões e outros materiais rodantes"
  },
  "3032600": {
    "description": "Fabricação de peças e acessórios para veículos ferroviários",
    "class_description": "Fabricação de peças e acessórios para veículos ferroviários"
  },
  "3041500": {
    "description": "Fabricação de aeronaves",
    "class_description": "Fabricação de aeronaves"
  },
  "3042300": {
    "description": "Fabricação de turbinas, motores e outros componentes e peças para aeronaves",
    "class_description": "Fabricação de turbinas, motores e outros componentes e peças para aeronaves"
  },
  "3050400": {
    "description": "Fabricação de veículos militares de combate",
    "class_description": "Fabricação de veículos militares de combate"
  },
  "3091101": {
    "description": "Fabricação de motocicletas",
    "class_description": "Fabricação de motocicletas"
  },
  "3091102": {
    "description": "Fabricação de peças e acessórios para motocicletas",
    "class_description": "Fabricação de motocicletas"
  },
  "3092000": {
    "description": "Fabricação de bicicletas e triciclos não motorizados, peças e acessórios",
    "class_description": "Fabricação de bicicletas e triciclos não motorizados"
  },
  "3099700": {
    "description": "Fabricação de equipamentos de transporte não especificados anteriormente",
    "class_description": "Fabricação de equipamentos de transporte não especificados anteriormente"
  },
  "3101200": {
    "description": "Fabricação de móveis com predominância de madeira",
    "class_description": "Fabricação de móveis com predominância de madeira"
  },
  "3102100": {
    "description": "Fabricação de móveis com predominância de metal",
    "class_description": "Fabricação de móveis com predominância de metal"
  },
  "3103900": {
    "description": "Fabricação de móveis de outros materiais, exceto madeira e metal",
    "class_description": "Fabricação de móveis de outros materiais, exceto madeira e metal"
  },
  "3104700": {
    "description": "Fabricação de colchões",
    "class_description": "Fabricação de colchões"
  },
  "3211601": {
    "description": "Lapidação de gemas",
    "class_description": "Lapidação de gemas e fabricação de artefatos de ourivesaria e joalheria"
  },
  "3211602": {
    "description": "Fabricação de artefatos de joalheria e ourivesaria",
    "class_description": "Lapidação de gemas e fabricação de artefatos de ourivesaria e joalheria"
  },
  "3211603": {
    "description": "Cunhagem de moedas e medalhas",
    "class_description": "Lapidação de gemas e fabricação de artefatos de ourivesaria e joalheria"
  },
  "3212400": {
    "description": "Fabricação de bijuterias e artefatos semelhantes",
    "class_description": "Fabricação de bijuterias e artefatos semelhantes"
  },
  "3220500": {
    "description": "Fabricação de instrumentos musicais, peças e acessórios",
    "class_description": "Fabricação de instrumentos musicais"
  },
  "3230200": {
    "description": "Fabricação de artefatos para pesca e esporte",
    "class_description": "Fabricação de artefatos para pesca e esporte"
  },
  "3240001": {
    "description": "Fabricação de jogos eletrônicos",
    "class_description": "Fabricação de brinquedos e jogos recreativos"
  },
  "3240002": {
    "description": "Fabricação de mesas de bilhar, de sinuca e acessórios não associada à locação",
    "class_description": "Fabricação de brinquedos e jogos recreativos"
  },
  "3240003": {
    "description": "Fabricação de mesas de bilhar, de sinuca e acessórios associada à locação",
    "class_description": "Fabricação de brinquedos e jogos recreativos"
  },
  "3240099": {
    "description": "Fabricação de outros brinquedos e jogos recreativos não especificados anteriormente",
    "class_description": "Fabricação de brinquedos e jogos recreativos"
  },
  "3250701": {
    "description": "Fabricação de instrumentos não eletrônicos e utensílios para uso médico, cirúrgico, odontológico e de laboratório",
    "class_description": "Fabricação de instrumentos e materiais para uso médico e odontológico e de artigos ópticos"
  },
  "3250702": {
    "description": "Fabricação de mobiliário para uso médico, cirúrgico, odontológico e de laboratório",
    "class_description": "Fabricação de instrumentos e materiais para uso médico e odontológico e de artigos ópticos"
  },
  "3250703": {
    "description": "Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em geral sob encomenda",
    "class_description": "Fabricação de instrumentos e materiais para uso médico e odontológico e de artigos ópticos"
  },
  "3250704": {
    "description": "Fabricação de aparelhos e utensílios para correção de defeitos físicos e aparelhos ortopédicos em geral, exceto sob encomenda",
    "class_description": "Fabricação de instrumentos e materiais para uso médico e odontológico e de artigos ópticos"
  },
  "3250705": {
    "description": "Fabricação de materiais para medicina e odontologia",
    "class_description": "Fabricação de instrumentos e materiais para uso médico e odontológico e de artigos ópticos"
  },
  "3250706": {
    "description": "Serviços de prótese dentária",
    "class_description": "Fabricação de instrumentos e materiais para uso médico e odontológico e de artigos ópticos"
  },
  "3250707": {
    "description": "Fabricação de artigos ópticos",
    "class_description": "Fabricação de instrumentos e materiais para uso médico e odontológico e de artigos ópticos"
  },
  "3250709": {
    "description": "Serviço de laboratório óptico",
    "class_description": "Fabricação de instrumentos e materiais para uso médico e odontológico e de artigos ópticos"
  },
  "3291400": {
    "description": "Fabricação de escovas, pincéis e vassouras",
    "class_description": "Fabricação de escovas, pincéis e vassouras"
  },
  "3292201": {
    "description": "Fabricação de roupas de proteção e segurança e resistentes a fogo",
    "class_description": "Fabricação de equipamentos e acessórios para segurança e proteção pessoal e profissional"
  },
  "3292202": {
    "description": "Fabricação de equipamentos e acessórios para segurança pessoal e profissional",
    "class_description": "Fabricação de equipamentos e acessórios para segurança e proteção pessoal e profissional"
  },
  "3299001": {
    "description": "Fabricação de guarda-chuvas e similares",
    "class_description": "Fabricação de produtos diversos não especificados anteriormente"
  },
  "3299002": {
    "description": "Fabricação de canetas, lápis e outros artigos para escritório",
    "class_description": "Fabricação de produtos diversos não especificados anteriormente"
  },
  "3299003": {
    "description": "Fabricação de letras, letreiros e placas de qualquer material, exceto luminosos",
    "class_description": "Fabricação de produtos diversos não especificados anteriormente"
  },
  "3299004": {
    "description": "Fabricação de painéis e letreiros luminosos",
    "class_description": "Fabricação de produtos diversos não especificados anteriormente"
  },
  "3299005": {
    "description": "Fabricação de aviamentos para costura",
    "class_description": "Fabricação de produtos diversos não especificados anteriormente"
  },
  "3299006": {
    "description": "Fabricação de velas, inclusive decorativas",
    "class_description": "Fabricação de produtos diversos não especificados anteriormente"
  },
  "3299099": {
    "description": "Fabricação de produtos diversos não especificados anteriormente",
    "class_description": "Fabricação de produtos diversos não especificados anteriormente"
  },
  "3311200": {
    "description": "Manutenção e reparação de tanques, reservatórios metálicos e caldeiras, exceto para veículos",
    "class_description": "Manutenção e reparação de tanques, reservatórios metálicos e caldeiras, exceto para veículos"
  },
  "3312102": {
    "description": "Manutenção e reparação de aparelhos e instrumentos de medida, teste e controle",
    "class_description": "Manutenção e reparação de equipamentos eletrônicos e ópticos"
  },
  "3312103": {
    "description": "Manutenção e reparação de aparelhos eletromédicos e eletroterapêuticos e equipamentos de irradiação",
    "class_description": "Manutenção e reparação de equipamentos eletrônicos e ópticos"
  },
  "3312104": {
    "description": "Manutenção e reparação de equipamentos e instrumentos ópticos",
    "class_description": "Manutenção e reparação de equipamentos eletrônicos e ópticos"
  },
  "3313901": {
    "description": "Manutenção e reparação de geradores, transformadores e motores elétricos",
    "class_description": "Manutenção e reparação de máquinas e equipamentos elétricos"
  },
  "3313902": {
    "description": "Manutenção e reparação de baterias e acumuladores elétricos, exceto para veículos",
    "class_description": "Manutenção e reparação de máquinas e equipamentos elétricos"
  },
  "3313999": {
    "description": "Manutenção e reparação de máquinas, aparelhos e materiais elétricos não especificados anteriormente",
    "class_description": "Manutenção e reparação de máquinas e equipamentos elétricos"
  },
  "3314701": {
    "description": "Manutenção e reparação de máquinas motrizes não elétricas",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314702": {
    "description": "Manutenção e reparação de equipamentos hidráulicos e pneumáticos, exceto válvulas",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314703": {
    "description": "Manutenção e reparação de válvulas industriais",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314704": {
    "description": "Manutenção e reparação de compressores",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314705": {
    "description": "Manutenção e reparação de equipamentos de transmissão para fins industriais",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314706": {
    "description": "Manutenção e reparação de máquinas, aparelhos e equipamentos para instalações térmicas",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314707": {
    "description": "Manutenção e reparação de máquinas e aparelhos de refrigeração e ventilação para uso industrial e comercial",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314708": {
    "description": "Manutenção e reparação de máquinas, equipamentos e aparelhos para transporte e elevação de cargas",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314709": {
    "description": "Manutenção e reparação de máquinas de escrever, calcular e de outros equipamentos não eletrônicos para escritório",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314710": {
    "description": "Manutenção e reparação de máquinas e equipamentos para uso geral não especificados anteriormente",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314711": {
    "description": "Manutenção e reparação de máquinas e equipamentos para agricultura e pecuária",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314712": {
    "description": "Manutenção e reparação de tratores agrícolas",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314713": {
    "description": "Manutenção e reparação de máquinas-ferramenta",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314714": {
    "description": "Manutenção e reparação de máquinas e equipamentos para a prospecção e extração de petróleo",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314715": {
    "description": "Manutenção e reparação de máquinas e equipamentos para uso na extração mineral, exceto na extração de petróleo",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314716": {
    "description": "Manutenção e reparação de tratores, exceto agrícolas",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314717": {
    "description": "Manutenção e reparação de máquinas e equipamentos de terraplenagem, pavimentação e construção, exceto tratores",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314718": {
    "description": "Manutenção e reparação de máquinas para a indústria metalúrgica, exceto máquinas-ferramenta",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314719": {
    "description": "Manutenção e reparação de máquinas e equipamentos para as indústrias de alimentos, bebidas e fumo",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314720": {
    "description": "Manutenção e reparação de máquinas e equipamentos para a indústria têxtil, do vestuário, do couro e calçados",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314721": {
    "description": "Manutenção e reparação de máquinas e aparelhos para a indústria de celulose, papel e papelão e artefatos",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314722": {
    "description": "Manutenção e reparação de máquinas e aparelhos para a indústria do plástico",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3314799": {
    "description": "Manutenção e reparação de outras máquinas e equipamentos para usos industriais não especificados anteriormente",
    "class_description": "Manutenção e reparação de máquinas e equipamentos da indústria mecânica"
  },
  "3315500": {
    "description": "Manutenção e reparação de veículos ferroviários",
    "class_description": "Manutenção e reparação de veículos ferroviários"
  },
  "3316301": {
    "description": "Manutenção e reparação de aeronaves, exceto a manutenção na pista",
    "class_description": "Manutenção e reparação de aeronaves"
  },
  "3316302": {
    "description": "Manutenção de aeronaves na pista",
    "class_description": "Manutenção e reparação de aeronaves"
  },
  "3317101": {
    "description": "Manutenção e reparação de embarcações e estruturas flutuantes",
    "class_description": "Manutenção e reparação de embarcações"
  },
  "3317102": {
    "description": "Manutenção e reparação de embarcações para esporte e lazer",
    "class_description": "Manutenção e reparação de embarcações"
  },
  "3319800": {
    "description": "Manutenção e reparação de equipamentos e produtos não especificados anteriormente",
    "class_description": "Manutenção e reparação de equipamentos e produtos não especificados anteriormente"
  },
  "3321000": {
    "description": "Instalação de máquinas e equipamentos industriais",
    "class_description": "Instalação de máquinas e equipamentos industriais"
  },
  "3329501": {
    "description": "Serviços de montagem de móveis de qualquer material",
    "class_description": "Instalação de equipamentos não especificados anteriormente"
  },
  "3329599": {
    "description": "Instalação de outros equipamentos não especificados anteriormente",
    "class_description": "Instalação de equipamentos não especificados anteriormente"
  },
  "3511501": {
    "description": "Geração de energia elétrica",
    "class_description": "Geração de energia elétrica"
  },
  "3511502": {
    "description": "Atividades de coordenação e controle da operação da geração e transmissão de energia elétrica",
    "class_description": "Geração de energia elétrica"
  },
  "3512300": {
    "description": "Transmissão de energia elétrica",
    "class_description": "Transmissão de energia elétrica"
  },
  "3513100": {
    "description": "Comércio atacadista de energia elétrica",
    "class_description": "Comércio atacadista de energia elétrica"
  },
  "3514000": {
    "description": "Distribuição de energia elétrica",
    "class_description": "Distribuição de energia elétrica"
  },
  "3520401": {
    "description": "Produção de gás; processamento de gás natural",
    "class_description": "Produção de gás; processamento de gás natural; distribuição de combustíveis gasosos por redes urbanas"
  },
  "3520402": {
    "description": "Distribuição de combustíveis gasosos por redes urbanas",
    "class_description": "Produção de gás; processamento de gás natural; distribuição de combustíveis gasosos por redes urbanas"
  },
  "3530100": {
    "description": "Produção e distribuição de vapor, água quente e ar condicionado",
    "class_description": "Produção e distribuição de vapor, água quente e ar\ncondicionado"
  },
  "3600601": {
    "description": "Captação, tratamento e distribuição de água",
    "class_description": "Captação, tratamento e distribuição de água"
  },
  "3600602": {
    "description": "Distribuição de água por caminhões",
    "class_description": "Captação, tratamento e distribuição de água"
  },
  "3701100": {
    "description": "Gestão de redes de esgoto",
    "class_description": "Gestão de redes de esgoto"
  },
  "3702900": {
    "description": "Atividades relacionadas a esgoto, exceto a gestão de redes",
    "class_description": "Atividades relacionadas a esgoto, exceto a gestão de redes"
  },
  "3811400": {
    "description": "Coleta de resíduos não perigosos",
    "class_description": "Coleta de resíduos não perigosos"
  },
  "3812200": {
    "description": "Coleta de resíduos perigosos",
    "class_description": "Coleta de resíduos perigosos"
  },
  "3821100": {
    "description": "Tratamento e disposição de resíduos não perigosos",
    "class_description": "Tratamento e disposição de resíduos não perigosos"
  },
  "3822000": {
    "description": "Tratamento e disposição de resíduos perigosos",
    "class_description": "Tratamento e disposição de resíduos perigosos"
  },
  "3831901": {
    "description": "Recuperação de sucatas de alumínio",
    "class_description": "Recuperação de materiais metálicos"
  },
  "3831999": {
    "description": "Recuperação de materiais metálicos, exceto alumínio",
    "class_description": "Recuperação de materiais metálicos"
  },
  "3832700": {
    "description": "Recuperação de materiais plásticos",
    "class_description": "Recuperação de materiais plásticos"
  },
  "3839401": {
    "description": "Usinas de compostagem",
    "class_description": "Recuperação de materiais não especificados anteriormente"
  },
  "3839499": {
    "description": "Recuperação de materiais não especificados anteriormente",
    "class_description": "Recuperação de materiais não especificados anteriormente"
  },
  "3900500": {
    "description": "Descontaminação e outros serviços de gestão de resíduos",
    "class_description": "Descontaminação e outros serviços de gestão de resíduos"
  },
  "4110700": {
    "description": "Incorporação de empreendimentos imobiliários",
    "class_description": "Incorporação de empreendimentos imobiliários"
  },
  "4120400": {
    "description": "Construção de edifícios",
    "class_description": "Construção de edifícios"
  },
  "4211101": {
    "description": "Construção de rodovias e ferrovias",
    "class_description": "Construção de rodovias e ferrovias"
  },
  "4211102": {
    "description": "Pintura para sinalização em pistas rodoviárias e aeroportos",
    "class_description": "Construção de rodovias e ferrovias"
  },
  "4212000": {
    "description": "Construção de obras de arte especiais",
    "class_description": "Construção de obras de arte especiais"
  },
  "4213800": {
    "description": "Obras de urbanização - ruas, praças e calçadas",
    "class_description": "Obras de urbanização - ruas, praças e calçadas"
  },
  "4221901": {
    "description": "Construção de barragens e represas para geração de energia \nelétrica",
    "class_description": "Obras para geração e distribuição de energia elétrica e para telecomunicações"
  },
  "4221902": {
    "description": "Construção de estações e redes de distribuição de energia elétrica",
    "class_description": "Obras para geração e distribuição de energia elétrica e para telecomunicações"
  },
  "4221903": {
    "description": "Manutenção de redes de distribuição de energia elétrica",
    "class_description": "Obras para geração e distribuição de energia elétrica e para telecomunicações"
  },
  "4221904": {
    "description": "Construção de estações e redes de telecomunicações",
    "class_description": "Obras para geração e distribuição de energia elétrica e para telecomunicações"
  },
  "4221905": {
    "description": "Manutenção de estações e redes de telecomunicações",
    "class_description": "Obras para geração e distribuição de energia elétrica e para telecomunicações"
  },
  "4222701": {
    "description": "Construção de redes de abastecimento de água, coleta de esgoto e construções correlatas, exceto obras de irrigação",
    "class_description": "Construção de redes de abastecimento de água, coleta de esgoto e construções correlatas"
  },
  "4222702": {
    "description": "Obras de irrigação",
    "class_description": "Construção de redes de abastecimento de água, coleta de esgoto e construções correlatas"
  },
  "4223500": {
    "description": "Construção de redes de transportes por dutos, exceto para água e esgoto",
    "class_description": "Construção de redes de transportes por dutos, exceto para água e esgoto"
  },
  "4291000": {
    "description": "Obras portuárias, marítimas e fluviais",
    "class_description": "Obras portuárias, marítimas e fluviais"
  },
  "4292801": {
    "description": "Montagem de estruturas metálicas",
    "class_description": "Montagem de instalações industriais e de estruturas metálicas"
  },
  "4292802": {
    "description": "Obras de montagem industrial",
    "class_description": "Montagem de instalações industriais e de estruturas metálicas"
  },
  "4299501": {
    "description": "Construção de instalações esportivas e recreativas",
    "class_description": "Obras de engenharia civil não especificadas anteriormente"
  },
  "4299599": {
    "description": "Outras obras de engenharia civil não especificadas anteriormente",
    "class_description": "Obras de engenharia civil não especificadas anteriormente"
  },
  "4311801": {
    "description": "Demolição de edifícios e outras estruturas",
    "class_description": "Demolição e preparação de canteiros de obras"
  },
  "4311802": {
    "description": "Preparação de canteiro e limpeza de terreno",
    "class_description": "Demolição e preparação de canteiros de obras"
  },
  "4312600": {
    "description": "Perfurações e sondagens",
    "class_description": "Perfurações e sondagens"
  },
  "4313400": {
    "description": "Obras de terraplenagem",
    "class_description": "Obras de terraplenagem"
  },
  "4319300": {
    "description": "Serviços de preparação do terreno não especificados anteriormente",
    "class_description": "Serviços de preparação do terreno não especificados anteriormente"
  },
  "4321500": {
    "description": "Instalação e manutenção elétrica",
    "class_description": "Instalações elétricas"
  },
  "4322301": {
    "description": "Instalações hidráulicas, sanitárias e de gás",
    "class_description": "Instalações hidráulicas, de sistemas de ventilação e\nrefrigeração"
  },
  "4322302": {
    "description": "Instalação e manutenção de sistemas centrais de ar condicionado, de ventilação e refrigeração",
    "class_description": "Instalações hidráulicas, de sistemas de ventilação e\nrefrigeração"
  },
  "4322303": {
    "description": "Instalações de sistema de prevenção contra incêndio",
    "class_description": "Instalações hidráulicas, de sistemas de ventilação e\nrefrigeração"
  },
  "4329101": {
    "description": "Instalação de painéis publicitários",
    "class_description": "Obras de instalações em construções não especificadas anteriormente"
  },
  "4329102": {
    "description": "Instalação de equipamentos para orientação à navegação marítima, fluvial e lacustre",
    "class_description": "Obras de instalações em construções não especificadas anteriormente"
  },
  "4329103": {
    "description": "Instalação, manutenção e reparação de elevadores, escadas e esteiras rolantes",
    "class_description": "Obras de instalações em construções não especificadas anteriormente"
  },
  "4329104": {
    "description": "Montagem e instalação de sistemas e equipamentos de iluminação e sinalização em vias públicas, portos e aeroportos",
    "class_description": "Obras de instalações em construções não especificadas anteriormente"
  },
  "4329105": {
    "description": "Tratamentos térmicos, acústicos ou de vibração",
    "class_description": "Obras de instalações em construções não especificadas anteriormente"
  },
  "4329199": {
    "description": "Outras obras de instalações em construções não especificadas anteriormente",
    "class_description": "Obras de instalações em construções não especificadas anteriormente"
  },
  "4330401": {
    "description": "Impermeabilização em obras de engenharia civil",
    "class_description": "Obras de acabamento"
  },
  "4330402": {
    "description": "Instalação de portas, janelas, tetos, divisórias e armários embutidos de qualquer material",
    "class_description": "Obras de acabamento"
  },
  "4330403": {
    "description": "Obras de acabamento em gesso e estuque",
    "class_description": "Obras de acabamento"
  },
  "4330404": {
    "description": "Serviços de pintura de edifícios em geral",
    "class_description": "Obras de acabamento"
  },
  "4330405": {
    "description": "Aplicação de revestimentos e de resinas em interiores e exteriores",
    "class_description": "Obras de acabamento"
  },
  "4330499": {
    "description": "Outras obras de acabamento da construção",
    "class_description": "Obras de acabamento"
  },
  "4391600": {
    "description": "Obras de fundações",
    "class_description": "Obras de fundações"
  },
  "4399101": {
    "description": "Administração de obras",
    "class_description": "Serviços especializados para construção não especificados anteriormente"
  },
  "4399102": {
    "description": "Montagem e desmontagem de andaimes e outras estruturas temporárias",
    "class_description": "Serviços especializados para construção não especificados anteriormente"
  },
  "4399103": {
    "description": "Obras de alvenaria",
    "class_description": "Serviços especializados para construção não especificados anteriormente"
  },
  "4399104": {
    "description": "Serviços de operação e fornecimento de equipamentos para transporte e elevação de cargas e pessoas para uso em obras",
    "class_description": "Serviços especializados para construção não especificados anteriormente"
  },
  "4399105": {
    "description": "Perfuração e construção de poços de água",
    "class_description": "Serviços especializados para construção não especificados anteriormente"
  },
  "4399199": {
    "description": "Serviços especializados para construção não especificados anteriormente",
    "class_description": "Serviços especializados para construção não especificados anteriormente"
  },
  "4511101": {
    "description": "Comércio a varejo de automóveis, camionetas e utilitários novos",
    "class_description": "Comércio a varejo e por atacado de veículos automotores"
  },
  "4511102": {
    "description": "Comércio a varejo de automóveis, camionetas e utilitários usados",
    "class_description": "Comércio a varejo e por atacado de veículos automotores"
  },
  "4511103": {
    "description": "Comércio por atacado de automóveis, camionetas e utilitários novos e usados",
    "class_description": "Comércio a varejo e por atacado de veículos automotores"
  },
  "4511104": {
    "description": "Comércio por atacado de caminhões novos e usados",
    "class_description": "Comércio a varejo e por atacado de veículos automotores"
  },
  "4511105": {
    "description": "Comércio por atacado de reboques e semireboques novos e usados",
    "class_description": "Comércio a varejo e por atacado de veículos automotores"
  },
  "4511106": {
    "description": "Comércio por atacado de ônibus e micro-ônibus novos e usados",
    "class_description": "Comércio a varejo e por atacado de veículos automotores"
  },
  "4512901": {
    "description": "Representantes comerciais e agentes do comércio de veículos automotores",
    "class_description": "Representantes comerciais e agentes do comércio de veículos automotores"
  },
  "4512902": {
    "description": "Comércio sob consignação de veículos automotores",
    "class_description": "Representantes comerciais e agentes do comércio de veículos automotores"
  },
  "4520001": {
    "description": "Serviços de manutenção e reparação mecânica de veículos automotores",
    "class_description": "Manutenção e reparação de veículos automotores"
  },
  "4520002": {
    "description": "Serviços de lanternagem ou funilaria e pintura de veículos automotores",
    "class_description": "Manutenção e reparação de veículos automotores"
  },
  "4520003": {
    "description": "Serviços de manutenção e reparação elétrica de veículos automotores",
    "class_description": "Manutenção e reparação de veículos automotores"
  },
  "4520004": {
    "description": "Serviços de alinhamento e balanceamento de veículos automotores",
    "class_description": "Manutenção e reparação de veículos automotores"
  },
  "4520005": {
    "description": "Serviços de lavagem, lubrificação e polimento de veículos automotores",
    "class_description": "Manutenção e reparação de veículos automotores"
  },
  "4520006": {
    "description": "Serviços de borracharia para veículos automotores",
    "class_description": "Manutenção e reparação de veículos automotores"
  },
  "4520007": {
    "description": "Serviços de instalação, manutenção e reparação de acessórios para veículos automotores",
    "class_description": "Manutenção e reparação de veículos automotores"
  },
  "4520008": {
    "description": "Serviços de capotaria",
    "class_description": "Manutenção e reparação de veículos automotores"
  },
  "4530701": {
    "description": "Comércio por atacado de peças e acessórios novos para veículos automotores",
    "class_description": "Comércio de peças e acessórios para veículos automotores"
  },
  "4530702": {
    "description": "Comércio por atacado de pneumáticos e câmaras-de-ar",
    "class_description": "Comércio de peças e acessórios para veículos automotores"
  },
  "4530703": {
    "description": "Comércio a varejo de peças e acessórios novos para veículos automotores",
    "class_description": "Comércio de peças e acessórios para veículos automotores"
  },
  "4530704": {
    "description": "Comércio a varejo de peças e acessórios usados para veículos automotores",
    "class_description": "Comércio de peças e acessórios para veículos automotores"
  },
  "4530705": {
    "description": "Comércio a varejo de pneumáticos e câmaras-de-ar",
    "class_description": "Comércio de peças e acessórios para veículos automotores"
  },
  "4530706": {
    "description": "Representantes comerciais e agentes do comércio de peças e acessórios novos e usados para veículos automotores",
    "class_description": "Comércio de peças e acessórios para veículos automotores"
  },
  "4541201": {
    "description": "Comércio por atacado de motocicletas e motonetas",
    "class_description": "Comércio por atacado e a varejo de motocicletas, peças e acessórios"
  },
  "4541202": {
    "description": "Comércio por atacado de peças e acessórios para motocicletas e motonetas",
    "class_description": "Comércio por atacado e a varejo de motocicletas, peças e acessórios"
  },
  "4541203": {
    "description": "Comércio a varejo de motocicletas e motonetas novas",
    "class_description": "Comércio por atacado e a varejo de motocicletas, peças e acessórios"
  },
  "4541204": {
    "description": "Comércio a varejo de motocicletas e motonetas usadas",
    "class_description": "Comércio por atacado e a varejo de motocicletas, peças e acessórios"
  },
  "4541206": {
    "description": "Comércio a varejo de peças e acessórios novos para motocicletas e motonetas",
    "class_description": "Comércio por atacado e a varejo de motocicletas, peças e acessórios"
  },
  "4541207": {
    "description": "Comércio a varejo de peças e acessórios usados para motocicletas e motonetas",
    "class_description": "Comércio por atacado e a varejo de motocicletas, peças e acessórios"
  },
  "4542101": {
    "description": "Representantes comerciais e agentes do comércio de motocicletas e motonetas, peças e acessórios",
    "class_description": "Representantes comerciais e agentes do comércio de motocicletas, peças e acessórios"
  },
  "4542102": {
    "description": "Comércio sob consignação de motocicletas e motonetas",
    "class_description": "Representantes comerciais e agentes do comércio de motocicletas, peças e acessórios"
  },
  "4543900": {
    "description": "Manutenção e reparação de motocicletas e motonetas",
    "class_description": "Manutenção e reparação de motocicletas"
  },
  "4611700": {
    "description": "Representantes comerciais e agentes do comércio de matérias-primas agrícolas e animais vivos",
    "class_description": "Representantes comerciais e agentes do comércio de matérias-primas agrícolas e animais vivos"
  },
  "4612500": {
    "description": "Representantes comerciais e agentes do comércio de combustíveis, minerais, produtos siderúrgicos e químicos",
    "class_description": "Representantes comerciais e agentes do comércio de combustíveis, minerais, produtos siderúrgicos e químicos"
  },
  "4613300": {
    "description": "Representantes comerciais e agentes do comércio de madeira, material de construção e ferragens",
    "class_description": "Representantes comerciais e agentes do comércio de madeira, material de construção e ferragens"
  },
  "4614100": {
    "description": "Representantes comerciais e agentes do comércio de máquinas, equipamentos, embarcações e aeronaves",
    "class_description": "Representantes comerciais e agentes do comércio de máquinas, equipamentos, embarcações e aeronaves"
  },
  "4615000": {
    "description": "Representantes comerciais e agentes do comércio de eletrodomésticos, móveis e artigos de uso doméstico",
    "class_description": "Representantes comerciais e agentes do comércio de eletrodomésticos, móveis e artigos de uso doméstico"
  },
  "4616800": {
    "description": "Representantes comerciais e agentes do comércio de têxteis, vestuário, calçados e artigos de viagem",
    "class_description": "Representantes comerciais e agentes do comércio de têxteis, vestuário, calçados e artigos de viagem"
  },
  "4617600": {
    "description": "Representantes comerciais e agentes do comércio de produtos alimentícios, bebidas e fumo",
    "class_description": "Representantes comerciais e agentes do comércio de produtos alimentícios, bebidas e fumo"
  },
  "4618401": {
    "description": "Representantes comerciais e agentes do comércio de medicamentos, cosméticos e produtos de perfumaria",
    "class_description": "Representantes comerciais e agentes do comércio especializado em produtos não especificados anteriormente"
  },
  "4618402": {
    "description": "Representantes comerciais e agentes do comércio de instrumentos e materiais odonto-médico-hospitalares",
    "class_description": "Representantes comerciais e agentes do comércio especializado em produtos não especificados anteriormente"
  },
  "4618403": {
    "description": "Representantes comerciais e agentes do comércio de jornais, revistas e outras publicações",
    "class_description": "Representantes comerciais e agentes do comércio especializado em produtos não especificados anteriormente"
  },
  "4618499": {
    "description": "Outros representantes comerciais e agentes do comércio especializado em produtos não especificados anteriormente",
    "class_description": "Representantes comerciais e agentes do comércio especializado em produtos não especificados anteriormente"
  },
  "4619200": {
    "description": "Representantes comerciais e agentes do comércio de mercadorias em geral não especializado",
    "class_description": "Representantes comerciais e agentes do comércio de mercadorias em geral não especializado"
  },
  "4621400": {
    "description": "Comércio atacadista de café em grão",
    "class_description": "Comércio atacadista de café em grão"
  },
  "4622200": {
    "description": "Comércio atacadista de soja",
    "class_description": "Comércio atacadista de soja"
  },
  "4623101": {
    "description": "Comércio atacadista de animais vivos",
    "class_description": "Comércio atacadista de animais vivos, alimentos para animais e matérias-primas agrícolas, exceto café e soja"
  },
  "4623102": {
    "description": "Comércio atacadista de couros, lãs, peles e outros subprodutos não comestíveis de origem animal",
    "class_description": "Comércio atacadista de animais vivos, alimentos para animais e matérias-primas agrícolas, exceto café e soja"
  },
  "4623103": {
    "description": "Comércio atacadista de algodão",
    "class_description": "Comércio atacadista de animais vivos, alimentos para animais e matérias-primas agrícolas, exceto café e soja"
  },
  "4623104": {
    "description": "Comércio atacadista de fumo em folha não beneficiado",
    "class_description": "Comércio atacadista de animais vivos, alimentos para animais e matérias-primas agrícolas, exceto café e soja"
  },
  "4623105": {
    "description": "Comércio atacadista de cacau",
    "class_description": "Comércio atacadista de animais vivos, alimentos para animais e matérias-primas agrícolas, exceto café e soja"
  },
  "4623106": {
    "description": "Comércio atacadista de sementes, flores, plantas e gramas",
    "class_description": "Comércio atacadista de animais vivos, alimentos para animais e matérias-primas agrícolas, exceto café e soja"
  },
  "4623107": {
    "description": "Comércio atacadista de sisal",
    "class_description": "Comércio atacadista de animais vivos, alimentos para animais e matérias-primas agrícolas, exceto café e soja"
  },
  "4623108": {
    "description": "Comércio atacadista de matérias-primas agrícolas com atividade de fracionamento e acondicionamento associada",
    "class_description": "Comércio atacadista de animais vivos, alimentos para animais e matérias-primas agrícolas, exceto café e soja"
  },
  "4623109": {
    "description": "Comércio atacadista de alimentos para animais",
    "class_description": "Comércio atacadista de animais vivos, alimentos para animais e matérias-primas agrícolas, exceto café e soja"
  },
  "4623199": {
    "description": "Comércio atacadista de matérias-primas agrícolas não especificadas anteriormente",
    "class_description": "Comércio atacadista de animais vivos, alimentos para animais e matérias-primas agrícolas, exceto café e soja"
  },
  "4631100": {
    "description": "Comércio atacadista de leite e laticínios",
    "class_description": "Comércio atacadista de leite e laticínios"
  },
  "4632001": {
    "description": "Comércio atacadista de cereais e leguminosas beneficiados",
    "class_description": "Comércio atacadista de cereais e leguminosas beneficiados, farinhas, amidos e féculas"
  },
  "4632002": {
    "description": "Comércio atacadista de farinhas, amidos e féculas",
    "class_description": "Comércio atacadista de cereais e leguminosas beneficiados, farinhas, amidos e féculas"
  },
  "4632003": {
    "description": "Comércio atacadista de cereais e leguminosas beneficiados, farinhas, amidos e féculas, com atividade de fracionamento e acondicionamento associada",
    "class_description": "Comércio atacadista de cereais e leguminosas beneficiados, farinhas, amidos e féculas"
  },
  "4633801": {
    "description": "Comércio atacadista de frutas, verduras, raízes, tubérculos, hortaliças e legumes frescos",
    "class_description": "Comércio atacadista de hortifrutigranjeiros"
  },
  "4633802": {
    "description": "Comércio atacadista de aves vivas e ovos",
    "class_description": "Comércio atacadista de hortifrutigranjeiros"
  },
  "4633803": {
    "description": "Comércio atacadista de coelhos e outros pequenos animais vivos para alimentação",
    "class_description": "Comércio atacadista de hortifrutigranjeiros"
  },
  "4634601": {
    "description": "Comércio atacadista de carnes bovinas e suínas e derivados",
    "class_description": "Comércio atacadista de carnes, produtos da carne e pescado"
  },
  "4634602": {
    "description": "Comércio atacadista de aves abatidas e derivados",
    "class_description": "Comércio atacadista de carnes, produtos da carne e pescado"
  },
  "4634603": {
    "description": "Comércio atacadista de pescados e frutos do mar",
    "class_description": "Comércio atacadista de carnes, produtos da carne e pescado"
  },
  "4634699": {
    "description": "Comércio atacadista de carnes e derivados de outros animais",
    "class_description": "Comércio atacadista de carnes, produtos da carne e pescado"
  },
  "4635401": {
    "description": "Comércio atacadista de água mineral",
    "class_description": "Comércio atacadista de bebidas"
  },
  "4635402": {
    "description": "Comércio atacadista de cerveja, chope e refrigerante",
    "class_description": "Comércio atacadista de bebidas"
  },
  "4635403": {
    "description": "Comércio atacadista de bebidas com atividade de fracionamento e acondicionamento associada",
    "class_description": "Comércio atacadista de bebidas"
  },
  "4635499": {
    "description": "Comércio atacadista de bebidas não especificadas anteriormente",
    "class_description": "Comércio atacadista de bebidas"
  },
  "4636201": {
    "description": "Comércio atacadista de fumo beneficiado",
    "class_description": "Comércio atacadista de produtos do fumo"
  },
  "4636202": {
    "description": "Comércio atacadista de cigarros, cigarrilhas e charutos",
    "class_description": "Comércio atacadista de produtos do fumo"
  },
  "4637101": {
    "description": "Comércio atacadista de café torrado, moído e solúvel",
    "class_description": "Comércio atacadista especializado em produtos alimentícios não especificados anteriormente"
  },
  "4637102": {
    "description": "Comércio atacadista de açúcar",
    "class_description": "Comércio atacadista especializado em produtos alimentícios não especificados anteriormente"
  },
  "4637103": {
    "description": "Comércio atacadista de óleos e gorduras",
    "class_description": "Comércio atacadista especializado em produtos alimentícios não especificados anteriormente"
  },
  "4637104": {
    "description": "Comércio atacadista de pães, bolos, biscoitos e similares",
    "class_description": "Comércio atacadista especializado em produtos alimentícios não especificados anteriormente"
  },
  "4637105": {
    "description": "Comércio atacadista de massas alimentícias",
    "class_description": "Comércio atacadista especializado em produtos alimentícios não especificados anteriormente"
  },
  "4637106": {
    "description": "Comércio atacadista de sorvetes",
    "class_description": "Comércio atacadista especializado em produtos alimentícios não especificados anteriormente"
  },
  "4637107": {
    "description": "Comércio atacadista de chocolates, confeitos, balas, bombons e semelhantes",
    "class_description": "Comércio atacadista especializado em produtos alimentícios não especificados anteriormente"
  },
  "4637199": {
    "description": "Comércio atacadista especializado em outros produtos alimentícios não especificados anteriormente",
    "class_description": "Comércio atacadista especializado em produtos alimentícios não especificados anteriormente"
  },
  "4639701": {
    "description": "Comércio atacadista de produtos alimentícios em geral",
    "class_description": "Comércio atacadista de produtos alimentícios em geral"
  },
  "4639702": {
    "description": "Comércio atacadista de produtos alimentícios em geral, com atividade de fracionamento e acondicionamento associada",
    "class_description": "Comércio atacadista de produtos alimentícios em geral"
  },
  "4641901": {
    "description": "Comércio atacadista de tecidos",
    "class_description": "Comércio atacadista de tecidos, artefatos de tecidos e de armarinho"
  },
  "4641902": {
    "description": "Comércio atacadista de artigos de cama, mesa e banho",
    "class_description": "Comércio atacadista de tecidos, artefatos de tecidos e de armarinho"
  },
  "4641903": {
    "description": "Comércio atacadista de artigos de armarinho",
    "class_description": "Comércio atacadista de tecidos, artefatos de tecidos e de armarinho"
  },
  "4642701": {
    "description": "Comércio atacadista de artigos do vestuário e acessórios, exceto profissionais e de segurança",
    "class_description": "Comércio atacadista de artigos do vestuário e acessórios"
  },
  "4642702": {
    "description": "Comércio atacadista de roupas e acessórios para uso profissional e de segurança do trabalho",
    "class_description": "Comércio atacadista de artigos do vestuário e acessórios"
  },
  "4643501": {
    "description": "Comércio atacadista de calçados",
    "class_description": "Comércio atacadista de calçados e artigos de viagem"
  },
  "4643502": {
    "description": "Comércio atacadista de bolsas, malas e artigos de viagem",
    "class_description": "Comércio atacadista de calçados e artigos de viagem"
  },
  "4644301": {
    "description": "Comércio atacadista de medicamentos e drogas de uso humano",
    "class_description": "Comércio atacadista de produtos farmacêuticos para uso humano e veterinário"
  },
  "4644302": {
    "description": "Comércio atacadista de medicamentos e drogas de uso veterinário",
    "class_description": "Comércio atacadista de produtos farmacêuticos para uso humano e veterinário"
  },
  "4645101": {
    "description": "Comércio atacadista de instrumentos e materiais para uso médico, cirúrgico, hospitalar e de laboratórios",
    "class_description": "Comércio atacadista de instrumentos e materiais para uso médico, cirúrgico, ortopédico e odontológico"
  },
  "4645102": {
    "description": "Comércio atacadista de próteses e artigos de ortopedia",
    "class_description": "Comércio atacadista de instrumentos e materiais para uso médico, cirúrgico, ortopédico e odontológico"
  },
  "4645103": {
    "description": "Comércio atacadista de produtos odontológicos",
    "class_description": "Comércio atacadista de instrumentos e materiais para uso médico, cirúrgico, ortopédico e odontológico"
  },
  "4646001": {
    "description": "Comércio atacadista de cosméticos e produtos de perfumaria",
    "class_description": "Comércio atacadista de cosméticos, produtos de perfumaria e de higiene pessoal"
  },
  "4646002": {
    "description": "Comércio atacadista de produtos de higiene pessoal",
    "class_description": "Comércio atacadista de cosméticos, produtos de perfumaria e de higiene pessoal"
  },
  "4647801": {
    "description": "Comércio atacadista de artigos de escritório e de papelaria",
    "class_description": "Comércio atacadista de artigos de escritório e de papelaria; livros, jornais e outras publicações"
  },
  "4647802": {
    "description": "Comércio atacadista de livros, jornais e outras publicações",
    "class_description": "Comércio atacadista de artigos de escritório e de papelaria; livros, jornais e outras publicações"
  },
  "4649401": {
    "description": "Comércio atacadista de equipamentos elétricos de uso pessoal e doméstico",
    "class_description": "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
  },
  "4649402": {
    "description": "Comércio atacadista de aparelhos eletrônicos de uso pessoal e doméstico",
    "class_description": "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
  },
  "4649403": {
    "description": "Comércio atacadista de bicicletas, triciclos e outros veículos recreativos",
    "class_description": "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
  },
  "4649404": {
    "description": "Comércio atacadista de móveis e artigos de colchoaria",
    "class_description": "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
  },
  "4649405": {
    "description": "Comércio atacadista de artigos de tapeçaria; persianas e cortinas",
    "class_description": "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
  },
  "4649406": {
    "description": "Comércio atacadista de lustres, luminárias e abajures",
    "class_description": "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
  },
  "4649407": {
    "description": "Comércio atacadista de filmes, CDs, DVDs, fitas e discos",
    "class_description": "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
  },
  "4649408": {
    "description": "Comércio atacadista de produtos de higiene, limpeza e conservação domiciliar",
    "class_description": "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
  },
  "4649409": {
    "description": "Comércio atacadista de produtos de higiene, limpeza e conservação domiciliar, com atividade de fracionamento e acondicionamento associada",
    "class_description": "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
  },
  "4649410": {
    "description": "Comércio atacadista de jóias, relógios e bijuterias, inclusive pedras preciosas e semipreciosas lapidadas",
    "class_description": "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
  },
  "4649499": {
    "description": "Comércio atacadista de outros equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente",
    "class_description": "Comércio atacadista de equipamentos e artigos de uso pessoal e doméstico não especificados anteriormente"
  },
  "4651601": {
    "description": "Comércio atacadista de equipamentos de informática",
    "class_description": "Comércio atacadista de computadores, periféricos e suprimentos de informática"
  },
  "4651602": {
    "description": "Comércio atacadista de suprimentos para informática",
    "class_description": "Comércio atacadista de computadores, periféricos e suprimentos de informática"
  },
  "4652400": {
    "description": "Comércio atacadista de componentes eletrônicos e equipamentos de telefonia e comunicação",
    "class_description": "Comércio atacadista de componentes eletrônicos e equipamentos de telefonia e comunicação"
  },
  "4661300": {
    "description": "Comércio atacadista de máquinas, aparelhos e equipamentos para uso agropecuário; partes e peças",
    "class_description": "Comércio atacadista de máquinas, aparelhos e equipamentos para uso agropecuário; partes e peças"
  },
  "4662100": {
    "description": "Comércio atacadista de máquinas, equipamentos para terraplenagem, mineração e construção; partes e peças",
    "class_description": "Comércio atacadista de máquinas, equipamentos para terraplenagem, mineração e construção; partes e peças"
  },
  "4663000": {
    "description": "Comércio atacadista de máquinas e equipamentos para uso industrial; partes e peças",
    "class_description": "Comércio atacadista de máquinas e equipamentos para uso industrial; partes e peças"
  },
  "4664800": {
    "description": "Comércio atacadista de máquinas, aparelhos e equipamentos para uso odonto-médico-hospitalar; partes e peças",
    "class_description": "Comércio atacadista de máquinas, aparelhos e equipamentos para uso odonto-médico-hospitalar; partes e peças"
  },
  "4665600": {
    "description": "Comércio atacadista de máquinas e equipamentos para uso comercial; partes e peças",
    "class_description": "Comércio atacadista de máquinas e equipamentos para uso comercial; partes e peças"
  },
  "4669901": {
    "description": "Comércio atacadista de bombas e compressores; partes e peças",
    "class_description": "Comércio atacadista de máquinas, aparelhos e equipamentos não especificados anteriormente; partes e peças"
  },
  "4669999": {
    "description": "Comércio atacadista de outras máquinas e equipamentos não especificados anteriormente; partes e peças",
    "class_description": "Comércio atacadista de máquinas, aparelhos e equipamentos não especificados anteriormente; partes e peças"
  },
  "4671100": {
    "description": "Comércio atacadista de madeira e produtos derivados",
    "class_description": "Comércio atacadista de madeira e produtos derivados"
  },
  "4672900": {
    "description": "Comércio atacadista de ferragens e ferramentas",
    "class_description": "Comércio atacadista de ferragens e ferramentas"
  },
  "4673700": {
    "description": "Comércio atacadista de material elétrico",
    "class_description": "Comércio atacadista de material elétrico"
  },
  "4674500": {
    "description": "Comércio atacadista de cimento",
    "class_description": "Comércio atacadista de cimento"
  },
  "4679601": {
    "description": "Comércio atacadista de tintas, vernizes e similares",
    "class_description": "Comércio atacadista especializado de materiais de construção não especificados anteriormente e de materiais de construção em geral"
  },
  "4679602": {
    "description": "Comércio atacadista de mármores e granitos",
    "class_description": "Comércio atacadista especializado de materiais de construção não especificados anteriormente e de materiais de construção em geral"
  },
  "4679603": {
    "description": "Comércio atacadista de vidros, espelhos e vitrais",
    "class_description": "Comércio atacadista especializado de materiais de construção não especificados anteriormente e de materiais de construção em geral"
  },
  "4679604": {
    "description": "Comércio atacadista especializado de materiais de construção não especificados anteriormente",
    "class_description": "Comércio atacadista especializado de materiais de construção não especificados anteriormente e de materiais de construção em geral"
  },
  "4679699": {
    "description": "Comércio atacadista de materiais de construção em geral",
    "class_description": "Comércio atacadista especializado de materiais de construção não especificados anteriormente e de materiais de construção em geral"
  },
  "4681801": {
    "description": "Comércio atacadista de álcool carburante, biodiesel, gasolina e demais derivados de petróleo, exceto lubrificantes, não realizado por transportador retalhista (TRR)",
    "class_description": "Comércio atacadista de combustíveis sólidos, líquidos e gasosos, exceto gás natural e GLP"
  },
  "4681802": {
    "description": "Comércio atacadista de combustíveis realizado por transportador retalhista (TRR)",
    "class_description": "Comércio atacadista de combustíveis sólidos, líquidos e gasosos, exceto gás natural e GLP"
  },
  "4681803": {
    "description": "Comércio atacadista de combustíveis de origem vegetal, exceto álcool carburante",
    "class_description": "Comércio atacadista de combustíveis sólidos, líquidos e gasosos, exceto gás natural e GLP"
  },
  "4681804": {
    "description": "Comércio atacadista de combustíveis de origem mineral em bruto",
    "class_description": "Comércio atacadista de combustíveis sólidos, líquidos e gasosos, exceto gás natural e GLP"
  },
  "4681805": {
    "description": "Comércio atacadista de lubrificantes",
    "class_description": "Comércio atacadista de combustíveis sólidos, líquidos e gasosos, exceto gás natural e GLP"
  },
  "4682600": {
    "description": "Comércio atacadista de gás liquefeito de petróleo (GLP)",
    "class_description": "Comércio atacadista de gás liquefeito de petróleo (GLP)"
  },
  "4683400": {
    "description": "Comércio atacadista de defensivos agrícolas, adubos, fertilizantes e corretivos do solo",
    "class_description": "Comércio atacadista de defensivos agrícolas, adubos, fertilizantes e corretivos do solo"
  },
  "4684201": {
    "description": "Comércio atacadista de resinas e elastômeros",
    "class_description": "Comércio atacadista de produtos químicos e petroquímicos, exceto agroquímicos"
  },
  "4684202": {
    "description": "Comércio atacadista de solventes",
    "class_description": "Comércio atacadista de produtos químicos e petroquímicos, exceto agroquímicos"
  },
  "4684299": {
    "description": "Comércio atacadista de outros produtos químicos e petroquímicos não especificados anteriormente",
    "class_description": "Comércio atacadista de produtos químicos e petroquímicos, exceto agroquímicos"
  },
  "4685100": {
    "description": "Comércio atacadista de produtos siderúrgicos e metalúrgicos, exceto para construção",
    "class_description": "Comércio atacadista de produtos siderúrgicos e metalúrgicos, exceto para construção"
  },
  "4686901": {
    "description": "Comércio atacadista de papel e papelão em bruto",
    "class_description": "Comércio atacadista de papel e papelão em bruto e de embalagens"
  },
  "4686902": {
    "description": "Comércio atacadista de embalagens",
    "class_description": "Comércio atacadista de papel e papelão em bruto e de embalagens"
  },
  "4687701": {
    "description": "Comércio atacadista de resíduos de papel e papelão",
    "class_description": "Comércio atacadista de resíduos e sucatas"
  },
  "4687702": {
    "description": "Comércio atacadista de resíduos e sucatas não metálicos, exceto de papel e papelão",
    "class_description": "Comércio atacadista de resíduos e sucatas"
  },
  "4687703": {
    "description": "Comércio atacadista de resíduos e sucatas metálicos",
    "class_description": "Comércio atacadista de resíduos e sucatas"
  },
  "4689301": {
    "description": "Comércio atacadista de produtos da extração mineral, exceto combustíveis",
    "class_description": "Comércio atacadista especializado de outros produtos intermediários não especificados anteriormente"
  },
  "4689302": {
    "description": "Comércio atacadista de fios e fibras beneficiados",
    "class_description": "Comércio atacadista especializado de outros produtos intermediários não especificados anteriormente"
  },
  "4689399": {
    "description": "Comércio atacadista especializado em outros produtos intermediários não especificados anteriormente",
    "class_description": "Comércio atacadista especializado de outros produtos intermediários não especificados anteriormente"
  },
  "4691500": {
    "description": "Comércio atacadista de mercadorias em geral, com predominância de produtos alimentícios",
    "class_description": "Comércio atacadista de mercadorias em geral, com predominância de produtos alimentícios"
  },
  "4692300": {
    "description": "Comércio atacadista de mercadorias em geral, com predominância de insumos agropecuários",
    "class_description": "Comércio atacadista de mercadorias em geral, com predominância de insumos agropecuários"
  },
  "4693100": {
    "description": "Comércio atacadista de mercadorias em geral, sem predominância de alimentos ou de insumos agropecuários",
    "class_description": "Comércio atacadista de mercadorias em geral, sem predominância de alimentos ou de insumos agropecuários"
  },
  "4711301": {
    "description": "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - hipermercados",
    "class_description": "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - hipermercados e supermercados"
  },
  "4711302": {
    "description": "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - supermercados",
    "class_description": "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - hipermercados e supermercados"
  },
  "4712100": {
    "description": "Comércio varejista de mercadorias em geral, com predominância de produtos alimentícios - minimercados, mercearias e armazéns",
    "class_description": "Comércio varejista de mercadorias em geral, com\npredominância de produtos alimentícios - minimercados,\nmercearias e armazéns"
  },
  "4713002": {
    "description": "Lojas de variedades, exceto lojas de departamentos ou magazines",
    "class_description": "Comércio varejista de mercadorias em geral, sem predominância de produtos alimentícios"
  },
  "4713004": {
    "description": "Lojas de departamentos ou magazines, exceto lojas francas (Duty free)",
    "class_description": "Comércio varejista de mercadorias em geral, sem predominância de produtos alimentícios"
  },
  "4713005": {
    "description": "Lojas francas (Duty Free) de aeroportos, portos e em fronteiras terrestres",
    "class_description": "Comércio varejista de mercadorias em geral, sem predominância de produtos alimentícios"
  },
  "4721102": {
    "description": "Padaria e confeitaria com predominância de revenda",
    "class_description": "Comércio varejista de produtos de padaria, laticínio, doces, balas e semelhantes"
  },
  "4721103": {
    "description": "Comércio varejista de laticínios e frios",
    "class_description": "Comércio varejista de produtos de padaria, laticínio, doces, balas e semelhantes"
  },
  "4721104": {
    "description": "Comércio varejista de doces, balas, bombons e semelhantes",
    "class_description": "Comércio varejista de produtos de padaria, laticínio, doces, balas e semelhantes"
  },
  "4722901": {
    "description": "Comércio varejista de carnes - açougues",
    "class_description": "Comércio varejista de carnes e pescados - açougues e peixarias"
  },
  "4722902": {
    "description": "Peixaria",
    "class_description": "Comércio varejista de carnes e pescados - açougues e peixarias"
  },
  "4723700": {
    "description": "Comércio varejista de bebidas",
    "class_description": "Comércio varejista de bebidas"
  },
  "4724500": {
    "description": "Comércio varejista de hortifrutigranjeiros",
    "class_description": "Comércio varejista de hortifrutigranjeiros"
  },
  "4729601": {
    "description": "Tabacaria",
    "class_description": "Comércio varejista de produtos alimentícios em geral ou especializado em produtos alimentícios não especificados anteriormente; produtos do fumo"
  },
  "4729602": {
    "description": "Comércio varejista de mercadorias em lojas de conveniência",
    "class_description": "Comércio varejista de produtos alimentícios em geral ou especializado em produtos alimentícios não especificados anteriormente; produtos do fumo"
  },
  "4729699": {
    "description": "Comércio varejista de produtos alimentícios em geral ou especializado em produtos alimentícios não especificados anteriormente",
    "class_description": "Comércio varejista de produtos alimentícios em geral ou especializado em produtos alimentícios não especificados anteriormente; produtos do fumo"
  },
  "4731800": {
    "description": "Comércio varejista de combustíveis para veículos automotores",
    "class_description": "Comércio varejista de combustíveis para veículos automotores"
  },
  "4732600": {
    "description": "Comércio varejista de lubrificantes",
    "class_description": "Comércio varejista de lubrificantes"
  },
  "4741500": {
    "description": "Comércio varejista de tintas e materiais para pintura",
    "class_description": "Comércio varejista de tintas e materiais para pintura"
  },
  "4742300": {
    "description": "Comércio varejista de material elétrico",
    "class_description": "Comércio varejista de material elétrico"
  },
  "4743100": {
    "description": "Comércio varejista de vidros",
    "class_description": "Comércio varejista de vidros"
  },
  "4744001": {
    "description": "Comércio varejista de ferragens e ferramentas",
    "class_description": "Comércio varejista de ferragens, madeira e materiais de construção"
  },
  "4744002": {
    "description": "Comércio varejista de madeira e artefatos",
    "class_description": "Comércio varejista de ferragens, madeira e materiais de construção"
  },
  "4744003": {
    "description": "Comércio varejista de materiais hidráulicos",
    "class_description": "Comércio varejista de ferragens, madeira e materiais de construção"
  },
  "4744004": {
    "description": "Comércio varejista de cal, areia, pedra britada, tijolos e telhas",
    "class_description": "Comércio varejista de ferragens, madeira e materiais de construção"
  },
  "4744005": {
    "description": "Comércio varejista de materiais de construção não especificados anteriormente",
    "class_description": "Comércio varejista de ferragens, madeira e materiais de construção"
  },
  "4744006": {
    "description": "Comércio varejista de pedras para revestimento",
    "class_description": "Comércio varejista de ferragens, madeira e materiais de construção"
  },
  "4744099": {
    "description": "Comércio varejista de materiais de construção em geral",
    "class_description": "Comércio varejista de ferragens, madeira e materiais de construção"
  },
  "4751201": {
    "description": "Comércio varejista especializado de equipamentos e suprimentos de informática",
    "class_description": "Comércio varejista especializado de equipamentos e suprimentos de informática"
  },
  "4751202": {
    "description": "Recarga de cartuchos para equipamentos de informática",
    "class_description": "Comércio varejista especializado de equipamentos e suprimentos de informática"
  },
  "4752100": {
    "description": "Comércio varejista especializado de equipamentos de telefonia e comunicação",
    "class_description": "Comércio varejista especializado de equipamentos de telefonia e comunicação"
  },
  "4753900": {
    "description": "Comércio varejista especializado de eletrodomésticos e equipamentos de áudio e vídeo",
    "class_description": "Comércio varejista especializado de eletrodomésticos e equipamentos de áudio e vídeo"
  },
  "4754701": {
    "description": "Comércio varejista de móveis",
    "class_description": "Comércio varejista especializado de móveis, colchoaria e artigos de iluminação"
  },
  "4754702": {
    "description": "Comércio varejista de artigos de colchoaria",
    "class_description": "Comércio varejista especializado de móveis, colchoaria e artigos de iluminação"
  },
  "4754703": {
    "description": "Comércio varejista de artigos de iluminação",
    "class_description": "Comércio varejista especializado de móveis, colchoaria e artigos de iluminação"
  },
  "4755501": {
    "description": "Comércio varejista de tecidos",
    "class_description": "Comércio varejista especializado de tecidos e artigos de cama, mesa e banho"
  },
  "4755502": {
    "description": "Comercio varejista de artigos de armarinho",
    "class_description": "Comércio varejista especializado de tecidos e artigos de cama, mesa e banho"
  },
  "4755503": {
    "description": "Comercio varejista de artigos de cama, mesa e banho",
    "class_description": "Comércio varejista especializado de tecidos e artigos de cama, mesa e banho"
  },
  "4756300": {
    "description": "Comércio varejista especializado de instrumentos musicais e acessórios",
    "class_description": "Comércio varejista especializado de instrumentos musicais e acessórios"
  },
  "4757100": {
    "description": "Comércio varejista especializado de peças e acessórios para aparelhos eletroeletrônicos para uso doméstico, exceto informática e comunicação",
    "class_description": "Comércio varejista especializado de peças e acessórios para aparelhos eletroeletrônicos para uso doméstico, exceto informática e comunicação"
  },
  "4759801": {
    "description": "Comércio varejista de artigos de tapeçaria, cortinas e persianas",
    "class_description": "Comércio varejista de artigos de uso doméstico não especificados anteriormente"
  },
  "4759899": {
    "description": "Comércio varejista de outros artigos de uso doméstico não especificados anteriormente",
    "class_description": "Comércio varejista de artigos de uso doméstico não especificados anteriormente"
  },
  "4761001": {
    "description": "Comércio varejista de livros",
    "class_description": "Comércio varejista de livros, jornais, revistas e papelaria"
  },
  "4761002": {
    "description": "Comércio varejista de jornais e revistas",
    "class_description": "Comércio varejista de livros, jornais, revistas e papelaria"
  },
  "4761003": {
    "description": "Comércio varejista de artigos de papelaria",
    "class_description": "Comércio varejista de livros, jornais, revistas e papelaria"
  },
  "4762800": {
    "description": "Comércio varejista de discos, CDs, DVDs e fitas",
    "class_description": "Comércio varejista de discos, CDs, DVDs e fitas"
  },
  "4763601": {
    "description": "Comércio varejista de brinquedos e artigos recreativos",
    "class_description": "Comércio varejista de artigos recreativos e esportivos"
  },
  "4763602": {
    "description": "Comércio varejista de artigos esportivos",
    "class_description": "Comércio varejista de artigos recreativos e esportivos"
  },
  "4763603": {
    "description": "Comércio varejista de bicicletas e triciclos; peças e acessórios",
    "class_description": "Comércio varejista de artigos recreativos e esportivos"
  },
  "4763604": {
    "description": "Comércio varejista de artigos de caça, pesca e camping",
    "class_description": "Comércio varejista de artigos recreativos e esportivos"
  },
  "4763605": {
    "description": "Comércio varejista de embarcações e outros veículos recreativos; peças e acessórios",
    "class_description": "Comércio varejista de artigos recreativos e esportivos"
  },
  "4771701": {
    "description": "Comércio varejista de produtos farmacêuticos, sem manipulação de fórmulas",
    "class_description": "Comércio varejista de produtos farmacêuticos para uso humano e veterinário"
  },
  "4771702": {
    "description": "Comércio varejista de produtos farmacêuticos, com manipulação de fórmulas",
    "class_description": "Comércio varejista de produtos farmacêuticos para uso humano e veterinário"
  },
  "4771703": {
    "description": "Comércio varejista de produtos farmacêuticos homeopáticos",
    "class_description": "Comércio varejista de produtos farmacêuticos para uso humano e veterinário"
  },
  "4771704": {
    "description": "Comércio varejista de medicamentos veterinários",
    "class_description": "Comércio varejista de produtos farmacêuticos para uso humano e veterinário"
  },
  "4772500": {
    "description": "Comércio varejista de cosméticos, produtos de perfumaria e de higiene pessoal",
    "class_description": "Comércio varejista de cosméticos, produtos de perfumaria e de higiene pessoal"
  },
  "4773300": {
    "description": "Comércio varejista de artigos médicos e ortopédicos",
    "class_description": "Comércio varejista de artigos médicos e ortopédicos"
  },
  "4774100": {
    "description": "Comércio varejista de artigos de óptica",
    "class_description": "Comércio varejista de artigos de óptica"
  },
  "4781400": {
    "description": "Comércio varejista de artigos do vestuário e acessórios",
    "class_description": "Comércio varejista de artigos do vestuário e acessórios"
  },
  "4782201": {
    "description": "Comércio varejista de calçados",
    "class_description": "Comércio varejista de calçados e artigos de viagem"
  },
  "4782202": {
    "description": "Comércio varejista de artigos de viagem",
    "class_description": "Comércio varejista de calçados e artigos de viagem"
  },
  "4783101": {
    "description": "Comércio varejista de artigos de joalheria",
    "class_description": "Comércio varejista de jóias e relógios"
  },
  "4783102": {
    "description": "Comércio varejista de artigos de relojoaria",
    "class_description": "Comércio varejista de jóias e relógios"
  },
  "4784900": {
    "description": "Comércio varejista de gás liqüefeito de petróleo (GLP)",
    "class_description": "Comércio varejista de gás liqüefeito de petróleo (GLP)"
  },
  "4785701": {
    "description": "Comércio varejista de antiguidades",
    "class_description": "Comércio varejista de artigos usados"
  },
  "4785799": {
    "description": "Comércio varejista de outros artigos usados",
    "class_description": "Comércio varejista de artigos usados"
  },
  "4789001": {
    "description": "Comércio varejista de suvenires, bijuterias e artesanatos",
    "class_description": "Comércio varejista de outros produtos novos não especificados anteriormente"
  },
  "4789002": {
    "description": "Comércio varejista de plantas e flores naturais",
    "class_description": "Comércio varejista de outros produtos novos não especificados anteriormente"
  },
  "4789003": {
    "description": "Comércio varejista de objetos de arte",
    "class_description": "Comércio varejista de outros produtos novos não especificados anteriormente"
  },
  "4789004": {
    "description": "Comércio varejista de animais vivos e de artigos e alimentos para animais de estimação",
    "class_description": "Comércio varejista de outros produtos novos não especificados anteriormente"
  },
  "4789005": {
    "description": "Comércio varejista de produtos saneantes domissanitários",
    "class_description": "Comércio varejista de outros produtos novos não especificados anteriormente"
  },
  "4789006": {
    "description": "Comércio varejista de fogos de artifício e artigos pirotécnicos",
    "class_description": "Comércio varejista de outros produtos novos não especificados anteriormente"
  },
  "4789007": {
    "description": "Comércio varejista de equipamentos para escritório",
    "class_description": "Comércio varejista de outros produtos novos não especificados anteriormente"
  },
  "4789008": {
    "description": "Comércio varejista de artigos fotográficos e para filmagem",
    "class_description": "Comércio varejista de outros produtos novos não especificados anteriormente"
  },
  "4789009": {
    "description": "Comércio varejista de armas e munições",
    "class_description": "Comércio varejista de outros produtos novos não especificados anteriormente"
  },
  "4789099": {
    "description": "Comércio varejista de outros produtos não especificados anteriormente",
    "class_description": "Comércio varejista de outros produtos novos não especificados anteriormente"
  },
  "4911600": {
    "description": "Transporte ferroviário de carga",
    "class_description": "Transporte ferroviário de carga"
  },
  "4912401": {
    "description": "Transporte ferroviário de passageiros intermunicipal e interestadual",
    "class_description": "Transporte metroferroviário de passageiros"
  },
  "4912402": {
    "description": "Transporte ferroviário de passageiros municipal e em região metropolitana",
    "class_description": "Transporte metroferroviário de passageiros"
  },
  "4912403": {
    "description": "Transporte metroviário",
    "class_description": "Transporte metroferroviário de passageiros"
  },
  "4921301": {
    "description": "Transporte rodoviário coletivo de passageiros, com itinerário fixo, municipal",
    "class_description": "Transporte rodoviário coletivo de passageiros, com itinerário fixo, municipal e em região metropolitana"
  },
  "4921302": {
    "description": "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal em região metropolitana",
    "class_description": "Transporte rodoviário coletivo de passageiros, com itinerário fixo, municipal e em região metropolitana"
  },
  "4922101": {
    "description": "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal, exceto em região metropolitana",
    "class_description": "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal, interestadual e internacional"
  },
  "4922102": {
    "description": "Transporte rodoviário coletivo de passageiros, com itinerário fixo, interestadual",
    "class_description": "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal, interestadual e internacional"
  },
  "4922103": {
    "description": "Transporte rodoviário coletivo de passageiros, com itinerário fixo, internacional",
    "class_description": "Transporte rodoviário coletivo de passageiros, com itinerário fixo, intermunicipal, interestadual e internacional"
  },
  "4923001": {
    "description": "Serviço de táxi",
    "class_description": "Transporte rodoviário de táxi"
  },
  "4923002": {
    "description": "Serviço de transporte de passageiros - locação de automóveis com motorista",
    "class_description": "Transporte rodoviário de táxi"
  },
  "4924800": {
    "description": "Transporte escolar",
    "class_description": "Transporte escolar"
  },
  "4929901": {
    "description": "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, municipal",
    "class_description": "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, e outros transportes rodoviários não especificados anteriormente"
  },
  "4929902": {
    "description": "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, intermunicipal, interestadual e internacional",
    "class_description": "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, e outros transportes rodoviários não especificados anteriormente"
  },
  "4929903": {
    "description": "Organização de excursões em veículos rodoviários próprios, municipal",
    "class_description": "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, e outros transportes rodoviários não especificados anteriormente"
  },
  "4929904": {
    "description": "Organização de excursões em veículos rodoviários próprios, intermunicipal, interestadual e internacional",
    "class_description": "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, e outros transportes rodoviários não especificados anteriormente"
  },
  "4929999": {
    "description": "Outros transportes rodoviários de passageiros não especificados anteriormente",
    "class_description": "Transporte rodoviário coletivo de passageiros, sob regime de fretamento, e outros transportes rodoviários não especificados anteriormente"
  },
  "4930201": {
    "description": "Transporte rodoviário de carga, exceto produtos perigosos e mudanças, municipal",
    "class_description": "Transporte rodoviário de carga"
  },
  "4930202": {
    "description": "Transporte rodoviário de carga, exceto produtos perigosos e mudanças, intermunicipal, interestadual e internacional",
    "class_description": "Transporte rodoviário de carga"
  },
  "4930203": {
    "description": "Transporte rodoviário de produtos perigosos",
    "class_description": "Transporte rodoviário de carga"
  },
  "4930204": {
    "description": "Transporte rodoviário de mudanças",
    "class_description": "Transporte rodoviário de carga"
  },
  "4940000": {
    "description": "Transporte dutoviário",
    "class_description": "Transporte dutoviário"
  },
  "4950700": {
    "description": "Trens turísticos, teleféricos e similares",
    "class_description": "Trens turísticos, teleféricos e similares"
  },
  "5011401": {
    "description": "Transporte marítimo de cabotagem - Carga",
    "class_description": "Transporte marítimo de cabotagem"
  },
  "5011402": {
    "description": "Transporte marítimo de cabotagem - Passageiros",
    "class_description": "Transporte marítimo de cabotagem"
  },
  "5012201": {
    "description": "Transporte marítimo de longo curso - Carga",
    "class_description": "Transporte marítimo de longo curso"
  },
  "5012202": {
    "description": "Transporte marítimo de longo curso - Passageiros",
    "class_description": "Transporte marítimo de longo curso"
  },
  "5021101": {
    "description": "Transporte por navegação interior de carga, municipal, exceto travessia",
    "class_description": "Transporte por navegação interior de carga"
  },
  "5021102": {
    "description": "Transporte por navegação interior de carga, intermunicipal, interestadual e internacional, exceto travessia",
    "class_description": "Transporte por navegação interior de carga"
  },
  "5022001": {
    "description": "Transporte por navegação interior de passageiros em linhas regulares, municipal, exceto travessia",
    "class_description": "Transporte por navegação interior de passageiros em linhas regulares"
  },
  "5022002": {
    "description": "Transporte por navegação interior de passageiros em linhas regulares, intermunicipal, interestadual e internacional, exceto travessia",
    "class_description": "Transporte por navegação interior de passageiros em linhas regulares"
  },
  "5030101": {
    "description": "Navegação de apoio marítimo",
    "class_description": "Navegação de apoio"
  },
  "5030102": {
    "description": "Navegação de apoio portuário",
    "class_description": "Navegação de apoio"
  },
  "5030103": {
    "description": "Serviço de rebocadores e empurradores",
    "class_description": "Navegação de apoio"
  },
  "5091201": {
    "description": "Transporte por navegação de travessia, municipal",
    "class_description": "Transporte por navegação de travessia"
  },
  "5091202": {
    "description": "Transporte por navegação de travessia, intermunicipal, interestadual e internacional",
    "class_description": "Transporte por navegação de travessia"
  },
  "5099801": {
    "description": "Transporte aquaviário para passeios turísticos",
    "class_description": "Transportes aquaviários não especificados anteriormente"
  },
  "5099899": {
    "description": "Outros transportes aquaviários não especificados anteriormente",
    "class_description": "Transportes aquaviários não especificados anteriormente"
  },
  "5111100": {
    "description": "Transporte aéreo de passageiros regular",
    "class_description": "Transporte aéreo de passageiros regular"
  },
  "5112901": {
    "description": "Serviço de táxi aéreo e locação de aeronaves com tripulação",
    "class_description": "Transporte aéreo de passageiros não regular"
  },
  "5112999": {
    "description": "Outros serviços de transporte aéreo de passageiros não regular",
    "class_description": "Transporte aéreo de passageiros não regular"
  },
  "5120000": {
    "description": "Transporte aéreo de carga",
    "class_description": "Transporte aéreo de carga"
  },
  "5130700": {
    "description": "Transporte espacial",
    "class_description": "Transporte espacial"
  },
  "5211701": {
    "description": "Armazéns gerais - emissão de warrant",
    "class_description": "Armazenamento"
  },
  "5211702": {
    "description": "Guarda-móveis",
    "class_description": "Armazenamento"
  },
  "5211799": {
    "description": "Depósitos de mercadorias para terceiros, exceto armazéns gerais e guarda-móveis",
    "class_description": "Armazenamento"
  },
  "5212500": {
    "description": "Carga e descarga",
    "class_description": "Carga e descarga"
  },
  "5221400": {
    "description": "Concessionárias de rodovias, pontes, túneis e serviços relacionados",
    "class_description": "Concessionárias de rodovias, pontes, túneis e serviços relacionados"
  },
  "5222200": {
    "description": "Terminais rodoviários e ferroviários",
    "class_description": "Terminais rodoviários e ferroviários"
  },
  "5223100": {
    "description": "Estacionamento de veículos",
    "class_description": "Estacionamento de veículos"
  },
  "5229001": {
    "description": "Serviços de apoio ao transporte por táxi, inclusive centrais de chamada",
    "class_description": "Atividades auxiliares dos transportes terrestres não especificadas anteriormente"
  },
  "5229002": {
    "description": "Serviços de reboque de veículos",
    "class_description": "Atividades auxiliares dos transportes terrestres não especificadas anteriormente"
  },
  "5229099": {
    "description": "Outras atividades auxiliares dos transportes terrestres não especificadas anteriormente",
    "class_description": "Atividades auxiliares dos transportes terrestres não especificadas anteriormente"
  },
  "5231101": {
    "description": "Administração da infraestrutura portuária",
    "class_description": "Gestão de portos e terminais"
  },
  "5231102": {
    "description": "Atividades do Operador Portuário",
    "class_description": "Gestão de portos e terminais"
  },
  "5231103": {
    "description": "Gestão de terminais aquaviários",
    "class_description": "Gestão de portos e terminais"
  },
  "5232000": {
    "description": "Atividades de agenciamento marítimo",
    "class_description": "Atividades de agenciamento marítimo"
  },
  "5239701": {
    "description": "Serviços de praticagem",
    "class_description": "Atividades auxiliares dos transportes aquaviários não especificadas anteriormente"
  },
  "5239799": {
    "description": "Atividades auxiliares dos transportes aquaviários não especificadas anteriormente",
    "class_description": "Atividades auxiliares dos transportes aquaviários não especificadas anteriormente"
  },
  "5240101": {
    "description": "Operação dos aeroportos e campos de aterrissagem",
    "class_description": "Atividades auxiliares dos transportes aéreos"
  },
  "5240199": {
    "description": "Atividades auxiliares dos transportes aéreos, exceto operação dos aeroportos e campos de aterrissagem",
    "class_description": "Atividades auxiliares dos transportes aéreos"
  },
  "5250801": {
    "description": "Comissaria de despachos",
    "class_description": "Atividades relacionadas à organização do transporte de carga"
  },
  "5250802": {
    "description": "Atividades de despachantes aduaneiros",
    "class_description": "Atividades relacionadas à organização do transporte de carga"
  },
  "5250803": {
    "description": "Agenciamento de cargas, exceto para o transporte marítimo",
    "class_description": "Atividades relacionadas à organização do transporte de carga"
  },
  "5250804": {
    "description": "Organização logística do transporte de carga",
    "class_description": "Atividades relacionadas à organização do transporte de carga"
  },
  "5250805": {
    "description": "Operador de transporte multimodal - OTM",
    "class_description": "Atividades relacionadas à organização do transporte de carga"
  },
  "5310501": {
    "description": "Atividades do Correio Nacional",
    "class_description": "Atividades de Correio"
  },
  "5310502": {
    "description": "Atividades de franqueadas e permissionárias do Correio Nacional",
    "class_description": "Atividades de Correio"
  },
  "5320201": {
    "description": "Serviços de malote não realizados pelo Correio Nacional",
    "class_description": "Atividades de malote e de entrega"
  },
  "5320202": {
    "description": "Serviços de entrega rápida",
    "class_description": "Atividades de malote e de entrega"
  },
  "5510801": {
    "description": "Hotéis",
    "class_description": "Hotéis e similares"
  },
  "5510802": {
    "description": "Apart-hotéis",
    "class_description": "Hotéis e similares"
  },
  "5510803": {
    "description": "Motéis",
    "class_description": "Hotéis e similares"
  },
  "5590601": {
    "description": "Albergues, exceto assistenciais",
    "class_description": "Outros tipos de alojamento não especificados anteriormente"
  },
  "5590602": {
    "description": "Campings",
    "class_description": "Outros tipos de alojamento não especificados anteriormente"
  },
  "5590603": {
    "description": "Pensões (alojamento)",
    "class_description": "Outros tipos de alojamento não especificados anteriormente"
  },
  "5590699": {
    "description": "Outros alojamentos não especificados anteriormente",
    "class_description": "Outros tipos de alojamento não especificados anteriormente"
  },
  "5611201": {
    "description": "Restaurantes e similares",
    "class_description": "Restaurantes e outros estabelecimentos de serviços de alimentação e bebidas"
  },
  "5611203": {
    "description": "Lanchonetes, casas de chá, de sucos e similares",
    "class_description": "Restaurantes e outros estabelecimentos de serviços de alimentação e bebidas"
  },
  "5611204": {
    "description": "Bares e outros estabelecimentos especializados em servir bebidas, sem entretenimento",
    "class_description": "Restaurantes e outros estabelecimentos de serviços de alimentação e bebidas"
  },
  "5611205": {
    "description": "Bares e outros estabelecimentos especializados em servir bebidas, com entretenimento",
    "class_description": "Restaurantes e outros estabelecimentos de serviços de alimentação e bebidas"
  },
  "5612100": {
    "description": "Serviços ambulantes de alimentação",
    "class_description": "Serviços ambulantes de alimentação"
  },
  "5620101": {
    "description": "Fornecimento de alimentos preparados preponderantemente para empresas",
    "class_description": "Serviços de catering, bufê e outros serviços de comida preparada"
  },
  "5620102": {
    "description": "Serviços de alimentação para eventos e recepções - bufê",
    "class_description": "Serviços de catering, bufê e outros serviços de comida preparada"
  },
  "5620103": {
    "description": "Cantinas - serviços de alimentação privativos",
    "class_description": "Serviços de catering, bufê e outros serviços de comida preparada"
  },
  "5620104": {
    "description": "Fornecimento de alimentos preparados preponderantemente para consumo domiciliar",
    "class_description": "Serviços de catering, bufê e outros serviços de comida preparada"
  },
  "5811500": {
    "description": "Edição de livros",
    "class_description": "Edição de livros"
  },
  "5812301": {
    "description": "Edição de jornais diários",
    "class_description": "Edição de jornais"
  },
  "5812302": {
    "description": "Edição de jornais não diários",
    "class_description": "Edição de jornais"
  },
  "5813100": {
    "description": "Edição de revistas",
    "class_description": "Edição de revistas"
  },
  "5819100": {
    "description": "Edição de cadastros, listas e outros produtos gráficos",
    "class_description": "Edição de cadastros, listas e outros produtos gráficos"
  },
  "5821200": {
    "description": "Edição integrada à impressão de livros",
    "class_description": "Edição integrada à impressão de livros"
  },
  "5822101": {
    "description": "Edição integrada à impressão de jornais diários",
    "class_description": "Edição integrada à impressão de jornais"
  },
  "5822102": {
    "description": "Edição integrada à impressão de jornais não diários",
    "class_description": "Edição integrada à impressão de jornais"
  },
  "5823900": {
    "description": "Edição integrada à impressão de revistas",
    "class_description": "Edição integrada à impressão de revistas"
  },
  "5829800": {
    "description": "Edição integrada à impressão de cadastros, listas e outros produtos gráficos",
    "class_description": "Edição integrada à impressão de cadastros, listas e outros produtos gráficos"
  },
  "5911101": {
    "description": "Estúdios cinematográficos",
    "class_description": "Atividades de produção cinematográfica, de vídeos e de programas de televisão"
  },
  "5911102": {
    "description": "Produção de filmes para publicidade",
    "class_description": "Atividades de produção cinematográfica, de vídeos e de programas de televisão"
  },
  "5911199": {
    "description": "Atividades de produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente",
    "class_description": "Atividades de produção cinematográfica, de vídeos e de programas de televisão"
  },
  "5912001": {
    "description": "Serviços de dublagem",
    "class_description": "Atividades de pós-produção cinematográfica, de vídeos e de programas de televisão"
  },
  "5912002": {
    "description": "Serviços de mixagem sonora em produção audiovisual",
    "class_description": "Atividades de pós-produção cinematográfica, de vídeos e de programas de televisão"
  },
  "5912099": {
    "description": "Atividades de pós-produção cinematográfica, de vídeos e de programas de televisão não especificadas anteriormente",
    "class_description": "Atividades de pós-produção cinematográfica, de vídeos e de programas de televisão"
  },
  "5913800": {
    "description": "Distribuição cinematográfica, de vídeo e de programas de televisão",
    "class_description": "Distribuição cinematográfica, de vídeo e de programas de televisão"
  },
  "5914600": {
    "description": "Atividades de exibição cinematográfica",
    "class_description": "Atividades de exibição cinematográfica"
  },
  "5920100": {
    "description": "Atividades de gravação de som e de edição de música",
    "class_description": "Atividades de gravação de som e de edição de música"
  },
  "6010100": {
    "description": "Atividades de rádio",
    "class_description": "Atividades de rádio"
  },
  "6021700": {
    "description": "Atividades de televisão aberta",
    "class_description": "Atividades de televisão aberta"
  },
  "6022501": {
    "description": "Programadoras",
    "class_description": "Programadoras e atividades relacionadas à televisão por assinatura"
  },
  "6022502": {
    "description": "Atividades relacionadas à televisão por assinatura, exceto programadoras",
    "class_description": "Programadoras e atividades relacionadas à televisão por assinatura"
  },
  "6110801": {
    "description": "Serviços de telefonia fixa comutada - STFC",
    "class_description": "Telecomunicações por fio"
  },
  "6110802": {
    "description": "Serviços de redes de transporte de telecomunicações - SRTT",
    "class_description": "Telecomunicações por fio"
  },
  "6110803": {
    "description": "Serviços de comunicação multimídia - SCM",
    "class_description": "Telecomunicações por fio"
  },
  "6110899": {
    "description": "Serviços de telecomunicações por fio não especificados anteriormente",
    "class_description": "Telecomunicações por fio"
  },
  "6120501": {
    "description": "Telefonia móvel celular",
    "class_description": "Telecomunicações sem fio"
  },
  "6120502": {
    "description": "Serviço móvel especializado - SME",
    "class_description": "Telecomunicações sem fio"
  },
  "6120599": {
    "description": "Serviços de telecomunicações sem fio não especificados anteriormente",
    "class_description": "Telecomunicações sem fio"
  },
  "6130200": {
    "description": "Telecomunicações por satélite",
    "class_description": "Telecomunicações por satélite"
  },
  "6141800": {
    "description": "Operadoras de televisão por assinatura por cabo",
    "class_description": "Operadoras de televisão por assinatura por cabo"
  },
  "6142600": {
    "description": "Operadoras de televisão por assinatura por micro-ondas",
    "class_description": "Operadoras de televisão por assinatura por micro-ondas"
  },
  "6143400": {
    "description": "Operadoras de televisão por assinatura por satélite",
    "class_description": "Operadoras de televisão por assinatura por satélite"
  },
  "6190601": {
    "description": "Provedores de acesso às redes de comunicações",
    "class_description": "Outras atividades de telecomunicações"
  },
  "6190602": {
    "description": "Provedores de voz sobre protocolo Internet - VOIP",
    "class_description": "Outras atividades de telecomunicações"
  },
  "6190699": {
    "description": "Outras atividades de telecomunicações não especificadas anteriormente",
    "class_description": "Outras atividades de telecomunicações"
  },
  "6201501": {
    "description": "Desenvolvimento de programas de computador sob encomenda",
    "class_description": "Desenvolvimento de programas de computador sob encomenda"
  },
  "6201502": {
    "description": "Web desing",
    "class_description": "Desenvolvimento de programas de computador sob encomenda"
  },
  "6202300": {
    "description": "Desenvolvimento e licenciamento de programas de computador customizáveis",
    "class_description": "Desenvolvimento e licenciamento de programas de computador customizáveis"
  },
  "6203100": {
    "description": "Desenvolvimento e licenciamento de programas de computador não customizáveis",
    "class_description": "Desenvolvimento e licenciamento de programas de computador não customizáveis"
  },
  "6204000": {
    "description": "Consultoria em tecnologia da informação",
    "class_description": "Consultoria em tecnologia da informação"
  },
  "6209100": {
    "description": "Suporte técnico, manutenção e outros serviços em tecnologia da informação",
    "class_description": "Suporte técnico, manutenção e outros serviços em tecnologia da informação"
  },
  "6311900": {
    "description": "Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na Internet",
    "class_description": "Tratamento de dados, provedores de serviços de aplicação e serviços de hospedagem na Internet"
  },
  "6319400": {
    "description": "Portais, provedores de conteúdo e outros serviços de informação na Internet",
    "class_description": "Portais, provedores de conteúdo e outros serviços de informação na Internet"
  },
  "6391700": {
    "description": "Agências de notícias",
    "class_description": "Agências de notícias"
  },
  "6399200": {
    "description": "Outras atividades de prestação de serviços de informação não especificadas anteriormente",
    "class_description": "Outras atividades de prestação de serviços de informação não especificadas anteriormente"
  },
  "6410700": {
    "description": "Banco Central",
    "class_description": "Banco Central"
  },
  "6421200": {
    "description": "Bancos comerciais",
    "class_description": "Bancos comerciais"
  },
  "6422100": {
    "description": "Bancos múltiplos, com carteira comercial",
    "class_description": "Bancos múltiplos, com carteira comercial"
  },
  "6423900": {
    "description": "Caixas econômicas",
    "class_description": "Caixas econômicas"
  },
  "6424701": {
    "description": "Bancos cooperativos",
    "class_description": "Crédito cooperativo"
  },
  "6424702": {
    "description": "Cooperativas centrais de crédito",
    "class_description": "Crédito cooperativo"
  },
  "6424703": {
    "description": "Cooperativas de crédito mútuo",
    "class_description": "Crédito cooperativo"
  },
  "6424704": {
    "description": "Cooperativas de crédito rural",
    "class_description": "Crédito cooperativo"
  },
  "6431000": {
    "description": "Bancos múltiplos, sem carteira comercial",
    "class_description": "Bancos múltiplos, sem carteira comercial"
  },
  "6432800": {
    "description": "Bancos de investimento",
    "class_description": "Bancos de investimento"
  },
  "6433600": {
    "description": "Bancos de desenvolvimento",
    "class_description": "Bancos de desenvolvimento"
  },
  "6434400": {
    "description": "Agências de fomento",
    "class_description": "Agências de fomento"
  },
  "6435201": {
    "description": "Sociedades de crédito imobiliário",
    "class_description": "Crédito imobiliário"
  },
  "6435202": {
    "description": "Associações de poupança e empréstimo",
    "class_description": "Crédito imobiliário"
  },
  "6435203": {
    "description": "Companhias hipotecárias",
    "class_description": "Crédito imobiliário"
  },
  "6436100": {
    "description": "Sociedades de crédito, financiamento e investimento - financeiras",
    "class_description": "Sociedades de crédito, financiamento e investimento - financeiras"
  },
  "6437900": {
    "description": "Sociedades de crédito ao microempreendedor",
    "class_description": "Sociedades de crédito ao microempreendedor"
  },
  "6438701": {
    "description": "Bancos de câmbio",
    "class_description": "Bancos de câmbio e outras instituições de intermediação não monetária"
  },
  "6438799": {
    "description": "Outras instituições de intermediação não monetária não especificadas anteriormente",
    "class_description": "Bancos de câmbio e outras instituições de intermediação não monetária"
  },
  "6440900": {
    "description": "Arrendamento mercantil",
    "class_description": "Arrendamento mercantil"
  },
  "6450600": {
    "description": "Sociedades de capitalização",
    "class_description": "Sociedades de capitalização"
  },
  "6461100": {
    "description": "Holdings de instituições financeiras",
    "class_description": "Holdings de instituições financeiras"
  },
  "6462000": {
    "description": "Holdings de instituições não financeiras",
    "class_description": "Holdings de instituições não financeiras"
  },
  "6463800": {
    "description": "Outras sociedades de participação, exceto holdings",
    "class_description": "Outras sociedades de participação, exceto holdings"
  },
  "6470101": {
    "description": "Fundos de investimento, exceto previdenciários e imobiliários",
    "class_description": "Fundos de investimento"
  },
  "6470102": {
    "description": "Fundos de investimento previdenciários",
    "class_description": "Fundos de investimento"
  },
  "6470103": {
    "description": "Fundos de investimento imobiliários",
    "class_description": "Fundos de investimento"
  },
  "6491300": {
    "description": "Sociedades de fomento mercantil - factoring",
    "class_description": "Sociedades de fomento mercantil - factoring"
  },
  "6492100": {
    "description": "Securitização de créditos",
    "class_description": "Securitização de créditos"
  },
  "6493000": {
    "description": "Administração de consórcios para aquisição de bens e direitos",
    "class_description": "Administração de consórcios para aquisição de bens e direitos"
  },
  "6499901": {
    "description": "Clubes de investimento",
    "class_description": "Outras atividades de serviços financeiros não especificadas anteriormente"
  },
  "6499902": {
    "description": "Sociedades de investimento",
    "class_description": "Outras atividades de serviços financeiros não especificadas anteriormente"
  },
  "6499903": {
    "description": "Fundo garantidor de crédito",
    "class_description": "Outras atividades de serviços financeiros não especificadas anteriormente"
  },
  "6499904": {
    "description": "Caixas de financiamento de corporações",
    "class_description": "Outras atividades de serviços financeiros não especificadas anteriormente"
  },
  "6499905": {
    "description": "Concessão de crédito pelas OSCIP",
    "class_description": "Outras atividades de serviços financeiros não especificadas anteriormente"
  },
  "6499999": {
    "description": "Outras atividades de serviços financeiros não especificadas anteriormente",
    "class_description": "Outras atividades de serviços financeiros não especificadas anteriormente"
  },
  "6511101": {
    "description": "Sociedade seguradora de seguros vida",
    "class_description": "Seguros de vida"
  },
  "6511102": {
    "description": "Planos de auxílio-funeral",
    "class_description": "Seguros de vida"
  },
  "6512000": {
    "description": "Sociedade seguradora de seguros não vida",
    "class_description": "Seguros não vida"
  },
  "6520100": {
    "description": "Sociedade seguradora de seguros-saúde",
    "class_description": "Seguros-saúde"
  },
  "6530800": {
    "description": "Resseguros",
    "class_description": "Resseguros"
  },
  "6541300": {
    "description": "Previdência complementar fechada",
    "class_description": "Previdência complementar fechada"
  },
  "6542100": {
    "description": "Previdência complementar aberta",
    "class_description": "Previdência complementar aberta"
  },
  "6550200": {
    "description": "Planos de saúde",
    "class_description": "Planos de saúde"
  },
  "6611801": {
    "description": "Bolsa de valores",
    "class_description": "Administração de bolsas e mercados de balcão organizados"
  },
  "6611802": {
    "description": "Bolsa de mercadorias",
    "class_description": "Administração de bolsas e mercados de balcão organizados"
  },
  "6611803": {
    "description": "Bolsa de mercadorias e futuros",
    "class_description": "Administração de bolsas e mercados de balcão organizados"
  },
  "6611804": {
    "description": "Administração de mercados de balcão organizados",
    "class_description": "Administração de bolsas e mercados de balcão organizados"
  },
  "6612601": {
    "description": "Corretoras de títulos e valores mobiliários",
    "class_description": "Atividades de intermediários em transações de títulos, valores mobiliários e mercadorias"
  },
  "6612602": {
    "description": "Distribuidoras de títulos e valores mobiliários",
    "class_description": "Atividades de intermediários em transações de títulos, valores mobiliários e mercadorias"
  },
  "6612603": {
    "description": "Corretoras de câmbio",
    "class_description": "Atividades de intermediários em transações de títulos, valores mobiliários e mercadorias"
  },
  "6612604": {
    "description": "Corretoras de contratos de mercadorias",
    "class_description": "Atividades de intermediários em transações de títulos, valores mobiliários e mercadorias"
  },
  "6612605": {
    "description": "Agentes de investimentos em aplicações financeiras",
    "class_description": "Atividades de intermediários em transações de títulos, valores mobiliários e mercadorias"
  },
  "6613400": {
    "description": "Administração de cartões de crédito",
    "class_description": "Administração de cartões de crédito"
  },
  "6619301": {
    "description": "Serviços de liquidação e custódia",
    "class_description": "Atividades auxiliares dos serviços financeiros não especificadas anteriormente"
  },
  "6619302": {
    "description": "Correspondentes de instituições financeiras",
    "class_description": "Atividades auxiliares dos serviços financeiros não especificadas anteriormente"
  },
  "6619303": {
    "description": "Representações de bancos estrangeiros",
    "class_description": "Atividades auxiliares dos serviços financeiros não especificadas anteriormente"
  },
  "6619304": {
    "description": "Caixas eletrônicos",
    "class_description": "Atividades auxiliares dos serviços financeiros não especificadas anteriormente"
  },
  "6619305": {
    "description": "Operadoras de cartões de débito",
    "class_description": "Atividades auxiliares dos serviços financeiros não especificadas anteriormente"
  },
  "6619399": {
    "description": "Outras atividades auxiliares dos serviços financeiros não especificadas anteriormente",
    "class_description": "Atividades auxiliares dos serviços financeiros não especificadas anteriormente"
  },
  "6621501": {
    "description": "Peritos e avaliadores de seguros",
    "class_description": "Avaliação de riscos e perdas"
  },
  "6621502": {
    "description": "Auditoria e consultoria atuarial",
    "class_description": "Avaliação de riscos e perdas"
  },
  "6622300": {
    "description": "Corretores e agentes de seguros, de planos de previdência complementar e de saúde",
    "class_description": "Corretores e agentes de seguros, de planos de previdência complementar e de saúde"
  },
  "6629100": {
    "description": "Atividades auxiliares dos seguros, da previdência complementar e dos planos de saúde não especificadas anteriormente",
    "class_description": "Atividades auxiliares dos seguros, da previdência complementar e dos planos de saúde não especificadas anteriormente"
  },
  "6630400": {
    "description": "Atividades de administração de fundos por contrato ou comissão",
    "class_description": "Atividades de administração de fundos por contrato ou\ncomissão"
  },
  "6810201": {
    "description": "Compra e venda de imóveis próprios",
    "class_description": "Atividades imobiliárias de imóveis próprios"
  },
  "6810202": {
    "description": "Aluguel de imóveis próprios",
    "class_description": "Atividades imobiliárias de imóveis próprios"
  },
  "6810203": {
    "description": "Loteamento de imóveis próprios",
    "class_description": "Atividades imobiliárias de imóveis próprios"
  },
  "6821801": {
    "description": "Corretagem na compra e venda e avaliação de imóveis",
    "class_description": "Intermediação na compra, venda e aluguel de imóveis"
  },
  "6821802": {
    "description": "Corretagem no aluguel de imóveis",
    "class_description": "Intermediação na compra, venda e aluguel de imóveis"
  },
  "6822600": {
    "description": "Gestão e administração da propriedade imobiliária",
    "class_description": "Gestão e administração da propriedade imobiliária"
  },
  "6911701": {
    "description": "Serviços advocatícios",
    "class_description": "Atividades jurídicas, exceto cartórios"
  },
  "6911702": {
    "description": "Atividades auxiliares da justiça",
    "class_description": "Atividades jurídicas, exceto cartórios"
  },
  "6911703": {
    "description": "Agente de propriedade industrial",
    "class_description": "Atividades jurídicas, exceto cartórios"
  },
  "6912500": {
    "description": "Cartórios",
    "class_description": "Cartórios"
  },
  "6920601": {
    "description": "Atividades de contabilidade",
    "class_description": "Atividades de contabilidade, consultoria e auditoria contábil e tributária"
  },
  "6920602": {
    "description": "Atividades de consultoria e auditoria contábil e tributária",
    "class_description": "Atividades de contabilidade, consultoria e auditoria contábil e tributária"
  },
  "7020400": {
    "description": "Atividades de consultoria em gestão empresarial, exceto consultoria técnica específica",
    "class_description": "Atividades de consultoria em gestão empresarial"
  },
  "7111100": {
    "description": "Serviços de arquitetura",
    "class_description": "Serviços de arquitetura"
  },
  "7112000": {
    "description": "Serviços de engenharia",
    "class_description": "Serviços de engenharia"
  },
  "7119701": {
    "description": "Serviços de cartografia, topografia e geodésia",
    "class_description": "Atividades técnicas relacionadas à arquitetura e engenharia"
  },
  "7119702": {
    "description": "Atividades de estudos geológicos",
    "class_description": "Atividades técnicas relacionadas à arquitetura e engenharia"
  },
  "7119703": {
    "description": "Serviços de desenho técnico relacionados à arquitetura e engenharia",
    "class_description": "Atividades técnicas relacionadas à arquitetura e engenharia"
  },
  "7119704": {
    "description": "Serviços de perícia técnica relacionados à segurança do trabalho",
    "class_description": "Atividades técnicas relacionadas à arquitetura e engenharia"
  },
  "7119799": {
    "description": "Atividades técnicas relacionadas à engenharia e arquitetura não especificadas anteriormente",
    "class_description": "Atividades técnicas relacionadas à arquitetura e engenharia"
  },
  "7120100": {
    "description": "Testes e análises técnicas",
    "class_description": "Testes e análises técnicas"
  },
  "7210000": {
    "description": "Pesquisa e desenvolvimento experimental em ciências físicas e naturais",
    "class_description": "Pesquisa e desenvolvimento experimental em ciências físicas e naturais"
  },
  "7220700": {
    "description": "Pesquisa e desenvolvimento experimental em ciências sociais e humanas",
    "class_description": "Pesquisa e desenvolvimento experimental em ciências sociais e humanas"
  },
  "7311400": {
    "description": "Agências de publicidade",
    "class_description": "Agências de publicidade"
  },
  "7312200": {
    "description": "Agenciamento de espaços para publicidade, exceto em veículos de comunicação",
    "class_description": "Agenciamento de espaços para publicidade, exceto em veículos de comunicação"
  },
  "7319001": {
    "description": "Criação de estandes para feiras e exposições",
    "class_description": "Atividades de publicidade não especificadas anteriormente"
  },
  "7319002": {
    "description": "Promoção de vendas",
    "class_description": "Atividades de publicidade não especificadas anteriormente"
  },
  "7319003": {
    "description": "Marketing direto",
    "class_description": "Atividades de publicidade não especificadas anteriormente"
  },
  "7319004": {
    "description": "Consultoria em publicidade",
    "class_description": "Atividades de publicidade não especificadas anteriormente"
  },
  "7319099": {
    "description": "Outras atividades de publicidade não especificadas anteriormente",
    "class_description": "Atividades de publicidade não especificadas anteriormente"
  },
  "7320300": {
    "description": "Pesquisas de mercado e de opinião pública",
    "class_description": "Pesquisas de mercado e de opinião pública"
  },
  "7410202": {
    "description": "Design de interiores",
    "class_description": "Design e decoração de interiores"
  },
  "7410203": {
    "description": "Desing de produto",
    "class_description": "Design e decoração de interiores"
  },
  "7410299": {
    "description": "Atividades de desing não especificadas anteriormente",
    "class_description": "Design e decoração de interiores"
  },
  "7420001": {
    "description": "Atividades de produção de fotografias, exceto aérea e submarina",
    "class_description": "Atividades fotográficas e similares"
  },
  "7420002": {
    "description": "Atividades de produção de fotografias aéreas e submarinas",
    "class_description": "Atividades fotográficas e similares"
  },
  "7420003": {
    "description": "Laboratórios fotográficos",
    "class_description": "Atividades fotográficas e similares"
  },
  "7420004": {
    "description": "Filmagem de festas e eventos",
    "class_description": "Atividades fotográficas e similares"
  },
  "7420005": {
    "description": "Serviços de microfilmagem",
    "class_description": "Atividades fotográficas e similares"
  },
  "7490101": {
    "description": "Serviços de tradução, interpretação e similares",
    "class_description": "Atividades profissionais, científicas e técnicas não especificadas anteriormente"
  },
  "7490102": {
    "description": "Escafandria e mergulho",
    "class_description": "Atividades profissionais, científicas e técnicas não especificadas anteriormente"
  },
  "7490103": {
    "description": "Serviços de agronomia e de consultoria às atividades agrícolas e pecuárias",
    "class_description": "Atividades profissionais, científicas e técnicas não especificadas anteriormente"
  },
  "7490104": {
    "description": "Atividades de intermediação e agenciamento de serviços e negócios em geral, exceto imobiliários",
    "class_description": "Atividades profissionais, científicas e técnicas não especificadas anteriormente"
  },
  "7490105": {
    "description": "Agenciamento de profissionais para atividades esportivas, culturais e artísticas",
    "class_description": "Atividades profissionais, científicas e técnicas não especificadas anteriormente"
  },
  "7490199": {
    "description": "Outras atividades profissionais, científicas e técnicas não especificadas anteriormente",
    "class_description": "Atividades profissionais, científicas e técnicas não especificadas anteriormente"
  },
  "7500100": {
    "description": "Atividades veterinárias",
    "class_description": "Atividades veterinárias"
  },
  "7711000": {
    "description": "Locação de automóveis sem condutor",
    "class_description": "Locação de automóveis sem condutor"
  },
  "7719501": {
    "description": "Locação de embarcações sem tripulação, exceto para fins\nrecreativos",
    "class_description": "Locação de meios de transporte, exceto automóveis, sem condutor"
  },
  "7719502": {
    "description": "Locação de aeronaves sem tripulação",
    "class_description": "Locação de meios de transporte, exceto automóveis, sem condutor"
  },
  "7719599": {
    "description": "Locação de outros meios de transporte não especificados anteriormente, sem condutor",
    "class_description": "Locação de meios de transporte, exceto automóveis, sem condutor"
  },
  "7721700": {
    "description": "Aluguel de equipamentos recreativos e esportivos",
    "class_description": "Aluguel de equipamentos recreativos e esportivos"
  },
  "7722500": {
    "description": "Aluguel de fitas de vídeo, DVDs e similares",
    "class_description": "Aluguel de fitas de vídeo, DVDs e similares"
  },
  "7723300": {
    "description": "Aluguel de objetos do vestuário, jóias e acessórios",
    "class_description": "Aluguel de objetos do vestuário, jóias e acessórios"
  },
  "7729201": {
    "description": "Aluguel de aparelhos de jogos eletrônicos",
    "class_description": "Aluguel de objetos pessoais e domésticos não especificados anteriormente"
  },
  "7729202": {
    "description": "Aluguel de móveis, utensílios e aparelhos de uso doméstico e pessoal; instrumentos musicais",
    "class_description": "Aluguel de objetos pessoais e domésticos não especificados anteriormente"
  },
  "7729203": {
    "description": "Aluguel de material médico",
    "class_description": "Aluguel de objetos pessoais e domésticos não especificados anteriormente"
  },
  "7729299": {
    "description": "Aluguel de outros objetos pessoais e domésticos não especificados anteriormente",
    "class_description": "Aluguel de objetos pessoais e domésticos não especificados anteriormente"
  },
  "7731400": {
    "description": "Aluguel de máquinas e equipamentos agrícolas sem operador",
    "class_description": "Aluguel de máquinas e equipamentos agrícolas sem operador"
  },
  "7732201": {
    "description": "Aluguel de máquinas e equipamentos para construção sem operador, exceto andaimes",
    "class_description": "Aluguel de máquinas e equipamentos para construção sem operador"
  },
  "7732202": {
    "description": "Aluguel de andaimes",
    "class_description": "Aluguel de máquinas e equipamentos para construção sem operador"
  },
  "7733100": {
    "description": "Aluguel de máquinas e equipamentos para escritório",
    "class_description": "Aluguel de máquinas e equipamentos para escritório"
  },
  "7739001": {
    "description": "Aluguel de máquinas e equipamentos para extração de minérios e petróleo, sem operador",
    "class_description": "Aluguel de máquinas e equipamentos não especificados anteriormente"
  },
  "7739002": {
    "description": "Aluguel de equipamentos científicos, médicos e hospitalares, sem operador",
    "class_description": "Aluguel de máquinas e equipamentos não especificados anteriormente"
  },
  "7739003": {
    "description": "Aluguel de palcos, coberturas e outras estruturas de uso temporário, exceto andaimes",
    "class_description": "Aluguel de máquinas e equipamentos não especificados anteriormente"
  },
  "7739099": {
    "description": "Aluguel de outras máquinas e equipamentos comerciais e industriais não especificados anteriormente, sem operador",
    "class_description": "Aluguel de máquinas e equipamentos não especificados anteriormente"
  },
  "7740300": {
    "description": "Gestão de ativos intangíveis não financeiros",
    "class_description": "Gestão de ativos intangíveis não financeiros"
  },
  "7810800": {
    "description": "Seleção e agenciamento de mão de obra",
    "class_description": "Seleção e agenciamento de mão de obra"
  },
  "7820500": {
    "description": "Locação de mão de obra temporária",
    "class_description": "Locação de mão de obra temporária"
  },
  "7830200": {
    "description": "Fornecimento e gestão de recursos humanos para terceiros",
    "class_description": "Fornecimento e gestão de recursos humanos para terceiros"
  },
  "7911200": {
    "description": "Agências de viagens",
    "class_description": "Agências de viagens"
  },
  "7912100": {
    "description": "Operadores turísticos",
    "class_description": "Operadores turísticos"
  },
  "7990200": {
    "description": "Serviços de reservas e outros serviços de turismo não especificados anteriormente",
    "class_description": "Serviços de reservas e outros serviços de turismo não especificados anteriormente"
  },
  "8011101": {
    "description": "Atividades de vigilância e segurança privada",
    "class_description": "Atividades de vigilância e segurança privada"
  },
  "8011102": {
    "description": "Serviços de adestramento de cães de guarda",
    "class_description": "Atividades de vigilância e segurança privada"
  },
  "8012900": {
    "description": "Atividades de transporte de valores",
    "class_description": "Atividades de transporte de valores"
  },
  "8020001": {
    "description": "Atividades de monitoramento de sistemas de segurança eletrônico",
    "class_description": "Atividades de monitoramento de sistemas de segurança"
  },
  "8020002": {
    "description": "Outras atividades de serviços de segurança",
    "class_description": "Atividades de monitoramento de sistemas de segurança"
  },
  "8030700": {
    "description": "Atividades de investigação particular",
    "class_description": "Atividades de investigação particular"
  },
  "8111700": {
    "description": "Serviços combinados para apoio a edifícios, exceto condomínios prediais",
    "class_description": "Serviços combinados para apoio a edifícios, exceto condomínios prediais"
  },
  "8112500": {
    "description": "Condomínios prediais",
    "class_description": "Condomínios prediais"
  },
  "8121400": {
    "description": "Limpeza em prédios e em domicílios",
    "class_description": "Limpeza em prédios e em domicílios"
  },
  "8122200": {
    "description": "Imunização e controle de pragas urbanas",
    "class_description": "Imunização e controle de pragas urbanas"
  },
  "8129000": {
    "description": "Atividades de limpeza não especificadas anteriormente",
    "class_description": "Atividades de limpeza não especificadas anteriormente"
  },
  "8130300": {
    "description": "Atividades paisagísticas",
    "class_description": "Atividades paisagísticas"
  },
  "8211300": {
    "description": "Serviços combinados de escritório e apoio administrativo",
    "class_description": "Serviços combinados de escritório e apoio administrativo"
  },
  "8219901": {
    "description": "Fotocópias",
    "class_description": "Fotocópias, preparação de documentos e outros serviços especializados de apoio administrativo"
  },
  "8219999": {
    "description": "Preparação de documentos e serviços especializados de apoio administrativo não especificados anteriormente",
    "class_description": "Fotocópias, preparação de documentos e outros serviços especializados de apoio administrativo"
  },
  "8220200": {
    "description": "Atividades de teleatendimento",
    "class_description": "Atividades de teleatendimento"
  },
  "8230001": {
    "description": "Serviços de organização de feiras, congressos, exposições e festas",
    "class_description": "Atividades de organização de eventos, exceto culturais e esportivos"
  },
  "8230002": {
    "description": "Casas de festas e eventos",
    "class_description": "Atividades de organização de eventos, exceto culturais e esportivos"
  },
  "8291100": {
    "description": "Atividades de cobrança e informações cadastrais",
    "class_description": "Atividades de cobrança e informações cadastrais"
  },
  "8292000": {
    "description": "Envasamento e empacotamento sob contrato",
    "class_description": "Envasamento e empacotamento sob contrato"
  },
  "8299701": {
    "description": "Medição de consumo de energia elétrica, gás e água",
    "class_description": "Atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
  },
  "8299702": {
    "description": "Emissão de vales-alimentação, vales-transporte e similares",
    "class_description": "Atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
  },
  "8299703": {
    "description": "Serviços de gravação de carimbos, exceto confecção",
    "class_description": "Atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
  },
  "8299704": {
    "description": "Leiloeiros independentes",
    "class_description": "Atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
  },
  "8299705": {
    "description": "Serviços de levantamento de fundos sob contrato",
    "class_description": "Atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
  },
  "8299706": {
    "description": "Casas lotéricas",
    "class_description": "Atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
  },
  "8299707": {
    "description": "Salas de acesso à Internet",
    "class_description": "Atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
  },
  "8299799": {
    "description": "Outras atividades de serviços prestados principalmente às empresas não especificadas anteriormente",
    "class_description": "Atividades de serviços prestados principalmente às empresas não especificadas anteriormente"
  },
  "8411600": {
    "description": "Administração pública em geral",
    "class_description": "Administração pública em geral"
  },
  "8412400": {
    "description": "Regulação das atividades de saúde, educação, serviços culturais e outros serviços sociais",
    "class_description": "Regulação das atividades de saúde, educação, serviços culturais e outros serviços sociais"
  },
  "8413200": {
    "description": "Regulação das atividades econômicas",
    "class_description": "Regulação das atividades econômicas"
  },
  "8421300": {
    "description": "Relações exteriores",
    "class_description": "Relações exteriores"
  },
  "8422100": {
    "description": "Defesa",
    "class_description": "Defesa"
  },
  "8423000": {
    "description": "Justiça",
    "class_description": "Justiça"
  },
  "8424800": {
    "description": "Segurança e ordem pública",
    "class_description": "Segurança e ordem pública"
  },
  "8425600": {
    "description": "Defesa Civil",
    "class_description": "Defesa Civil"
  },
  "8430200": {
    "description": "Seguridade social obrigatória",
    "class_description": "Seguridade social obrigatória"
  },
  "8511200": {
    "description": "Educação infantil - creche",
    "class_description": "Educação infantil - creche"
  },
  "8512100": {
    "description": "Educação infantil - pré-escola",
    "class_description": "Educação infantil - pré-escola"
  },
  "8513900": {
    "description": "Ensino fundamental",
    "class_description": "Ensino fundamental"
  },
  "8520100": {
    "description": "Ensino médio",
    "class_description": "Ensino médio"
  },
  "8531700": {
    "description": "Educação superior - graduação",
    "class_description": "Educação superior - graduação"
  },
  "8532500": {
    "description": "Educação superior - graduação e pós-graduação",
    "class_description": "Educação superior - graduação e pós-graduação"
  },
  "8533300": {
    "description": "Educação superior - pós-graduação e extensão",
    "class_description": "Educação superior - pós-graduação e extensão"
  },
  "8541400": {
    "description": "Educação profissional de nível técnico",
    "class_description": "Educação profissional de nível técnico"
  },
  "8542200": {
    "description": "Educação profissional de nível tecnológico",
    "class_description": "Educação profissional de nível tecnológico"
  },
  "8550301": {
    "description": "Administração de caixas escolares",
    "class_description": "Atividades de apoio à educação"
  },
  "8550302": {
    "description": "Atividades de apoio à educação, exceto caixas escolares",
    "class_description": "Atividades de apoio à educação"
  },
  "8591100": {
    "description": "Ensino de esportes",
    "class_description": "Ensino de esportes"
  },
  "8592901": {
    "description": "Ensino de dança",
    "class_description": "Ensino de arte e cultura"
  },
  "8592902": {
    "description": "Ensino de artes cênicas, exceto dança",
    "class_description": "Ensino de arte e cultura"
  },
  "8592903": {
    "description": "Ensino de música",
    "class_description": "Ensino de arte e cultura"
  },
  "8592999": {
    "description": "Ensino de arte e cultura não especificado anteriormente",
    "class_description": "Ensino de arte e cultura"
  },
  "8593700": {
    "description": "Ensino de idiomas",
    "class_description": "Ensino de idiomas"
  },
  "8599601": {
    "description": "Formação de condutores",
    "class_description": "Atividades de ensino não especificadas anteriormente"
  },
  "8599602": {
    "description": "Cursos de pilotagem",
    "class_description": "Atividades de ensino não especificadas anteriormente"
  },
  "8599603": {
    "description": "Treinamento em informática",
    "class_description": "Atividades de ensino não especificadas anteriormente"
  },
  "8599604": {
    "description": "Treinamento em desenvolvimento profissional e gerencial",
    "class_description": "Atividades de ensino não especificadas anteriormente"
  },
  "8599605": {
    "description": "Cursos preparatórios para concursos",
    "class_description": "Atividades de ensino não especificadas anteriormente"
  },
  "8599699": {
    "description": "Outras atividades de ensino não especificadas anteriormente",
    "class_description": "Atividades de ensino não especificadas anteriormente"
  },
  "8610101": {
    "description": "Atividades de atendimento hospitalar, exceto pronto-socorro e unidades para atendimento a urgências",
    "class_description": "Atividades de atendimento hospitalar"
  },
  "8610102": {
    "description": "Atividades de atendimento em pronto-socorro e unidades hospitalares para atendimento a urgências",
    "class_description": "Atividades de atendimento hospitalar"
  },
  "8621601": {
    "description": "UTI móvel",
    "class_description": "Serviços móveis de atendimento a urgências"
  },
  "8621602": {
    "description": "Serviços móveis de atendimento a urgências, exceto por UTI móvel",
    "class_description": "Serviços móveis de atendimento a urgências"
  },
  "8622400": {
    "description": "Serviços de remoção de pacientes, exceto os serviços móveis de atendimento a urgências",
    "class_description": "Serviços de remoção de pacientes, exceto os serviços móveis de atendimento a urgências"
  },
  "8630501": {
    "description": "Atividade médica ambulatorial com recursos para realização de procedimentos cirúrgicos",
    "class_description": "Atividades de atenção ambulatorial executadas por médicos e odontólogos"
  },
  "8630502": {
    "description": "Atividade médica ambulatorial com recursos para realização de exames complementares",
    "class_description": "Atividades de atenção ambulatorial executadas por médicos e odontólogos"
  },
  "8630503": {
    "description": "Atividade médica ambulatorial restrita a consultas",
    "class_description": "Atividades de atenção ambulatorial executadas por médicos e odontólogos"
  },
  "8630504": {
    "description": "Atividade odontológica",
    "class_description": "Atividades de atenção ambulatorial executadas por médicos e odontólogos"
  },
  "8630506": {
    "description": "Serviços de vacinação e imunização humana",
    "class_description": "Atividades de atenção ambulatorial executadas por médicos e odontólogos"
  },
  "8630507": {
    "description": "Atividades de reprodução humana assistida",
    "class_description": "Atividades de atenção ambulatorial executadas por médicos e odontólogos"
  },
  "8630599": {
    "description": "Atividades de atenção ambulatorial não especificadas anteriormente",
    "class_description": "Atividades de atenção ambulatorial executadas por médicos e odontólogos"
  },
  "8640201": {
    "description": "Laboratórios de anatomia patológica e citológica",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640202": {
    "description": "Laboratórios clínicos",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640203": {
    "description": "Serviços de diálise e nefrologia",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640204": {
    "description": "Serviços de tomografia",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640205": {
    "description": "Serviços de diagnóstico por imagem com uso de radiação ionizante, exceto tomografia",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640206": {
    "description": "Serviços de ressonância magnética",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640207": {
    "description": "Serviços de diagnóstico por imagem sem uso de radiação ionizante, exceto ressonância magnética",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640208": {
    "description": "Serviços de diagnóstico por registro gráfico - ECG, EEG e outros exames análogos",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640209": {
    "description": "Serviços de diagnóstico por métodos ópticos - endoscopia e outros exames análogos",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640210": {
    "description": "Serviços de quimioterapia",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640211": {
    "description": "Serviços de radioterapia",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640212": {
    "description": "Serviços de hemoterapia",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640213": {
    "description": "Serviços de litotripsia",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640214": {
    "description": "Serviços de bancos de células e tecidos humanos",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8640299": {
    "description": "Atividades de serviços de complementação diagnóstica e terapêutica não especificadas anteriormente",
    "class_description": "Atividades de serviços de complementação diagnóstica e terapêutica"
  },
  "8650001": {
    "description": "Atividades de enfermagem",
    "class_description": "Atividades de profissionais da área de saúde, exceto médicos e odontólogos"
  },
  "8650002": {
    "description": "Atividades de profissionais da nutrição",
    "class_description": "Atividades de profissionais da área de saúde, exceto médicos e odontólogos"
  },
  "8650003": {
    "description": "Atividades de psicologia e psicanálise",
    "class_description": "Atividades de profissionais da área de saúde, exceto médicos e odontólogos"
  },
  "8650004": {
    "description": "Atividades de fisioterapia",
    "class_description": "Atividades de profissionais da área de saúde, exceto médicos e odontólogos"
  },
  "8650005": {
    "description": "Atividades de terapia ocupacional",
    "class_description": "Atividades de profissionais da área de saúde, exceto médicos e odontólogos"
  },
  "8650006": {
    "description": "Atividades de fonoaudiologia",
    "class_description": "Atividades de profissionais da área de saúde, exceto médicos e odontólogos"
  },
  "8650007": {
    "description": "Atividades de terapia de nutrição enteral e parenteral",
    "class_description": "Atividades de profissionais da área de saúde, exceto médicos e odontólogos"
  },
  "8650099": {
    "description": "Atividades de profissionais da área de saúde não especificadas anteriormente",
    "class_description": "Atividades de profissionais da área de saúde, exceto médicos e odontólogos"
  },
  "8660700": {
    "description": "Atividades de apoio à gestão de saúde",
    "class_description": "Atividades de apoio à gestão de saúde"
  },
  "8690901": {
    "description": "Atividades de práticas integrativas e complementares em saúde humana",
    "class_description": "Atividades de atenção à saúde humana não especificadas anteriormente"
  },
  "8690902": {
    "description": "Atividades de bancos de leite humano",
    "class_description": "Atividades de atenção à saúde humana não especificadas anteriormente"
  },
  "8690903": {
    "description": "Atividades de acupuntura",
    "class_description": "Atividades de atenção à saúde humana não especificadas anteriormente"
  },
  "8690904": {
    "description": "Atividades de podologia",
    "class_description": "Atividades de atenção à saúde humana não especificadas anteriormente"
  },
  "8690999": {
    "description": "Outras atividades de atenção à saúde humana não especificadas anteriormente",
    "class_description": "Atividades de atenção à saúde humana não especificadas anteriormente"
  },
  "8711501": {
    "description": "Clínicas e residências geriátricas",
    "class_description": "Atividades de assistência a idosos, deficientes físicos, imunodeprimidos e convalescentes prestadas em residências coletivas e particulares"
  },
  "8711502": {
    "description": "Instituições de longa permanência para idosos",
    "class_description": "Atividades de assistência a idosos, deficientes físicos, imunodeprimidos e convalescentes prestadas em residências coletivas e particulares"
  },
  "8711503": {
    "description": "Atividades de assistência a deficientes físicos, imunodeprimidos e convalescentes",
    "class_description": "Atividades de assistência a idosos, deficientes físicos, imunodeprimidos e convalescentes prestadas em residências coletivas e particulares"
  },
  "8711504": {
    "description": "Centros de apoio a pacientes com câncer e com AIDS",
    "class_description": "Atividades de assistência a idosos, deficientes físicos, imunodeprimidos e convalescentes prestadas em residências coletivas e particulares"
  },
  "8711505": {
    "description": "Condomínios residenciais para idosos",
    "class_description": "Atividades de assistência a idosos, deficientes físicos, imunodeprimidos e convalescentes prestadas em residências coletivas e particulares"
  },
  "8712300": {
    "description": "Atividades de fornecimento de infraestrutura de apoio e assistência a paciente no domicílio",
    "class_description": "Atividades de fornecimento de infraestrutura de apoio e assistência a paciente no domicílio"
  },
  "8720401": {
    "description": "Atividades de centros de assistência psicossocial",
    "class_description": "Atividades de assistência psicossocial e à saúde a portadores de distúrbios psíquicos, deficiência mental e dependência\nquímica"
  },
  "8720499": {
    "description": "Atividades de assistência psicossocial e à saúde a portadores de distúrbios psíquicos, deficiência mental e dependência química e grupos similares não especificadas anteriormente",
    "class_description": "Atividades de assistência psicossocial e à saúde a portadores de distúrbios psíquicos, deficiência mental e dependência\nquímica"
  },
  "8730101": {
    "description": "Orfanatos",
    "class_description": "Atividades de assistência social prestadas em residências coletivas e particulares"
  },
  "8730102": {
    "description": "Albergues assistenciais",
    "class_description": "Atividades de assistência social prestadas em residências coletivas e particulares"
  },
  "8730199": {
    "description": "Atividades de assistência social prestadas em residências coletivas e particulares não especificadas anteriormente",
    "class_description": "Atividades de assistência social prestadas em residências coletivas e particulares"
  },
  "8800600": {
    "description": "Serviços de assistência social sem alojamento",
    "class_description": "Serviços de assistência social sem alojamento"
  },
  "9001901": {
    "description": "Produção teatral",
    "class_description": "Artes cênicas, espetáculos e atividades complementares"
  },
  "9001902": {
    "description": "Produção musical",
    "class_description": "Artes cênicas, espetáculos e atividades complementares"
  },
  "9001903": {
    "description": "Produção de espetáculos de dança",
    "class_description": "Artes cênicas, espetáculos e atividades complementares"
  },
  "9001904": {
    "description": "Produção de espetáculos circenses, de marionetes e similares",
    "class_description": "Artes cênicas, espetáculos e atividades complementares"
  },
  "9001905": {
    "description": "Produção de espetáculos de rodeios, vaquejadas e similares",
    "class_description": "Artes cênicas, espetáculos e atividades complementares"
  },
  "9001906": {
    "description": "Atividades de sonorização e de iluminação",
    "class_description": "Artes cênicas, espetáculos e atividades complementares"
  },
  "9001999": {
    "description": "Artes cênicas, espetáculos e atividades complementares não especificados anteriormente",
    "class_description": "Artes cênicas, espetáculos e atividades complementares"
  },
  "9002701": {
    "description": "Atividades de artistas plásticos, jornalistas independentes e\nescritores",
    "class_description": "Criação artística"
  },
  "9002702": {
    "description": "Restauração de obras de arte",
    "class_description": "Criação artística"
  },
  "9003500": {
    "description": "Gestão de espaços para artes cênicas, espetáculos e outras atividades artísticas",
    "class_description": "Gestão de espaços para artes cênicas, espetáculos e outras atividades artísticas"
  },
  "9101500": {
    "description": "Atividades de bibliotecas e arquivos",
    "class_description": "Atividades de bibliotecas e arquivos"
  },
  "9102301": {
    "description": "Atividades de museus e de exploração de lugares e prédios históricos e atrações similares",
    "class_description": "Atividades de museus e de exploração, restauração artística\ne conservação de lugares e prédios históricos e atrações\nsimilares"
  },
  "9102302": {
    "description": "Restauração e conservação de lugares e prédios históricos",
    "class_description": "Atividades de museus e de exploração, restauração artística\ne conservação de lugares e prédios históricos e atrações\nsimilares"
  },
  "9103100": {
    "description": "Atividades de jardins botânicos, zoológicos, parques nacionais, reservas ecológicas e áreas de proteção ambiental",
    "class_description": "Atividades de jardins botânicos, zoológicos, parques nacionais, reservas ecológicas e áreas de proteção ambiental"
  },
  "9200301": {
    "description": "Casas de bingo",
    "class_description": "Atividades de exploração de jogos de azar e apostas"
  },
  "9200302": {
    "description": "Exploração de apostas em corridas de cavalos",
    "class_description": "Atividades de exploração de jogos de azar e apostas"
  },
  "9200399": {
    "description": "Exploração de jogos de azar e apostas não especificados anteriormente",
    "class_description": "Atividades de exploração de jogos de azar e apostas"
  },
  "9311500": {
    "description": "Gestão de instalações de esportes",
    "class_description": "Gestão de instalações de esportes"
  },
  "9312300": {
    "description": "Clubes sociais, esportivos e similares",
    "class_description": "Clubes sociais, esportivos e similares"
  },
  "9313100": {
    "description": "Atividades de condicionamento físico",
    "class_description": "Atividades de condicionamento físico"
  },
  "9319101": {
    "description": "Produção e promoção de eventos esportivos",
    "class_description": "Atividades esportivas não especificadas anteriormente"
  },
  "9319199": {
    "description": "Outras atividades esportivas não especificadas anteriormente",
    "class_description": "Atividades esportivas não especificadas anteriormente"
  },
  "9321200": {
    "description": "Parques de diversão e parques temáticos",
    "class_description": "Parques de diversão e parques temáticos"
  },
  "9329801": {
    "description": "Discotecas, danceterias, salões de dança e similares",
    "class_description": "Atividades de recreação e lazer não especificadas\nanteriormente"
  },
  "9329802": {
    "description": "Exploração de boliches",
    "class_description": "Atividades de recreação e lazer não especificadas\nanteriormente"
  },
  "9329803": {
    "description": "Exploração de jogos de sinuca, bilhar e similares",
    "class_description": "Atividades de recreação e lazer não especificadas\nanteriormente"
  },
  "9329804": {
    "description": "Exploração de jogos eletrônicos recreativos",
    "class_description": "Atividades de recreação e lazer não especificadas\nanteriormente"
  },
  "9329899": {
    "description": "Outras atividades de recreação e lazer não especificadas anteriormente",
    "class_description": "Atividades de recreação e lazer não especificadas\nanteriormente"
  },
  "9411100": {
    "description": "Atividades de organizações associativas patronais e empresariais",
    "class_description": "Atividades de organizações associativas patronais e empresariais"
  },
  "9412001": {
    "description": "Atividades de fiscalização profissional",
    "class_description": "Atividades de organizações associativas profissionais"
  },
  "9412099": {
    "description": "Outras atividades associativas profissionais",
    "class_description": "Atividades de organizações associativas profissionais"
  },
  "9420100": {
    "description": "Atividades de organizações sindicais",
    "class_description": "Atividades de organizações sindicais"
  },
  "9430800": {
    "description": "Atividades de associações de defesa de direitos sociais",
    "class_description": "Atividades de associações de defesa de direitos sociais"
  },
  "9491000": {
    "description": "Atividades de organizações religiosas ou filosóficas",
    "class_description": "Atividades de organizações religiosas"
  },
  "9492800": {
    "description": "Atividades de organizações políticas",
    "class_description": "Atividades de organizações políticas"
  },
  "9493600": {
    "description": "Atividades de organizações associativas ligadas à cultura e à arte",
    "class_description": "Atividades de organizações associativas ligadas à cultura\ne à arte"
  },
  "9499500": {
    "description": "Atividades associativas não especificadas anteriormente",
    "class_description": "Atividades associativas não especificadas anteriormente"
  },
  "9511800": {
    "description": "Reparação e manutenção de computadores e de equipamentos periféricos",
    "class_description": "Reparação e manutenção de computadores e de equipamentos periféricos"
  },
  "9512600": {
    "description": "Reparação e manutenção de equipamentos de comunicação",
    "class_description": "Reparação e manutenção de equipamentos de comunicação"
  },
  "9521500": {
    "description": "Reparação e manutenção de equipamentos eletroeletrônicos de uso pessoal e doméstico",
    "class_description": "Reparação e manutenção de equipamentos eletroeletrônicos de uso pessoal e doméstico"
  },
  "9529101": {
    "description": "Reparação de calçados, bolsas e artigos de viagem",
    "class_description": "Reparação e manutenção de objetos e equipamentos pessoais e domésticos não especificados anteriormente"
  },
  "9529102": {
    "description": "Chaveiros",
    "class_description": "Reparação e manutenção de objetos e equipamentos pessoais e domésticos não especificados anteriormente"
  },
  "9529103": {
    "description": "Reparação de relógios",
    "class_description": "Reparação e manutenção de objetos e equipamentos pessoais e domésticos não especificados anteriormente"
  },
  "9529104": {
    "description": "Reparação de bicicletas, triciclos e outros veículos não motorizados",
    "class_description": "Reparação e manutenção de objetos e equipamentos pessoais e domésticos não especificados anteriormente"
  },
  "9529105": {
    "description": "Reparação de artigos do mobiliário",
    "class_description": "Reparação e manutenção de objetos e equipamentos pessoais e domésticos não especificados anteriormente"
  },
  "9529106": {
    "description": "Reparação de jóias",
    "class_description": "Reparação e manutenção de objetos e equipamentos pessoais e domésticos não especificados anteriormente"
  },
  "9529199": {
    "description": "Reparação e manutenção de outros objetos e equipamentos pessoais e domésticos não especificados anteriormente",
    "class_description": "Reparação e manutenção de objetos e equipamentos pessoais e domésticos não especificados anteriormente"
  },
  "9601701": {
    "description": "Lavanderias",
    "class_description": "Lavanderias, tinturarias e toalheiros"
  },
  "9601702": {
    "description": "Tinturarias",
    "class_description": "Lavanderias, tinturarias e toalheiros"
  },
  "9601703": {
    "description": "Toalheiros",
    "class_description": "Lavanderias, tinturarias e toalheiros"
  },
  "9602501": {
    "description": "Cabeleireiros, manicure e pedicure",
    "class_description": "Cabeleireiros e outras atividades de tratamento de beleza"
  },
  "9602502": {
    "description": "Atividades de estética e outros serviços de cuidados com a beleza",
    "class_description": "Cabeleireiros e outras atividades de tratamento de beleza"
  },
  "9603301": {
    "description": "Gestão e manutenção de cemitérios",
    "class_description": "Atividades funerárias e serviços relacionados"
  },
  "9603302": {
    "description": "Serviços de cremação",
    "class_description": "Atividades funerárias e serviços relacionados"
  },
  "9603303": {
    "description": "Serviços de sepultamento",
    "class_description": "Atividades funerárias e serviços relacionados"
  },
  "9603304": {
    "description": "Serviços de funerárias",
    "class_description": "Atividades funerárias e serviços relacionados"
  },
  "9603305": {
    "description": "Serviços de somatoconservação",
    "class_description": "Atividades funerárias e serviços relacionados"
  },
  "9603399": {
    "description": "Atividades funerárias e serviços relacionados não especificados anteriormente",
    "class_description": "Atividades funerárias e serviços relacionados"
  },
  "9609202": {
    "description": "Agências matrimoniais",
    "class_description": "Atividades de serviços pessoais não especificadas anteriormente"
  },
  "9609204": {
    "description": "Exploração de máquinas de serviços pessoais acionadas por moeda",
    "class_description": "Atividades de serviços pessoais não especificadas anteriormente"
  },
  "9609205": {
    "description": "Atividades de sauna e banhos",
    "class_description": "Atividades de serviços pessoais não especificadas anteriormente"
  },
  "9609206": {
    "description": "Serviços de tatuagem e colocação de piercing",
    "class_description": "Atividades de serviços pessoais não especificadas anteriormente"
  },
  "9609207": {
    "description": "Alojamento de animais domésticos",
    "class_description": "Atividades de serviços pessoais não especificadas anteriormente"
  },
  "9609208": {
    "description": "Higiene e embelezamento de animais domésticos",
    "class_description": "Atividades de serviços pessoais não especificadas anteriormente"
  },
  "9609299": {
    "description": "Outras atividades de serviços pessoais não especificadas anteriormente",
    "class_description": "Atividades de serviços pessoais não especificadas anteriormente"
  },
  "9700500": {
    "description": "Serviços domésticos",
    "class_description": "Serviços domésticos"
  },
  "9900800": {
    "description": "Organismos internacionais e outras instituições extraterritoriais",
    "class_description": "Organismos internacionais e outras instituições extraterritoriais"
  }
}
